// This file is auto-generated by @hey-api/openapi-ts

import { type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError } from 'axios'

import { client } from '../client.gen'
import {
    deleteAdminBillingCreditCostsId,
    deleteAdminBillingPlansId,
    deleteAssessmentParamsId,
    deleteAssessmentTemplatesId,
    deleteCandidatesId,
    deleteCompanyCompanySlugApprovalFlowRuleId,
    deleteCompanyCompanySlugCandidateStatusesConfigStatusId,
    deleteCompanyCompanySlugDepartments,
    deleteCustomAnalyticsDashboard,
    deleteCustomAnalyticsId,
    deleteHiringManagersId,
    deleteInterviewsId,
    deleteInterviewsIdInterviewRoundInterviewRoundId,
    deleteInterviewsIdInterviewRoundInterviewRoundIdPanellist,
    deleteInterviewsScreeningCall,
    deleteInterviewsScreeningInterviewClientTokenId,
    deleteInterviewsScreeningInterviewIdentityCheckId,
    deleteInterviewsScreeningInterviewSpeechTokenId,
    deleteJdId,
    deleteJobApplicationsId,
    deleteJobsId,
    deleteJobsIdSourcedCandidatesSourcedCandidateId,
    deleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteId,
    deleteMarleeSessionSessionId,
    deleteNotesId,
    deleteNotificationsId,
    deleteSettingsCommunicationTemplatesId,
    getAdminBillingCreditCosts,
    getAdminBillingCreditCostsExport,
    getAdminBillingCreditCostsId,
    getAdminBillingPlans,
    getAdminBillingPlansExport,
    getAdminBillingPlansId,
    getAdminBillingSignupDrafts,
    getAdminCompanies,
    getAdminCompaniesId,
    getAdminCompaniesIdAccessControl,
    getAdminCompaniesIdCredits,
    getAdminCompaniesIdCreditsLedger,
    getAdminCompaniesIdIntegrations,
    getAdminIntalentUsers,
    getAdminInterviewQualityReports,
    getAdminInterviewQualityReportsId,
    getAdminInterviewQualityRuns,
    getApplicationsSearch,
    getAssessmentParams,
    getAssessmentParamsId,
    getAssessmentTemplates,
    getAssessmentTemplatesId,
    getAuthLogoutCallback,
    getAuthMyCompanies,
    getAuthProfile,
    getAuthSwitchCompany,
    getBillingPlans,
    getBillingSubscription,
    getBillingUsage,
    getCandidates,
    getCandidateSharingSharingSlug,
    getCandidatesId,
    getChatbotConfig,
    getCommunicationStatusEmailClientId,
    getCompany,
    getCompanyCompanySlugAccessControlConfig,
    getCompanyCompanySlugApprovalFlow,
    getCompanyCompanySlugCandidateStatusesConfig,
    getCompanyCompanySlugDepartments,
    getCompanyCompanySlugIntegrations,
    getCompanyCompanySlugJdTemplate,
    getCompanyCompanySlugJobPostingConfig,
    getCompanyCompanySlugPanellists,
    getCompanyCompanySlugScreeningWebrtcConfig,
    getCompanyCompanySlugUsers,
    getCompanyConfig,
    getCompanyDepartments,
    getCompanyEmploymentTypes,
    getCompanySlugJobsJobPostingIdTalentPoolInvites,
    getCompanySlugPublicCareerConfig,
    getCompanySlugPublicCareerDepartments,
    getCompanySlugPublicCareerJobs,
    getCompanySlugPublicCareerJobsId,
    getCompanySlugPublicCareerJobsIdUploadUrl,
    getCompanySlugPublicCareerTalentPoolUploadUrl,
    getCronAiInterviewReminders,
    getCronFeedbackReminders,
    getCronRenewCalendarSubscriptions,
    getCronScreeningWebrtcLifecycleSweeper,
    getCustomAnalytics,
    getEmbeddings,
    getHiringManagers,
    getIntegrationsGoogleAuthorize,
    getIntegrationsGoogleCallback,
    getIntegrationsMicrosoftAuthorize,
    getIntegrationsMicrosoftCallback,
    getInternalSttToken,
    getInterviews,
    getInterviewsFeedback,
    getInterviewsFeedbackTranscript,
    getInterviewsId,
    getInterviewsScreeningCallIdRecording,
    getInterviewsScreeningInterview,
    getInterviewsScreeningInterviewCandidate,
    getInterviewsScreeningInterviewClientToken,
    getInterviewsScreeningInterviewIceServers,
    getInterviewsScreeningInterviewIdentityCheckId,
    getInterviewsScreeningInterviewProctoring,
    getInterviewsScreeningInterviewRemind,
    getInterviewsScreeningInterviewSpeechToken,
    getInterviewsScreeningWebrtcBootstrap,
    getInterviewsScreeningWebrtcNetworkProbe,
    getInterviewsScreeningWebrtcOutput,
    getJd,
    getJdAgentConversation,
    getJdAgentSpeechToken,
    getJdExtractText,
    getJdId,
    getJdIdLinkedJobs,
    getJobApplications,
    getJobApplicationsId,
    getJobApplicationsIdApplicantHistory,
    getJobApplicationsProcessing,
    getJobApplicationsStatus,
    getJobApprovers,
    getJobApproversApprove,
    getJobs,
    getJobsId,
    getJobsIdActivity,
    getJobsIdCandidateMatching,
    getJobsIdLocations,
    getJobsIdShortlistRuleAffectedCandidates,
    getJobsIdSourcedCandidates,
    getJobsIdSourcedCandidatesSourcedCandidateIdNotes,
    getJobsSearch,
    getMetrics,
    getMetricsStatusChange,
    getNotes,
    getNotesByEmail,
    getNotifications,
    getOffers,
    getOffersApprove,
    getOffersUploadDocumentsId,
    getOgApply,
    getOgCompany,
    getOgDefault,
    getOnboardingPlans,
    getOnboardingStatus,
    getOnboardingVerifyStatus,
    getRecordingsRecordingId,
    getRekognitionGetResultsSessionId,
    getReportsConfigCompanyId,
    getReportsTaTracker,
    getSettingsCommunicationTemplates,
    getSettingsCommunicationTemplatesId,
    getSourcingJobs,
    getSseTest,
    getSseV2,
    getStorageAccess,
    getStorageUpload,
    getTemporalCheatDetectionConfig,
    getTemporalCompaniesIdAgentMemoryFlags,
    getTemporalHiQuestions,
    getTemporalIntegrations,
    getTemporalInterviewQualityCheck,
    getTemporalInterviewQualityContext,
    getTemporalJobApplicationsId,
    getTemporalJobApplicationsStatus,
    getTemporalJobsId,
    getTemporalScreeningCall,
    getTemporalScreeningInterview,
    getUserData,
    getWebhooksAzureEmail,
    getWebhooksGraph,
    getWebhooksGraphTranscript,
    getWebhooksPlivoVoice,
    getWebhooksPlivoWhatsapp,
    getWebhooksTwilioWhatsapp,
    getWellKnownScreeningJwks,
    getWhatsapp,
    getWhatsappCompanySlug,
    type Options,
    patchAdminBillingPlansId,
    patchAdminCompaniesIdArchive,
    patchAdminCompaniesIdBilling,
    patchAdminCompaniesIdFeatureFlags,
    patchAdminCompaniesIdIntegrations,
    patchAdminCompaniesIdOrgConfig,
    patchAdminInterviewQualityIssuesId,
    patchCalendarGenerateTranscript,
    patchCompanyCompanySlugApprovalFlow,
    patchCompanyCompanySlugApprovalFlowRuleId,
    patchCompanyCompanySlugCandidateStatusesConfigStatusId,
    patchCompanyCompanySlugDepartments,
    patchCompanyCompanySlugIntegrations,
    patchCompanyCompanySlugScreeningWebrtcConfig,
    patchCompanyCompanySlugUsersUserId,
    patchCronCandidates,
    patchCustomAnalyticsDashboard,
    patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary,
    patchJdId,
    patchJobApplications,
    patchJobApplicationsStatus,
    patchJobOpeningsId,
    patchJobsIdSourcedCandidatesSourcedCandidateId,
    patchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteId,
    patchJobsIdStatus,
    patchOnboardingOrg,
    postAdminBillingCreditCosts,
    postAdminBillingCreditCostsImport,
    postAdminBillingPlans,
    postAdminBillingPlansIdSync,
    postAdminBillingPlansImport,
    postAdminCompanies,
    postAdminCompaniesIdCredits,
    postAdminCompaniesIdIntegrations,
    postAdminCompaniesIdIntegrationsIntegrationIdReencrypt,
    postAdminCompaniesIdLinkIntalentUser,
    postAdminInterviewQualityResolve,
    postAdminInterviewQualityRuns,
    postAdminOrganizations,
    postAdminOrganizationsUploadLogo,
    postAnalyticsAgent,
    postAnalyticsAgentStream,
    postAssessmentParams,
    postAssessmentParamsIdCopy,
    postAssessmentTemplates,
    postAuthSetCompany,
    postBillingChangePlan,
    postBillingCompleteCheckout,
    postBillingCreditPacks,
    postBillingPortal,
    postCalendar,
    postCalendarAvailability,
    postCalendarGenerateTranscript,
    postCalendarPanelistSlots,
    postCalendarPanelistSlotsComments,
    postCalendarPanelistSlotsGenerate,
    postCalendarSchedulingSlots,
    postCandidates,
    postCandidatesBulkDelete,
    postCandidatesParseQuery,
    postCompanyCompanySlugApprovalFlow,
    postCompanyCompanySlugCandidateStatusesConfig,
    postCompanyCompanySlugDepartments,
    postCompanyCompanySlugIntegrationsDisconnect,
    postCompanyCompanySlugIntegrationsLinkedinVerify,
    postCompanyCompanySlugIntegrationsTest,
    postCompanyCompanySlugLogo,
    postCompanyCompanySlugUsers,
    postCompanyCompanySlugUsersDisable,
    postCompanyCompanySlugUsersEnable,
    postCompanyCompanySlugUsersUserIdResetPassword,
    postCompanyConfig,
    postCompanyGrade,
    postCompanySlugCandidateSharingCreate,
    postCompanySlugJobsJobPostingIdTalentPoolInvites,
    postCompanySlugPublicCareerJobsIdApplications,
    postCompanySlugPublicCareerTalentPoolApplications,
    postCompanyTitleGrade,
    postCronAiInterviewReminders,
    postCronAnalyticsRefresh,
    postCronBillingCapacityRebill,
    postCronFeedbackReminders,
    postCronJobApplicationProcessing,
    postCronRenewCalendarSubscriptions,
    postCronScreeningWebrtcLifecycleSweeper,
    postCustomAnalytics,
    postCustomAnalyticsAssignDashboard,
    postCustomAnalyticsDashboard,
    postCustomAnalyticsOrder,
    postCustomAnalyticsPaginate,
    postCustomAnalyticsPreview,
    postCustomAnalyticsRemoveDashboard,
    postEmbeddings,
    postGenerateQuestions,
    postHiringManagers,
    postInsightsBenettonApplicantsReport,
    postInsightsCandidatesByRolesReport,
    postInsightsCandidatesByStatusReport,
    postInsightsCustomCharts,
    postInsightsMonthlyDashboard,
    postInsightsOfferJoinedReport,
    postInsightsOpenPositionsReport,
    postInsightsPositionsClosedReport,
    postInsightsPositionsCreatedReport,
    postInsightsPredefinedGraphs,
    postInsightsPredefinedGraphsSave,
    postInternalAnalyticsQuery,
    postInternalStt,
    postInterviews,
    postInterviewsFeedbackGenerate,
    postInterviewsHumanInterviewQuestions,
    postInterviewsHumanInterviewQuestionsTrigger,
    postInterviewsIdInterviewRound,
    postInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary,
    postInterviewsIdInterviewRoundInterviewRoundIdRatings,
    postInterviewsScreeningCall,
    postInterviewsScreeningCallBulk,
    postInterviewsScreeningCallEndInterview,
    postInterviewsScreeningCallIdRecordingFetch,
    postInterviewsScreeningCallLifecycle,
    postInterviewsScreeningInterview,
    postInterviewsScreeningInterviewClientToken,
    postInterviewsScreeningInterviewDailyRecording,
    postInterviewsScreeningInterviewEndInterview,
    postInterviewsScreeningInterviewEvents,
    postInterviewsScreeningInterviewFastrtcRecording,
    postInterviewsScreeningInterviewFetchDailyRecording,
    postInterviewsScreeningInterviewFixLivenessStatus,
    postInterviewsScreeningInterviewProctoring,
    postInterviewsScreeningInterviewStart,
    postInterviewsScreeningInterviewTransitionToStarted,
    postInterviewsScreeningInterviewTtsEnsure,
    postInterviewsScreeningWebrtcAbandon,
    postInterviewsScreeningWebrtcLifecycle,
    postInterviewsScreeningWebrtcOffer,
    postInterviewsScreeningWebrtcRecordingChunk,
    postInterviewsScreeningWebrtcRecordingFinalize,
    postInterviewsScreeningWebrtcRecordingInit,
    postInterviewsScreeningWebrtcRecordingPartUrl,
    postInterviewsScreeningWebrtcSession,
    postInterviewsScreeningWebrtcSessionLogAppend,
    postInterviewsScreeningWebrtcSessionLogFinalize,
    postInterviewsScreeningWebrtcSessionSessionIdConnect,
    postInterviewsScreeningWebrtcToken,
    postJd,
    postJdAgentBackend,
    postJdAgentBackendStream,
    postJdAgentConversationSync,
    postJdExtractText,
    postJobApplications,
    postJobApplicationsBulkDelete,
    postJobApplicationsBulkReprocess,
    postJobApplicationsId,
    postJobApplicationsIdReprocess,
    postJobApprovers,
    postJobApproversBypassId,
    postJobApproversReminderId,
    postJobs,
    postJobsBulkDelete,
    postJobsIdSourcedCandidatesSourcedCandidateIdInviteDrafts,
    postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmails,
    postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreview,
    postJobsIdSourcedCandidatesSourcedCandidateIdMove,
    postJobsIdSourcedCandidatesSourcedCandidateIdNotes,
    postMailboxMonitoring,
    postMailboxMonitoringProcess,
    postMarleeCommand,
    postMarleeSession,
    postNaukriJob,
    postNotes,
    postOffers,
    postOffersRemind,
    postOffersRequestDocuments,
    postOffersSend,
    postOffersSendForApproval,
    postOffersUploadDocumentsId,
    postOnboardingCompleteCheckout,
    postOnboardingCompleteSignup,
    postOnboardingSelectPlan,
    postOnboardingSignup,
    postOnboardingUploadLogo,
    postOnboardingVerifyCode,
    postOnboardingVerifyStatus,
    postPermissions,
    postReachOut,
    postReachOutSlotBooking,
    postRekognitionCreateSession,
    postReportsConfigCompanyId,
    postReportsExecute,
    postScreeningReportPdf,
    postSendEmail,
    postSettingsCommunicationTemplates,
    postSettingsCommunicationTemplatesActivateDefault,
    postSettingsCommunicationTemplatesPreview,
    postSourcingExtract,
    postSourcingSourcedCandidates,
    postTemporalCandidate,
    postTemporalCommunicationStatus,
    postTemporalInterviewQualityReport,
    postTemporalInterviewQualityRunsRunIdStatus,
    postTemporalScreeningCallObjectiveEvaluations,
    postTemporalWorkshorts,
    postWebhooksAzureEmail,
    postWebhooksDaily,
    postWebhooksGraph,
    postWebhooksGraphTranscript,
    postWebhooksPlivoRecording,
    postWebhooksPlivoVoice,
    postWebhooksPlivoWhatsapp,
    postWebhooksResendEmail,
    postWebhooksStripe,
    postWebhooksTwilioRecording,
    postWebhooksTwilioVoice,
    postWebhooksTwilioWhatsapp,
    postWhatsapp,
    postWhatsappCompanySlug,
    putAdminBillingCreditCostsId,
    putAdminCompaniesId,
    putAdminCompaniesIdAccessControl,
    putAssessmentParamsId,
    putAssessmentTemplatesId,
    putAuthProfile,
    putCalendar,
    putCandidateSharingSharingSlugFeedback,
    putCandidatesId,
    putCompanyCompanySlugAccessControlConfig,
    putCompanyCompanySlugCandidateStatusesConfig,
    putCompanyCompanySlugJdTemplate,
    putCompanyCompanySlugJobPostingConfig,
    putCompanyConfig,
    putGenerateQuestionsId,
    putHiringManagersId,
    putInterviewsFeedback,
    putInterviewsId,
    putInterviewsIdInterviewRound,
    putInterviewsIdInterviewRoundInterviewRoundId,
    putInterviewsScreeningCall,
    putInterviewsScreeningInterview,
    putInterviewsScreeningWebrtcNetworkProbe,
    putJobApplicationsApprove,
    putJobApplicationsId,
    putJobApproversApprove,
    putJobsId,
    putNotesId,
    putNotifications,
    putOffers,
    putOffersAccept,
    putOffersApprove,
    putOffersDocuments,
    putOffersUploadDocumentsId,
    putSettingsCommunicationTemplatesId,
    putTemporalJobApplicationsId,
    putTemporalScreeningCall,
} from '../sdk.gen'
import type {
    DeleteAdminBillingCreditCostsIdData,
    DeleteAdminBillingCreditCostsIdError,
    DeleteAdminBillingCreditCostsIdResponse,
    DeleteAdminBillingPlansIdData,
    DeleteAdminBillingPlansIdError,
    DeleteAdminBillingPlansIdResponse,
    DeleteAssessmentParamsIdData,
    DeleteAssessmentParamsIdError,
    DeleteAssessmentParamsIdResponse,
    DeleteAssessmentTemplatesIdData,
    DeleteAssessmentTemplatesIdError,
    DeleteAssessmentTemplatesIdResponse,
    DeleteCandidatesIdData,
    DeleteCandidatesIdError,
    DeleteCompanyCompanySlugApprovalFlowRuleIdData,
    DeleteCompanyCompanySlugApprovalFlowRuleIdError,
    DeleteCompanyCompanySlugApprovalFlowRuleIdResponse,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdError,
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
    DeleteCompanyCompanySlugDepartmentsData,
    DeleteCompanyCompanySlugDepartmentsError,
    DeleteCompanyCompanySlugDepartmentsResponse,
    DeleteCustomAnalyticsDashboardData,
    DeleteCustomAnalyticsDashboardError,
    DeleteCustomAnalyticsIdData,
    DeleteCustomAnalyticsIdError,
    DeleteCustomAnalyticsIdResponse,
    DeleteHiringManagersIdData,
    DeleteHiringManagersIdError,
    DeleteInterviewsIdData,
    DeleteInterviewsIdError,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdData,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdError,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistError,
    DeleteInterviewsIdInterviewRoundInterviewRoundIdResponse,
    DeleteInterviewsIdResponse,
    DeleteInterviewsScreeningCallData,
    DeleteInterviewsScreeningCallError,
    DeleteInterviewsScreeningInterviewClientTokenIdData,
    DeleteInterviewsScreeningInterviewClientTokenIdError,
    DeleteInterviewsScreeningInterviewClientTokenIdResponse,
    DeleteInterviewsScreeningInterviewIdentityCheckIdData,
    DeleteInterviewsScreeningInterviewIdentityCheckIdError,
    DeleteInterviewsScreeningInterviewSpeechTokenIdData,
    DeleteInterviewsScreeningInterviewSpeechTokenIdError,
    DeleteInterviewsScreeningInterviewSpeechTokenIdResponse,
    DeleteJdIdData,
    DeleteJdIdError,
    DeleteJdIdResponse,
    DeleteJobApplicationsIdData,
    DeleteJobApplicationsIdError,
    DeleteJobApplicationsIdResponse,
    DeleteJobsIdData,
    DeleteJobsIdError,
    DeleteJobsIdResponse,
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdData,
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdError,
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData,
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError,
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdResponse,
    DeleteMarleeSessionSessionIdData,
    DeleteMarleeSessionSessionIdError,
    DeleteMarleeSessionSessionIdResponse,
    DeleteNotesIdData,
    DeleteNotesIdError,
    DeleteNotificationsIdData,
    DeleteNotificationsIdError,
    DeleteNotificationsIdResponse,
    DeleteSettingsCommunicationTemplatesIdData,
    DeleteSettingsCommunicationTemplatesIdError,
    DeleteSettingsCommunicationTemplatesIdResponse,
    GetAdminBillingCreditCostsData,
    GetAdminBillingCreditCostsError,
    GetAdminBillingCreditCostsExportData,
    GetAdminBillingCreditCostsExportError,
    GetAdminBillingCreditCostsExportResponse,
    GetAdminBillingCreditCostsIdData,
    GetAdminBillingCreditCostsIdError,
    GetAdminBillingCreditCostsIdResponse,
    GetAdminBillingCreditCostsResponse,
    GetAdminBillingPlansData,
    GetAdminBillingPlansError,
    GetAdminBillingPlansExportData,
    GetAdminBillingPlansExportError,
    GetAdminBillingPlansExportResponse,
    GetAdminBillingPlansIdData,
    GetAdminBillingPlansIdError,
    GetAdminBillingPlansIdResponse,
    GetAdminBillingPlansResponse,
    GetAdminBillingSignupDraftsData,
    GetAdminBillingSignupDraftsError,
    GetAdminBillingSignupDraftsResponse,
    GetAdminCompaniesData,
    GetAdminCompaniesError,
    GetAdminCompaniesIdAccessControlData,
    GetAdminCompaniesIdAccessControlError,
    GetAdminCompaniesIdAccessControlResponse,
    GetAdminCompaniesIdCreditsData,
    GetAdminCompaniesIdCreditsError,
    GetAdminCompaniesIdCreditsLedgerData,
    GetAdminCompaniesIdCreditsLedgerError,
    GetAdminCompaniesIdCreditsLedgerResponse,
    GetAdminCompaniesIdCreditsResponse,
    GetAdminCompaniesIdData,
    GetAdminCompaniesIdError,
    GetAdminCompaniesIdIntegrationsData,
    GetAdminCompaniesIdIntegrationsError,
    GetAdminCompaniesIdIntegrationsResponse,
    GetAdminCompaniesIdResponse,
    GetAdminCompaniesResponse,
    GetAdminIntalentUsersData,
    GetAdminIntalentUsersError,
    GetAdminIntalentUsersResponse,
    GetAdminInterviewQualityReportsData,
    GetAdminInterviewQualityReportsError,
    GetAdminInterviewQualityReportsIdData,
    GetAdminInterviewQualityReportsIdError,
    GetAdminInterviewQualityReportsIdResponse,
    GetAdminInterviewQualityReportsResponse,
    GetAdminInterviewQualityRunsData,
    GetAdminInterviewQualityRunsError,
    GetAdminInterviewQualityRunsResponse,
    GetApplicationsSearchData,
    GetApplicationsSearchError,
    GetApplicationsSearchResponse,
    GetAssessmentParamsData,
    GetAssessmentParamsError,
    GetAssessmentParamsIdData,
    GetAssessmentParamsIdError,
    GetAssessmentParamsIdResponse,
    GetAssessmentParamsResponse,
    GetAssessmentTemplatesData,
    GetAssessmentTemplatesError,
    GetAssessmentTemplatesIdData,
    GetAssessmentTemplatesIdError,
    GetAssessmentTemplatesIdResponse,
    GetAssessmentTemplatesResponse,
    GetAuthLogoutCallbackData,
    GetAuthLogoutCallbackError,
    GetAuthMyCompaniesData,
    GetAuthMyCompaniesError,
    GetAuthMyCompaniesResponse,
    GetAuthProfileData,
    GetAuthProfileError,
    GetAuthProfileResponse,
    GetAuthSwitchCompanyData,
    GetAuthSwitchCompanyError,
    GetBillingPlansData,
    GetBillingPlansError,
    GetBillingPlansResponse,
    GetBillingSubscriptionData,
    GetBillingSubscriptionError,
    GetBillingSubscriptionResponse,
    GetBillingUsageData,
    GetBillingUsageError,
    GetBillingUsageResponse,
    GetCandidatesData,
    GetCandidatesError,
    GetCandidateSharingSharingSlugData,
    GetCandidateSharingSharingSlugError,
    GetCandidatesIdData,
    GetCandidatesIdError,
    GetCandidatesResponse,
    GetChatbotConfigData,
    GetChatbotConfigError,
    GetChatbotConfigResponse,
    GetCommunicationStatusEmailClientIdData,
    GetCommunicationStatusEmailClientIdError,
    GetCompanyCompanySlugAccessControlConfigData,
    GetCompanyCompanySlugAccessControlConfigError,
    GetCompanyCompanySlugAccessControlConfigResponse,
    GetCompanyCompanySlugApprovalFlowData,
    GetCompanyCompanySlugApprovalFlowError,
    GetCompanyCompanySlugApprovalFlowResponse,
    GetCompanyCompanySlugCandidateStatusesConfigData,
    GetCompanyCompanySlugCandidateStatusesConfigError,
    GetCompanyCompanySlugCandidateStatusesConfigResponse,
    GetCompanyCompanySlugDepartmentsData,
    GetCompanyCompanySlugDepartmentsError,
    GetCompanyCompanySlugDepartmentsResponse,
    GetCompanyCompanySlugIntegrationsData,
    GetCompanyCompanySlugIntegrationsError,
    GetCompanyCompanySlugIntegrationsResponse,
    GetCompanyCompanySlugJdTemplateData,
    GetCompanyCompanySlugJdTemplateError,
    GetCompanyCompanySlugJdTemplateResponse,
    GetCompanyCompanySlugJobPostingConfigData,
    GetCompanyCompanySlugJobPostingConfigError,
    GetCompanyCompanySlugJobPostingConfigResponse,
    GetCompanyCompanySlugPanellistsData,
    GetCompanyCompanySlugPanellistsError,
    GetCompanyCompanySlugPanellistsResponse,
    GetCompanyCompanySlugScreeningWebrtcConfigData,
    GetCompanyCompanySlugScreeningWebrtcConfigError,
    GetCompanyCompanySlugScreeningWebrtcConfigResponse,
    GetCompanyCompanySlugUsersData,
    GetCompanyCompanySlugUsersError,
    GetCompanyCompanySlugUsersResponse,
    GetCompanyConfigData,
    GetCompanyConfigError,
    GetCompanyData,
    GetCompanyDepartmentsData,
    GetCompanyDepartmentsError,
    GetCompanyDepartmentsResponse,
    GetCompanyEmploymentTypesData,
    GetCompanyEmploymentTypesError,
    GetCompanyError,
    GetCompanySlugJobsJobPostingIdTalentPoolInvitesData,
    GetCompanySlugJobsJobPostingIdTalentPoolInvitesError,
    GetCompanySlugPublicCareerConfigData,
    GetCompanySlugPublicCareerConfigError,
    GetCompanySlugPublicCareerConfigResponse,
    GetCompanySlugPublicCareerDepartmentsData,
    GetCompanySlugPublicCareerDepartmentsError,
    GetCompanySlugPublicCareerDepartmentsResponse,
    GetCompanySlugPublicCareerJobsData,
    GetCompanySlugPublicCareerJobsError,
    GetCompanySlugPublicCareerJobsIdData,
    GetCompanySlugPublicCareerJobsIdError,
    GetCompanySlugPublicCareerJobsIdResponse,
    GetCompanySlugPublicCareerJobsIdUploadUrlData,
    GetCompanySlugPublicCareerJobsIdUploadUrlError,
    GetCompanySlugPublicCareerJobsIdUploadUrlResponse,
    GetCompanySlugPublicCareerJobsResponse,
    GetCompanySlugPublicCareerTalentPoolUploadUrlData,
    GetCompanySlugPublicCareerTalentPoolUploadUrlError,
    GetCompanySlugPublicCareerTalentPoolUploadUrlResponse,
    GetCronAiInterviewRemindersData,
    GetCronAiInterviewRemindersError,
    GetCronFeedbackRemindersData,
    GetCronFeedbackRemindersError,
    GetCronRenewCalendarSubscriptionsData,
    GetCronRenewCalendarSubscriptionsError,
    GetCronScreeningWebrtcLifecycleSweeperData,
    GetCronScreeningWebrtcLifecycleSweeperError,
    GetCustomAnalyticsData,
    GetCustomAnalyticsError,
    GetEmbeddingsData,
    GetEmbeddingsError,
    GetEmbeddingsResponse,
    GetHiringManagersData,
    GetHiringManagersError,
    GetIntegrationsGoogleAuthorizeData,
    GetIntegrationsGoogleAuthorizeError,
    GetIntegrationsGoogleCallbackData,
    GetIntegrationsGoogleCallbackError,
    GetIntegrationsMicrosoftAuthorizeData,
    GetIntegrationsMicrosoftAuthorizeError,
    GetIntegrationsMicrosoftCallbackData,
    GetIntegrationsMicrosoftCallbackError,
    GetInternalSttTokenData,
    GetInternalSttTokenError,
    GetInternalSttTokenResponse,
    GetInterviewsData,
    GetInterviewsError,
    GetInterviewsFeedbackData,
    GetInterviewsFeedbackError,
    GetInterviewsFeedbackTranscriptData,
    GetInterviewsFeedbackTranscriptError,
    GetInterviewsIdData,
    GetInterviewsIdError,
    GetInterviewsIdResponse,
    GetInterviewsResponse,
    GetInterviewsScreeningCallIdRecordingData,
    GetInterviewsScreeningCallIdRecordingError,
    GetInterviewsScreeningCallIdRecordingResponse,
    GetInterviewsScreeningInterviewCandidateData,
    GetInterviewsScreeningInterviewCandidateError,
    GetInterviewsScreeningInterviewClientTokenData,
    GetInterviewsScreeningInterviewClientTokenError,
    GetInterviewsScreeningInterviewClientTokenResponse,
    GetInterviewsScreeningInterviewData,
    GetInterviewsScreeningInterviewError,
    GetInterviewsScreeningInterviewIceServersData,
    GetInterviewsScreeningInterviewIceServersError,
    GetInterviewsScreeningInterviewIceServersResponse,
    GetInterviewsScreeningInterviewIdentityCheckIdData,
    GetInterviewsScreeningInterviewIdentityCheckIdError,
    GetInterviewsScreeningInterviewProctoringData,
    GetInterviewsScreeningInterviewProctoringError,
    GetInterviewsScreeningInterviewProctoringResponse,
    GetInterviewsScreeningInterviewRemindData,
    GetInterviewsScreeningInterviewRemindError,
    GetInterviewsScreeningInterviewRemindResponse,
    GetInterviewsScreeningInterviewSpeechTokenData,
    GetInterviewsScreeningInterviewSpeechTokenError,
    GetInterviewsScreeningInterviewSpeechTokenResponse,
    GetInterviewsScreeningWebrtcBootstrapData,
    GetInterviewsScreeningWebrtcBootstrapError,
    GetInterviewsScreeningWebrtcBootstrapResponse,
    GetInterviewsScreeningWebrtcNetworkProbeData,
    GetInterviewsScreeningWebrtcNetworkProbeError,
    GetInterviewsScreeningWebrtcOutputData,
    GetInterviewsScreeningWebrtcOutputError,
    GetInterviewsScreeningWebrtcOutputResponse,
    GetJdAgentConversationData,
    GetJdAgentConversationError,
    GetJdAgentConversationResponse,
    GetJdAgentSpeechTokenData,
    GetJdAgentSpeechTokenError,
    GetJdAgentSpeechTokenResponse,
    GetJdData,
    GetJdError,
    GetJdExtractTextData,
    GetJdExtractTextError,
    GetJdExtractTextResponse,
    GetJdIdData,
    GetJdIdError,
    GetJdIdLinkedJobsData,
    GetJdIdLinkedJobsError,
    GetJdIdLinkedJobsResponse,
    GetJdIdResponse,
    GetJdResponse,
    GetJobApplicationsData,
    GetJobApplicationsError,
    GetJobApplicationsIdApplicantHistoryData,
    GetJobApplicationsIdApplicantHistoryError,
    GetJobApplicationsIdApplicantHistoryResponse,
    GetJobApplicationsIdData,
    GetJobApplicationsIdError,
    GetJobApplicationsIdResponse,
    GetJobApplicationsProcessingData,
    GetJobApplicationsProcessingError,
    GetJobApplicationsProcessingResponse,
    GetJobApplicationsResponse,
    GetJobApplicationsStatusData,
    GetJobApplicationsStatusError,
    GetJobApplicationsStatusResponse,
    GetJobApproversApproveData,
    GetJobApproversApproveError,
    GetJobApproversApproveResponse,
    GetJobApproversData,
    GetJobApproversError,
    GetJobApproversResponse,
    GetJobsData,
    GetJobsError,
    GetJobsIdActivityData,
    GetJobsIdActivityError,
    GetJobsIdActivityResponse,
    GetJobsIdCandidateMatchingData,
    GetJobsIdCandidateMatchingError,
    GetJobsIdCandidateMatchingResponse,
    GetJobsIdData,
    GetJobsIdError,
    GetJobsIdLocationsData,
    GetJobsIdLocationsError,
    GetJobsIdLocationsResponse,
    GetJobsIdShortlistRuleAffectedCandidatesData,
    GetJobsIdShortlistRuleAffectedCandidatesError,
    GetJobsIdShortlistRuleAffectedCandidatesResponse,
    GetJobsIdSourcedCandidatesData,
    GetJobsIdSourcedCandidatesError,
    GetJobsIdSourcedCandidatesResponse,
    GetJobsIdSourcedCandidatesSourcedCandidateIdNotesData,
    GetJobsIdSourcedCandidatesSourcedCandidateIdNotesError,
    GetJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
    GetJobsResponse,
    GetJobsSearchData,
    GetJobsSearchError,
    GetJobsSearchResponse,
    GetMetricsData,
    GetMetricsError,
    GetMetricsResponse,
    GetMetricsStatusChangeData,
    GetMetricsStatusChangeError,
    GetNotesByEmailData,
    GetNotesByEmailError,
    GetNotesData,
    GetNotesError,
    GetNotificationsData,
    GetNotificationsError,
    GetNotificationsResponse,
    GetOffersApproveData,
    GetOffersApproveError,
    GetOffersApproveResponse,
    GetOffersData,
    GetOffersError,
    GetOffersResponse,
    GetOffersUploadDocumentsIdData,
    GetOffersUploadDocumentsIdError,
    GetOffersUploadDocumentsIdResponse,
    GetOgApplyData,
    GetOgApplyError,
    GetOgCompanyData,
    GetOgCompanyError,
    GetOgDefaultData,
    GetOgDefaultError,
    GetOnboardingPlansData,
    GetOnboardingPlansError,
    GetOnboardingPlansResponse,
    GetOnboardingStatusData,
    GetOnboardingStatusError,
    GetOnboardingStatusResponse,
    GetOnboardingVerifyStatusData,
    GetOnboardingVerifyStatusError,
    GetOnboardingVerifyStatusResponse,
    GetRecordingsRecordingIdData,
    GetRecordingsRecordingIdError,
    GetRekognitionGetResultsSessionIdData,
    GetRekognitionGetResultsSessionIdError,
    GetReportsConfigCompanyIdData,
    GetReportsConfigCompanyIdError,
    GetReportsConfigCompanyIdResponse,
    GetReportsTaTrackerData,
    GetReportsTaTrackerError,
    GetSettingsCommunicationTemplatesData,
    GetSettingsCommunicationTemplatesError,
    GetSettingsCommunicationTemplatesIdData,
    GetSettingsCommunicationTemplatesIdError,
    GetSettingsCommunicationTemplatesIdResponse,
    GetSettingsCommunicationTemplatesResponse,
    GetSourcingJobsData,
    GetSourcingJobsError,
    GetSourcingJobsResponse,
    GetSseTestData,
    GetSseTestError,
    GetSseTestResponse,
    GetSseV2Data,
    GetSseV2Error,
    GetStorageAccessData,
    GetStorageAccessError,
    GetStorageAccessResponse,
    GetStorageUploadData,
    GetStorageUploadError,
    GetStorageUploadResponse,
    GetTemporalCheatDetectionConfigData,
    GetTemporalCheatDetectionConfigError,
    GetTemporalCompaniesIdAgentMemoryFlagsData,
    GetTemporalCompaniesIdAgentMemoryFlagsError,
    GetTemporalCompaniesIdAgentMemoryFlagsResponse,
    GetTemporalHiQuestionsData,
    GetTemporalHiQuestionsError,
    GetTemporalHiQuestionsResponse,
    GetTemporalIntegrationsData,
    GetTemporalIntegrationsError,
    GetTemporalIntegrationsResponse,
    GetTemporalInterviewQualityCheckData,
    GetTemporalInterviewQualityCheckError,
    GetTemporalInterviewQualityCheckResponse,
    GetTemporalInterviewQualityContextData,
    GetTemporalInterviewQualityContextError,
    GetTemporalInterviewQualityContextResponse,
    GetTemporalJobApplicationsIdData,
    GetTemporalJobApplicationsIdError,
    GetTemporalJobApplicationsIdResponse,
    GetTemporalJobApplicationsStatusData,
    GetTemporalJobApplicationsStatusError,
    GetTemporalJobApplicationsStatusResponse,
    GetTemporalJobsIdData,
    GetTemporalJobsIdError,
    GetTemporalJobsIdResponse,
    GetTemporalScreeningCallData,
    GetTemporalScreeningCallError,
    GetTemporalScreeningCallResponse,
    GetTemporalScreeningInterviewData,
    GetTemporalScreeningInterviewError,
    GetTemporalScreeningInterviewResponse,
    GetUserDataData,
    GetUserDataError,
    GetWebhooksAzureEmailData,
    GetWebhooksAzureEmailError,
    GetWebhooksGraphData,
    GetWebhooksGraphError,
    GetWebhooksGraphResponse,
    GetWebhooksGraphTranscriptData,
    GetWebhooksGraphTranscriptError,
    GetWebhooksGraphTranscriptResponse,
    GetWebhooksPlivoVoiceData,
    GetWebhooksPlivoVoiceError,
    GetWebhooksPlivoVoiceResponse,
    GetWebhooksPlivoWhatsappData,
    GetWebhooksPlivoWhatsappError,
    GetWebhooksTwilioWhatsappData,
    GetWebhooksTwilioWhatsappError,
    GetWellKnownScreeningJwksData,
    GetWellKnownScreeningJwksError,
    GetWellKnownScreeningJwksResponse,
    GetWhatsappCompanySlugData,
    GetWhatsappCompanySlugError,
    GetWhatsappData,
    GetWhatsappError,
    PatchAdminBillingPlansIdData,
    PatchAdminBillingPlansIdError,
    PatchAdminBillingPlansIdResponse,
    PatchAdminCompaniesIdArchiveData,
    PatchAdminCompaniesIdArchiveError,
    PatchAdminCompaniesIdArchiveResponse,
    PatchAdminCompaniesIdBillingData,
    PatchAdminCompaniesIdBillingError,
    PatchAdminCompaniesIdBillingResponse,
    PatchAdminCompaniesIdFeatureFlagsData,
    PatchAdminCompaniesIdFeatureFlagsError,
    PatchAdminCompaniesIdFeatureFlagsResponse,
    PatchAdminCompaniesIdIntegrationsData,
    PatchAdminCompaniesIdIntegrationsError,
    PatchAdminCompaniesIdIntegrationsResponse,
    PatchAdminCompaniesIdOrgConfigData,
    PatchAdminCompaniesIdOrgConfigError,
    PatchAdminCompaniesIdOrgConfigResponse,
    PatchAdminInterviewQualityIssuesIdData,
    PatchAdminInterviewQualityIssuesIdError,
    PatchAdminInterviewQualityIssuesIdResponse,
    PatchCalendarGenerateTranscriptData,
    PatchCalendarGenerateTranscriptError,
    PatchCompanyCompanySlugApprovalFlowData,
    PatchCompanyCompanySlugApprovalFlowError,
    PatchCompanyCompanySlugApprovalFlowResponse,
    PatchCompanyCompanySlugApprovalFlowRuleIdData,
    PatchCompanyCompanySlugApprovalFlowRuleIdError,
    PatchCompanyCompanySlugApprovalFlowRuleIdResponse,
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData,
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdError,
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
    PatchCompanyCompanySlugDepartmentsData,
    PatchCompanyCompanySlugDepartmentsError,
    PatchCompanyCompanySlugDepartmentsResponse,
    PatchCompanyCompanySlugIntegrationsData,
    PatchCompanyCompanySlugIntegrationsError,
    PatchCompanyCompanySlugIntegrationsResponse,
    PatchCompanyCompanySlugScreeningWebrtcConfigData,
    PatchCompanyCompanySlugScreeningWebrtcConfigError,
    PatchCompanyCompanySlugScreeningWebrtcConfigResponse,
    PatchCompanyCompanySlugUsersUserIdData,
    PatchCompanyCompanySlugUsersUserIdError,
    PatchCompanyCompanySlugUsersUserIdResponse,
    PatchCronCandidatesData,
    PatchCronCandidatesError,
    PatchCustomAnalyticsDashboardData,
    PatchCustomAnalyticsDashboardError,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError,
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponse,
    PatchJdIdData,
    PatchJdIdError,
    PatchJdIdResponse,
    PatchJobApplicationsData,
    PatchJobApplicationsError,
    PatchJobApplicationsResponse,
    PatchJobApplicationsStatusData,
    PatchJobApplicationsStatusError,
    PatchJobApplicationsStatusResponse,
    PatchJobOpeningsIdData,
    PatchJobOpeningsIdError,
    PatchJobsIdSourcedCandidatesSourcedCandidateIdData,
    PatchJobsIdSourcedCandidatesSourcedCandidateIdError,
    PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData,
    PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError,
    PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
    PatchJobsIdSourcedCandidatesSourcedCandidateIdResponse,
    PatchJobsIdStatusData,
    PatchJobsIdStatusError,
    PatchJobsIdStatusResponse,
    PatchOnboardingOrgData,
    PatchOnboardingOrgError,
    PatchOnboardingOrgResponse,
    PostAdminBillingCreditCostsData,
    PostAdminBillingCreditCostsError,
    PostAdminBillingCreditCostsImportData,
    PostAdminBillingCreditCostsImportError,
    PostAdminBillingCreditCostsImportResponse,
    PostAdminBillingCreditCostsResponse,
    PostAdminBillingPlansData,
    PostAdminBillingPlansError,
    PostAdminBillingPlansIdSyncData,
    PostAdminBillingPlansIdSyncError,
    PostAdminBillingPlansIdSyncResponse,
    PostAdminBillingPlansImportData,
    PostAdminBillingPlansImportError,
    PostAdminBillingPlansImportResponse,
    PostAdminBillingPlansResponse,
    PostAdminCompaniesData,
    PostAdminCompaniesError,
    PostAdminCompaniesIdCreditsData,
    PostAdminCompaniesIdCreditsError,
    PostAdminCompaniesIdCreditsResponse,
    PostAdminCompaniesIdIntegrationsData,
    PostAdminCompaniesIdIntegrationsError,
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData,
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptError,
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponse,
    PostAdminCompaniesIdIntegrationsResponse,
    PostAdminCompaniesIdLinkIntalentUserData,
    PostAdminCompaniesIdLinkIntalentUserError,
    PostAdminCompaniesIdLinkIntalentUserResponse,
    PostAdminCompaniesResponse,
    PostAdminInterviewQualityResolveData,
    PostAdminInterviewQualityResolveError,
    PostAdminInterviewQualityResolveResponse,
    PostAdminInterviewQualityRunsData,
    PostAdminInterviewQualityRunsError,
    PostAdminInterviewQualityRunsResponse,
    PostAdminOrganizationsData,
    PostAdminOrganizationsError,
    PostAdminOrganizationsResponse,
    PostAdminOrganizationsUploadLogoData,
    PostAdminOrganizationsUploadLogoError,
    PostAdminOrganizationsUploadLogoResponse,
    PostAnalyticsAgentData,
    PostAnalyticsAgentError,
    PostAnalyticsAgentResponse,
    PostAnalyticsAgentStreamData,
    PostAnalyticsAgentStreamError,
    PostAnalyticsAgentStreamResponse,
    PostAssessmentParamsData,
    PostAssessmentParamsError,
    PostAssessmentParamsIdCopyData,
    PostAssessmentParamsIdCopyError,
    PostAssessmentParamsIdCopyResponse,
    PostAssessmentParamsResponse,
    PostAssessmentTemplatesData,
    PostAssessmentTemplatesError,
    PostAssessmentTemplatesResponse,
    PostAuthSetCompanyData,
    PostAuthSetCompanyError,
    PostAuthSetCompanyResponse,
    PostBillingChangePlanData,
    PostBillingChangePlanError,
    PostBillingChangePlanResponse,
    PostBillingCompleteCheckoutData,
    PostBillingCompleteCheckoutError,
    PostBillingCompleteCheckoutResponse,
    PostBillingCreditPacksData,
    PostBillingCreditPacksError,
    PostBillingPortalData,
    PostBillingPortalError,
    PostBillingPortalResponse,
    PostCalendarAvailabilityData,
    PostCalendarAvailabilityError,
    PostCalendarData,
    PostCalendarError,
    PostCalendarGenerateTranscriptData,
    PostCalendarGenerateTranscriptError,
    PostCalendarPanelistSlotsCommentsData,
    PostCalendarPanelistSlotsCommentsError,
    PostCalendarPanelistSlotsData,
    PostCalendarPanelistSlotsError,
    PostCalendarPanelistSlotsGenerateData,
    PostCalendarPanelistSlotsGenerateError,
    PostCalendarSchedulingSlotsData,
    PostCalendarSchedulingSlotsError,
    PostCandidatesBulkDeleteData,
    PostCandidatesBulkDeleteError,
    PostCandidatesBulkDeleteResponse,
    PostCandidatesData,
    PostCandidatesError,
    PostCandidatesParseQueryData,
    PostCandidatesParseQueryError,
    PostCandidatesParseQueryResponse,
    PostCandidatesResponse,
    PostCompanyCompanySlugApprovalFlowData,
    PostCompanyCompanySlugApprovalFlowError,
    PostCompanyCompanySlugApprovalFlowResponse,
    PostCompanyCompanySlugCandidateStatusesConfigData,
    PostCompanyCompanySlugCandidateStatusesConfigError,
    PostCompanyCompanySlugCandidateStatusesConfigResponse,
    PostCompanyCompanySlugDepartmentsData,
    PostCompanyCompanySlugDepartmentsError,
    PostCompanyCompanySlugDepartmentsResponse,
    PostCompanyCompanySlugIntegrationsDisconnectData,
    PostCompanyCompanySlugIntegrationsDisconnectError,
    PostCompanyCompanySlugIntegrationsDisconnectResponse,
    PostCompanyCompanySlugIntegrationsLinkedinVerifyData,
    PostCompanyCompanySlugIntegrationsLinkedinVerifyError,
    PostCompanyCompanySlugIntegrationsLinkedinVerifyResponse,
    PostCompanyCompanySlugIntegrationsTestData,
    PostCompanyCompanySlugIntegrationsTestError,
    PostCompanyCompanySlugIntegrationsTestResponse,
    PostCompanyCompanySlugLogoData,
    PostCompanyCompanySlugLogoError,
    PostCompanyCompanySlugLogoResponse,
    PostCompanyCompanySlugUsersData,
    PostCompanyCompanySlugUsersDisableData,
    PostCompanyCompanySlugUsersDisableError,
    PostCompanyCompanySlugUsersDisableResponse,
    PostCompanyCompanySlugUsersEnableData,
    PostCompanyCompanySlugUsersEnableError,
    PostCompanyCompanySlugUsersEnableResponse,
    PostCompanyCompanySlugUsersError,
    PostCompanyCompanySlugUsersResponse,
    PostCompanyCompanySlugUsersUserIdResetPasswordData,
    PostCompanyCompanySlugUsersUserIdResetPasswordError,
    PostCompanyCompanySlugUsersUserIdResetPasswordResponse,
    PostCompanyConfigData,
    PostCompanyConfigError,
    PostCompanyConfigResponse,
    PostCompanyGradeData,
    PostCompanyGradeError,
    PostCompanyGradeResponse,
    PostCompanySlugCandidateSharingCreateData,
    PostCompanySlugCandidateSharingCreateError,
    PostCompanySlugJobsJobPostingIdTalentPoolInvitesData,
    PostCompanySlugJobsJobPostingIdTalentPoolInvitesError,
    PostCompanySlugPublicCareerJobsIdApplicationsData,
    PostCompanySlugPublicCareerJobsIdApplicationsError,
    PostCompanySlugPublicCareerJobsIdApplicationsResponse,
    PostCompanySlugPublicCareerTalentPoolApplicationsData,
    PostCompanySlugPublicCareerTalentPoolApplicationsError,
    PostCompanySlugPublicCareerTalentPoolApplicationsResponse,
    PostCompanyTitleGradeData,
    PostCompanyTitleGradeError,
    PostCompanyTitleGradeResponse,
    PostCronAiInterviewRemindersData,
    PostCronAiInterviewRemindersError,
    PostCronAnalyticsRefreshData,
    PostCronAnalyticsRefreshError,
    PostCronBillingCapacityRebillData,
    PostCronBillingCapacityRebillError,
    PostCronFeedbackRemindersData,
    PostCronFeedbackRemindersError,
    PostCronJobApplicationProcessingData,
    PostCronJobApplicationProcessingError,
    PostCronJobApplicationProcessingResponse,
    PostCronRenewCalendarSubscriptionsData,
    PostCronRenewCalendarSubscriptionsError,
    PostCronScreeningWebrtcLifecycleSweeperData,
    PostCronScreeningWebrtcLifecycleSweeperError,
    PostCustomAnalyticsAssignDashboardData,
    PostCustomAnalyticsAssignDashboardError,
    PostCustomAnalyticsDashboardData,
    PostCustomAnalyticsDashboardError,
    PostCustomAnalyticsData,
    PostCustomAnalyticsError,
    PostCustomAnalyticsOrderData,
    PostCustomAnalyticsOrderError,
    PostCustomAnalyticsPaginateData,
    PostCustomAnalyticsPaginateError,
    PostCustomAnalyticsPreviewData,
    PostCustomAnalyticsPreviewError,
    PostCustomAnalyticsRemoveDashboardData,
    PostCustomAnalyticsRemoveDashboardError,
    PostEmbeddingsData,
    PostEmbeddingsError,
    PostEmbeddingsResponse,
    PostGenerateQuestionsData,
    PostGenerateQuestionsError,
    PostHiringManagersData,
    PostHiringManagersError,
    PostInsightsBenettonApplicantsReportData,
    PostInsightsBenettonApplicantsReportError,
    PostInsightsCandidatesByRolesReportData,
    PostInsightsCandidatesByRolesReportError,
    PostInsightsCandidatesByStatusReportData,
    PostInsightsCandidatesByStatusReportError,
    PostInsightsCustomChartsData,
    PostInsightsCustomChartsError,
    PostInsightsMonthlyDashboardData,
    PostInsightsMonthlyDashboardError,
    PostInsightsOfferJoinedReportData,
    PostInsightsOfferJoinedReportError,
    PostInsightsOpenPositionsReportData,
    PostInsightsOpenPositionsReportError,
    PostInsightsPositionsClosedReportData,
    PostInsightsPositionsClosedReportError,
    PostInsightsPositionsCreatedReportData,
    PostInsightsPositionsCreatedReportError,
    PostInsightsPredefinedGraphsData,
    PostInsightsPredefinedGraphsError,
    PostInsightsPredefinedGraphsSaveData,
    PostInsightsPredefinedGraphsSaveError,
    PostInternalAnalyticsQueryData,
    PostInternalAnalyticsQueryError,
    PostInternalAnalyticsQueryResponse,
    PostInternalSttData,
    PostInternalSttError,
    PostInternalSttResponse,
    PostInterviewsData,
    PostInterviewsError,
    PostInterviewsFeedbackGenerateData,
    PostInterviewsFeedbackGenerateError,
    PostInterviewsHumanInterviewQuestionsData,
    PostInterviewsHumanInterviewQuestionsError,
    PostInterviewsHumanInterviewQuestionsTriggerData,
    PostInterviewsHumanInterviewQuestionsTriggerError,
    PostInterviewsIdInterviewRoundData,
    PostInterviewsIdInterviewRoundError,
    PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData,
    PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError,
    PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData,
    PostInterviewsIdInterviewRoundInterviewRoundIdRatingsError,
    PostInterviewsIdInterviewRoundResponse,
    PostInterviewsResponse,
    PostInterviewsScreeningCallBulkData,
    PostInterviewsScreeningCallBulkError,
    PostInterviewsScreeningCallData,
    PostInterviewsScreeningCallEndInterviewData,
    PostInterviewsScreeningCallEndInterviewError,
    PostInterviewsScreeningCallEndInterviewResponse,
    PostInterviewsScreeningCallError,
    PostInterviewsScreeningCallIdRecordingFetchData,
    PostInterviewsScreeningCallIdRecordingFetchError,
    PostInterviewsScreeningCallIdRecordingFetchResponse,
    PostInterviewsScreeningCallLifecycleData,
    PostInterviewsScreeningCallLifecycleError,
    PostInterviewsScreeningCallLifecycleResponse,
    PostInterviewsScreeningInterviewClientTokenData,
    PostInterviewsScreeningInterviewClientTokenError,
    PostInterviewsScreeningInterviewClientTokenResponse,
    PostInterviewsScreeningInterviewDailyRecordingData,
    PostInterviewsScreeningInterviewDailyRecordingError,
    PostInterviewsScreeningInterviewData,
    PostInterviewsScreeningInterviewEndInterviewData,
    PostInterviewsScreeningInterviewEndInterviewError,
    PostInterviewsScreeningInterviewEndInterviewResponse,
    PostInterviewsScreeningInterviewError,
    PostInterviewsScreeningInterviewEventsData,
    PostInterviewsScreeningInterviewEventsError,
    PostInterviewsScreeningInterviewEventsResponse,
    PostInterviewsScreeningInterviewFastrtcRecordingData,
    PostInterviewsScreeningInterviewFastrtcRecordingError,
    PostInterviewsScreeningInterviewFetchDailyRecordingData,
    PostInterviewsScreeningInterviewFetchDailyRecordingError,
    PostInterviewsScreeningInterviewFixLivenessStatusData,
    PostInterviewsScreeningInterviewFixLivenessStatusError,
    PostInterviewsScreeningInterviewProctoringData,
    PostInterviewsScreeningInterviewProctoringError,
    PostInterviewsScreeningInterviewProctoringResponse,
    PostInterviewsScreeningInterviewStartData,
    PostInterviewsScreeningInterviewStartError,
    PostInterviewsScreeningInterviewTransitionToStartedData,
    PostInterviewsScreeningInterviewTransitionToStartedError,
    PostInterviewsScreeningInterviewTransitionToStartedResponse,
    PostInterviewsScreeningInterviewTtsEnsureData,
    PostInterviewsScreeningInterviewTtsEnsureError,
    PostInterviewsScreeningWebrtcAbandonData,
    PostInterviewsScreeningWebrtcAbandonError,
    PostInterviewsScreeningWebrtcAbandonResponse,
    PostInterviewsScreeningWebrtcLifecycleData,
    PostInterviewsScreeningWebrtcLifecycleError,
    PostInterviewsScreeningWebrtcLifecycleResponse,
    PostInterviewsScreeningWebrtcOfferData,
    PostInterviewsScreeningWebrtcOfferError,
    PostInterviewsScreeningWebrtcOfferResponse,
    PostInterviewsScreeningWebrtcRecordingChunkData,
    PostInterviewsScreeningWebrtcRecordingChunkError,
    PostInterviewsScreeningWebrtcRecordingChunkResponse,
    PostInterviewsScreeningWebrtcRecordingFinalizeData,
    PostInterviewsScreeningWebrtcRecordingFinalizeError,
    PostInterviewsScreeningWebrtcRecordingFinalizeResponse,
    PostInterviewsScreeningWebrtcRecordingInitData,
    PostInterviewsScreeningWebrtcRecordingInitError,
    PostInterviewsScreeningWebrtcRecordingInitResponse,
    PostInterviewsScreeningWebrtcRecordingPartUrlData,
    PostInterviewsScreeningWebrtcRecordingPartUrlError,
    PostInterviewsScreeningWebrtcRecordingPartUrlResponse,
    PostInterviewsScreeningWebrtcSessionData,
    PostInterviewsScreeningWebrtcSessionError,
    PostInterviewsScreeningWebrtcSessionLogAppendData,
    PostInterviewsScreeningWebrtcSessionLogAppendError,
    PostInterviewsScreeningWebrtcSessionLogAppendResponse,
    PostInterviewsScreeningWebrtcSessionLogFinalizeData,
    PostInterviewsScreeningWebrtcSessionLogFinalizeError,
    PostInterviewsScreeningWebrtcSessionLogFinalizeResponse,
    PostInterviewsScreeningWebrtcSessionResponse,
    PostInterviewsScreeningWebrtcSessionSessionIdConnectData,
    PostInterviewsScreeningWebrtcSessionSessionIdConnectError,
    PostInterviewsScreeningWebrtcSessionSessionIdConnectResponse,
    PostInterviewsScreeningWebrtcTokenData,
    PostInterviewsScreeningWebrtcTokenError,
    PostInterviewsScreeningWebrtcTokenResponse,
    PostJdAgentBackendData,
    PostJdAgentBackendError,
    PostJdAgentBackendResponse,
    PostJdAgentBackendStreamData,
    PostJdAgentBackendStreamError,
    PostJdAgentBackendStreamResponse,
    PostJdAgentConversationSyncData,
    PostJdAgentConversationSyncError,
    PostJdAgentConversationSyncResponse,
    PostJdData,
    PostJdError,
    PostJdExtractTextData,
    PostJdExtractTextError,
    PostJdExtractTextResponse,
    PostJdResponse,
    PostJobApplicationsBulkDeleteData,
    PostJobApplicationsBulkDeleteError,
    PostJobApplicationsBulkDeleteResponse,
    PostJobApplicationsBulkReprocessData,
    PostJobApplicationsBulkReprocessError,
    PostJobApplicationsBulkReprocessResponse,
    PostJobApplicationsData,
    PostJobApplicationsError,
    PostJobApplicationsIdData,
    PostJobApplicationsIdError,
    PostJobApplicationsIdReprocessData,
    PostJobApplicationsIdReprocessError,
    PostJobApplicationsIdReprocessResponse,
    PostJobApplicationsIdResponse,
    PostJobApplicationsResponse,
    PostJobApproversBypassIdData,
    PostJobApproversBypassIdError,
    PostJobApproversData,
    PostJobApproversError,
    PostJobApproversReminderIdData,
    PostJobApproversReminderIdError,
    PostJobApproversReminderIdResponse,
    PostJobApproversResponse,
    PostJobsBulkDeleteData,
    PostJobsBulkDeleteError,
    PostJobsBulkDeleteResponse,
    PostJobsData,
    PostJobsError,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsData,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsError,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsResponse,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsData,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsError,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewData,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewError,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewResponse,
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsResponse,
    PostJobsIdSourcedCandidatesSourcedCandidateIdMoveData,
    PostJobsIdSourcedCandidatesSourcedCandidateIdMoveError,
    PostJobsIdSourcedCandidatesSourcedCandidateIdMoveResponse,
    PostJobsIdSourcedCandidatesSourcedCandidateIdNotesData,
    PostJobsIdSourcedCandidatesSourcedCandidateIdNotesError,
    PostJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
    PostJobsResponse,
    PostMailboxMonitoringData,
    PostMailboxMonitoringError,
    PostMailboxMonitoringProcessData,
    PostMailboxMonitoringProcessError,
    PostMarleeCommandData,
    PostMarleeCommandError,
    PostMarleeCommandResponse,
    PostMarleeSessionData,
    PostMarleeSessionError,
    PostMarleeSessionResponse,
    PostNaukriJobData,
    PostNaukriJobError,
    PostNaukriJobResponse,
    PostNotesData,
    PostNotesError,
    PostOffersData,
    PostOffersError,
    PostOffersRemindData,
    PostOffersRemindError,
    PostOffersRemindResponse,
    PostOffersRequestDocumentsData,
    PostOffersRequestDocumentsError,
    PostOffersRequestDocumentsResponse,
    PostOffersResponse,
    PostOffersSendData,
    PostOffersSendError,
    PostOffersSendForApprovalData,
    PostOffersSendForApprovalError,
    PostOffersSendForApprovalResponse,
    PostOffersSendResponse,
    PostOffersUploadDocumentsIdData,
    PostOffersUploadDocumentsIdError,
    PostOffersUploadDocumentsIdResponse,
    PostOnboardingCompleteCheckoutData,
    PostOnboardingCompleteCheckoutError,
    PostOnboardingCompleteCheckoutResponse,
    PostOnboardingCompleteSignupData,
    PostOnboardingCompleteSignupError,
    PostOnboardingCompleteSignupResponse,
    PostOnboardingSelectPlanData,
    PostOnboardingSelectPlanError,
    PostOnboardingSelectPlanResponse,
    PostOnboardingSignupData,
    PostOnboardingSignupError,
    PostOnboardingSignupResponse,
    PostOnboardingUploadLogoData,
    PostOnboardingUploadLogoError,
    PostOnboardingUploadLogoResponse,
    PostOnboardingVerifyCodeData,
    PostOnboardingVerifyCodeError,
    PostOnboardingVerifyCodeResponse,
    PostOnboardingVerifyStatusData,
    PostOnboardingVerifyStatusError,
    PostOnboardingVerifyStatusResponse,
    PostPermissionsData,
    PostPermissionsError,
    PostPermissionsResponse,
    PostReachOutData,
    PostReachOutError,
    PostReachOutSlotBookingData,
    PostReachOutSlotBookingError,
    PostRekognitionCreateSessionData,
    PostRekognitionCreateSessionError,
    PostReportsConfigCompanyIdData,
    PostReportsConfigCompanyIdError,
    PostReportsConfigCompanyIdResponse,
    PostReportsExecuteData,
    PostReportsExecuteError,
    PostReportsExecuteResponse,
    PostScreeningReportPdfData,
    PostScreeningReportPdfError,
    PostScreeningReportPdfResponse,
    PostSendEmailData,
    PostSendEmailError,
    PostSettingsCommunicationTemplatesActivateDefaultData,
    PostSettingsCommunicationTemplatesActivateDefaultError,
    PostSettingsCommunicationTemplatesActivateDefaultResponse,
    PostSettingsCommunicationTemplatesData,
    PostSettingsCommunicationTemplatesError,
    PostSettingsCommunicationTemplatesPreviewData,
    PostSettingsCommunicationTemplatesPreviewError,
    PostSettingsCommunicationTemplatesPreviewResponse,
    PostSettingsCommunicationTemplatesResponse,
    PostSourcingExtractData,
    PostSourcingExtractError,
    PostSourcingExtractResponse,
    PostSourcingSourcedCandidatesData,
    PostSourcingSourcedCandidatesError,
    PostSourcingSourcedCandidatesResponse,
    PostTemporalCandidateData,
    PostTemporalCandidateError,
    PostTemporalCommunicationStatusData,
    PostTemporalCommunicationStatusError,
    PostTemporalInterviewQualityReportData,
    PostTemporalInterviewQualityReportError,
    PostTemporalInterviewQualityReportResponse,
    PostTemporalInterviewQualityRunsRunIdStatusData,
    PostTemporalInterviewQualityRunsRunIdStatusError,
    PostTemporalInterviewQualityRunsRunIdStatusResponse,
    PostTemporalScreeningCallObjectiveEvaluationsData,
    PostTemporalScreeningCallObjectiveEvaluationsError,
    PostTemporalScreeningCallObjectiveEvaluationsResponse,
    PostTemporalWorkshortsData,
    PostTemporalWorkshortsError,
    PostTemporalWorkshortsResponse,
    PostWebhooksAzureEmailData,
    PostWebhooksAzureEmailError,
    PostWebhooksDailyData,
    PostWebhooksDailyError,
    PostWebhooksGraphData,
    PostWebhooksGraphError,
    PostWebhooksGraphResponse,
    PostWebhooksGraphTranscriptData,
    PostWebhooksGraphTranscriptError,
    PostWebhooksGraphTranscriptResponse,
    PostWebhooksPlivoRecordingData,
    PostWebhooksPlivoRecordingError,
    PostWebhooksPlivoRecordingResponse,
    PostWebhooksPlivoVoiceData,
    PostWebhooksPlivoVoiceError,
    PostWebhooksPlivoVoiceResponse,
    PostWebhooksPlivoWhatsappData,
    PostWebhooksPlivoWhatsappError,
    PostWebhooksResendEmailData,
    PostWebhooksResendEmailError,
    PostWebhooksStripeData,
    PostWebhooksStripeError,
    PostWebhooksStripeResponse,
    PostWebhooksTwilioRecordingData,
    PostWebhooksTwilioRecordingError,
    PostWebhooksTwilioRecordingResponse,
    PostWebhooksTwilioVoiceData,
    PostWebhooksTwilioVoiceError,
    PostWebhooksTwilioVoiceResponse,
    PostWebhooksTwilioWhatsappData,
    PostWebhooksTwilioWhatsappError,
    PostWhatsappCompanySlugData,
    PostWhatsappCompanySlugError,
    PostWhatsappData,
    PostWhatsappError,
    PutAdminBillingCreditCostsIdData,
    PutAdminBillingCreditCostsIdError,
    PutAdminBillingCreditCostsIdResponse,
    PutAdminCompaniesIdAccessControlData,
    PutAdminCompaniesIdAccessControlError,
    PutAdminCompaniesIdAccessControlResponse,
    PutAdminCompaniesIdData,
    PutAdminCompaniesIdError,
    PutAdminCompaniesIdResponse,
    PutAssessmentParamsIdData,
    PutAssessmentParamsIdError,
    PutAssessmentParamsIdResponse,
    PutAssessmentTemplatesIdData,
    PutAssessmentTemplatesIdError,
    PutAssessmentTemplatesIdResponse,
    PutAuthProfileData,
    PutAuthProfileError,
    PutAuthProfileResponse,
    PutCalendarData,
    PutCalendarError,
    PutCandidateSharingSharingSlugFeedbackData,
    PutCandidateSharingSharingSlugFeedbackError,
    PutCandidatesIdData,
    PutCandidatesIdError,
    PutCompanyCompanySlugAccessControlConfigData,
    PutCompanyCompanySlugAccessControlConfigError,
    PutCompanyCompanySlugAccessControlConfigResponse,
    PutCompanyCompanySlugCandidateStatusesConfigData,
    PutCompanyCompanySlugCandidateStatusesConfigError,
    PutCompanyCompanySlugCandidateStatusesConfigResponse,
    PutCompanyCompanySlugJdTemplateData,
    PutCompanyCompanySlugJdTemplateError,
    PutCompanyCompanySlugJdTemplateResponse,
    PutCompanyCompanySlugJobPostingConfigData,
    PutCompanyCompanySlugJobPostingConfigError,
    PutCompanyCompanySlugJobPostingConfigResponse,
    PutCompanyConfigData,
    PutCompanyConfigError,
    PutCompanyConfigResponse,
    PutGenerateQuestionsIdData,
    PutGenerateQuestionsIdError,
    PutHiringManagersIdData,
    PutHiringManagersIdError,
    PutInterviewsFeedbackData,
    PutInterviewsFeedbackError,
    PutInterviewsIdData,
    PutInterviewsIdError,
    PutInterviewsIdInterviewRoundData,
    PutInterviewsIdInterviewRoundError,
    PutInterviewsIdInterviewRoundInterviewRoundIdData,
    PutInterviewsIdInterviewRoundInterviewRoundIdError,
    PutInterviewsIdInterviewRoundResponse,
    PutInterviewsIdResponse,
    PutInterviewsScreeningCallData,
    PutInterviewsScreeningCallError,
    PutInterviewsScreeningInterviewData,
    PutInterviewsScreeningInterviewError,
    PutInterviewsScreeningWebrtcNetworkProbeData,
    PutInterviewsScreeningWebrtcNetworkProbeError,
    PutJobApplicationsApproveData,
    PutJobApplicationsApproveError,
    PutJobApplicationsApproveResponse,
    PutJobApplicationsIdData,
    PutJobApplicationsIdError,
    PutJobApplicationsIdResponse,
    PutJobApproversApproveData,
    PutJobApproversApproveError,
    PutJobApproversApproveResponse,
    PutJobsIdData,
    PutJobsIdError,
    PutJobsIdResponse,
    PutNotesIdData,
    PutNotesIdError,
    PutNotificationsData,
    PutNotificationsError,
    PutNotificationsResponse,
    PutOffersAcceptData,
    PutOffersAcceptError,
    PutOffersAcceptResponse,
    PutOffersApproveData,
    PutOffersApproveError,
    PutOffersApproveResponse,
    PutOffersData,
    PutOffersDocumentsData,
    PutOffersDocumentsError,
    PutOffersDocumentsResponse,
    PutOffersError,
    PutOffersResponse,
    PutOffersUploadDocumentsIdData,
    PutOffersUploadDocumentsIdError,
    PutOffersUploadDocumentsIdResponse,
    PutSettingsCommunicationTemplatesIdData,
    PutSettingsCommunicationTemplatesIdError,
    PutSettingsCommunicationTemplatesIdResponse,
    PutTemporalJobApplicationsIdData,
    PutTemporalJobApplicationsIdError,
    PutTemporalJobApplicationsIdResponse,
    PutTemporalScreeningCallData,
    PutTemporalScreeningCallError,
    PutTemporalScreeningCallResponse,
} from '../types.gen'

export const postCompanySlugCandidateSharingCreateMutation = (
    options?: Partial<Options<PostCompanySlugCandidateSharingCreateData>>
): UseMutationOptions<unknown, AxiosError<PostCompanySlugCandidateSharingCreateError>, Options<PostCompanySlugCandidateSharingCreateData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostCompanySlugCandidateSharingCreateError>,
        Options<PostCompanySlugCandidateSharingCreateData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanySlugCandidateSharingCreate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseURL' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string
        _infinite?: boolean
        tags?: ReadonlyArray<string>
    },
]

const createQueryKey = <TOptions extends Options>(
    id: string,
    options?: TOptions,
    infinite?: boolean,
    tags?: ReadonlyArray<string>
): [QueryKey<TOptions>[0]] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseURL: options?.baseURL || (options?.client ?? client).getConfig().baseURL } as QueryKey<TOptions>[0]
    if (infinite) {
        params._infinite = infinite
    }
    if (tags) {
        params.tags = tags
    }
    if (options?.body) {
        params.body = options.body
    }
    if (options?.headers) {
        params.headers = options.headers
    }
    if (options?.path) {
        params.path = options.path
    }
    if (options?.query) {
        params.query = options.query
    }
    return [params]
}

export const getCompanySlugJobsJobPostingIdTalentPoolInvitesQueryKey = (options: Options<GetCompanySlugJobsJobPostingIdTalentPoolInvitesData>) =>
    createQueryKey('getCompanySlugJobsJobPostingIdTalentPoolInvites', options, false, ['{companySlug}'])

export const getCompanySlugJobsJobPostingIdTalentPoolInvitesOptions = (options: Options<GetCompanySlugJobsJobPostingIdTalentPoolInvitesData>) =>
    queryOptions<
        unknown,
        AxiosError<GetCompanySlugJobsJobPostingIdTalentPoolInvitesError>,
        unknown,
        ReturnType<typeof getCompanySlugJobsJobPostingIdTalentPoolInvitesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugJobsJobPostingIdTalentPoolInvites({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugJobsJobPostingIdTalentPoolInvitesQueryKey(options),
    })

export const postCompanySlugJobsJobPostingIdTalentPoolInvitesMutation = (
    options?: Partial<Options<PostCompanySlugJobsJobPostingIdTalentPoolInvitesData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostCompanySlugJobsJobPostingIdTalentPoolInvitesError>,
    Options<PostCompanySlugJobsJobPostingIdTalentPoolInvitesData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostCompanySlugJobsJobPostingIdTalentPoolInvitesError>,
        Options<PostCompanySlugJobsJobPostingIdTalentPoolInvitesData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanySlugJobsJobPostingIdTalentPoolInvites({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminCompaniesQueryKey = (options?: Options<GetAdminCompaniesData>) => createQueryKey('getAdminCompanies', options, false, ['Admin'])

/**
 * GET handler for admin companies endpoint
 */
export const getAdminCompaniesOptions = (options?: Options<GetAdminCompaniesData>) =>
    queryOptions<GetAdminCompaniesResponse, AxiosError<GetAdminCompaniesError>, GetAdminCompaniesResponse, ReturnType<typeof getAdminCompaniesQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminCompanies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminCompaniesQueryKey(options),
    })

export const postAdminCompaniesMutation = (
    options?: Partial<Options<PostAdminCompaniesData>>
): UseMutationOptions<PostAdminCompaniesResponse, AxiosError<PostAdminCompaniesError>, Options<PostAdminCompaniesData>> => {
    const mutationOptions: UseMutationOptions<PostAdminCompaniesResponse, AxiosError<PostAdminCompaniesError>, Options<PostAdminCompaniesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminCompanies({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminIntalentUsersQueryKey = (options?: Options<GetAdminIntalentUsersData>) =>
    createQueryKey('getAdminIntalentUsers', options, false, ['Admin'])

/**
 * SuperAdmin only. Lists distinct @intalent.ai users with real Auth0 IDs (from Users table).
 */
export const getAdminIntalentUsersOptions = (options?: Options<GetAdminIntalentUsersData>) =>
    queryOptions<
        GetAdminIntalentUsersResponse,
        AxiosError<GetAdminIntalentUsersError>,
        GetAdminIntalentUsersResponse,
        ReturnType<typeof getAdminIntalentUsersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminIntalentUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminIntalentUsersQueryKey(options),
    })

/**
 * POST /api/admin/organizations
 */
export const postAdminOrganizationsMutation = (
    options?: Partial<Options<PostAdminOrganizationsData>>
): UseMutationOptions<PostAdminOrganizationsResponse, AxiosError<PostAdminOrganizationsError>, Options<PostAdminOrganizationsData>> => {
    const mutationOptions: UseMutationOptions<PostAdminOrganizationsResponse, AxiosError<PostAdminOrganizationsError>, Options<PostAdminOrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminOrganizations({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminCompaniesIdQueryKey = (options: Options<GetAdminCompaniesIdData>) => createQueryKey('getAdminCompaniesId', options, false, ['Admin'])

/**
 * GET handler for company full details (super admin only).
 */
export const getAdminCompaniesIdOptions = (options: Options<GetAdminCompaniesIdData>) =>
    queryOptions<
        GetAdminCompaniesIdResponse,
        AxiosError<GetAdminCompaniesIdError>,
        GetAdminCompaniesIdResponse,
        ReturnType<typeof getAdminCompaniesIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminCompaniesId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminCompaniesIdQueryKey(options),
    })

/**
 * PUT handler for updating company details
 */
export const putAdminCompaniesIdMutation = (
    options?: Partial<Options<PutAdminCompaniesIdData>>
): UseMutationOptions<PutAdminCompaniesIdResponse, AxiosError<PutAdminCompaniesIdError>, Options<PutAdminCompaniesIdData>> => {
    const mutationOptions: UseMutationOptions<PutAdminCompaniesIdResponse, AxiosError<PutAdminCompaniesIdError>, Options<PutAdminCompaniesIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAdminCompaniesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/admin/organizations/upload-logo
 */
export const postAdminOrganizationsUploadLogoMutation = (
    options?: Partial<Options<PostAdminOrganizationsUploadLogoData>>
): UseMutationOptions<
    PostAdminOrganizationsUploadLogoResponse,
    AxiosError<PostAdminOrganizationsUploadLogoError>,
    Options<PostAdminOrganizationsUploadLogoData>
> => {
    const mutationOptions: UseMutationOptions<
        PostAdminOrganizationsUploadLogoResponse,
        AxiosError<PostAdminOrganizationsUploadLogoError>,
        Options<PostAdminOrganizationsUploadLogoData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminOrganizationsUploadLogo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminCompaniesIdAccessControlQueryKey = (options: Options<GetAdminCompaniesIdAccessControlData>) =>
    createQueryKey('getAdminCompaniesIdAccessControl', options, false, ['Admin'])

/**
 * GET /api/admin/companies/[id]/access-control
 */
export const getAdminCompaniesIdAccessControlOptions = (options: Options<GetAdminCompaniesIdAccessControlData>) =>
    queryOptions<
        GetAdminCompaniesIdAccessControlResponse,
        AxiosError<GetAdminCompaniesIdAccessControlError>,
        GetAdminCompaniesIdAccessControlResponse,
        ReturnType<typeof getAdminCompaniesIdAccessControlQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminCompaniesIdAccessControl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminCompaniesIdAccessControlQueryKey(options),
    })

/**
 * PUT /api/admin/companies/[id]/access-control
 */
export const putAdminCompaniesIdAccessControlMutation = (
    options?: Partial<Options<PutAdminCompaniesIdAccessControlData>>
): UseMutationOptions<
    PutAdminCompaniesIdAccessControlResponse,
    AxiosError<PutAdminCompaniesIdAccessControlError>,
    Options<PutAdminCompaniesIdAccessControlData>
> => {
    const mutationOptions: UseMutationOptions<
        PutAdminCompaniesIdAccessControlResponse,
        AxiosError<PutAdminCompaniesIdAccessControlError>,
        Options<PutAdminCompaniesIdAccessControlData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAdminCompaniesIdAccessControl({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/admin/companies/[id]/archive
 */
export const patchAdminCompaniesIdArchiveMutation = (
    options?: Partial<Options<PatchAdminCompaniesIdArchiveData>>
): UseMutationOptions<PatchAdminCompaniesIdArchiveResponse, AxiosError<PatchAdminCompaniesIdArchiveError>, Options<PatchAdminCompaniesIdArchiveData>> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminCompaniesIdArchiveResponse,
        AxiosError<PatchAdminCompaniesIdArchiveError>,
        Options<PatchAdminCompaniesIdArchiveData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminCompaniesIdArchive({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/admin/companies/[id]/feature-flags
 */
export const patchAdminCompaniesIdFeatureFlagsMutation = (
    options?: Partial<Options<PatchAdminCompaniesIdFeatureFlagsData>>
): UseMutationOptions<
    PatchAdminCompaniesIdFeatureFlagsResponse,
    AxiosError<PatchAdminCompaniesIdFeatureFlagsError>,
    Options<PatchAdminCompaniesIdFeatureFlagsData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminCompaniesIdFeatureFlagsResponse,
        AxiosError<PatchAdminCompaniesIdFeatureFlagsError>,
        Options<PatchAdminCompaniesIdFeatureFlagsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminCompaniesIdFeatureFlags({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminCompaniesIdIntegrationsQueryKey = (options: Options<GetAdminCompaniesIdIntegrationsData>) =>
    createQueryKey('getAdminCompaniesIdIntegrations', options, false, ['Admin'])

export const getAdminCompaniesIdIntegrationsOptions = (options: Options<GetAdminCompaniesIdIntegrationsData>) =>
    queryOptions<
        GetAdminCompaniesIdIntegrationsResponse,
        AxiosError<GetAdminCompaniesIdIntegrationsError>,
        GetAdminCompaniesIdIntegrationsResponse,
        ReturnType<typeof getAdminCompaniesIdIntegrationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminCompaniesIdIntegrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminCompaniesIdIntegrationsQueryKey(options),
    })

export const patchAdminCompaniesIdIntegrationsMutation = (
    options?: Partial<Options<PatchAdminCompaniesIdIntegrationsData>>
): UseMutationOptions<
    PatchAdminCompaniesIdIntegrationsResponse,
    AxiosError<PatchAdminCompaniesIdIntegrationsError>,
    Options<PatchAdminCompaniesIdIntegrationsData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminCompaniesIdIntegrationsResponse,
        AxiosError<PatchAdminCompaniesIdIntegrationsError>,
        Options<PatchAdminCompaniesIdIntegrationsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminCompaniesIdIntegrations({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postAdminCompaniesIdIntegrationsMutation = (
    options?: Partial<Options<PostAdminCompaniesIdIntegrationsData>>
): UseMutationOptions<
    PostAdminCompaniesIdIntegrationsResponse,
    AxiosError<PostAdminCompaniesIdIntegrationsError>,
    Options<PostAdminCompaniesIdIntegrationsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostAdminCompaniesIdIntegrationsResponse,
        AxiosError<PostAdminCompaniesIdIntegrationsError>,
        Options<PostAdminCompaniesIdIntegrationsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminCompaniesIdIntegrations({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * SuperAdmin only. Links an existing @intalent.ai user (from directory + Auth0) to a company:
 */
export const postAdminCompaniesIdLinkIntalentUserMutation = (
    options?: Partial<Options<PostAdminCompaniesIdLinkIntalentUserData>>
): UseMutationOptions<
    PostAdminCompaniesIdLinkIntalentUserResponse,
    AxiosError<PostAdminCompaniesIdLinkIntalentUserError>,
    Options<PostAdminCompaniesIdLinkIntalentUserData>
> => {
    const mutationOptions: UseMutationOptions<
        PostAdminCompaniesIdLinkIntalentUserResponse,
        AxiosError<PostAdminCompaniesIdLinkIntalentUserError>,
        Options<PostAdminCompaniesIdLinkIntalentUserData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminCompaniesIdLinkIntalentUser({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * SuperAdmin only. Updates the company display name and CompanyConfig fields shown on the org Overview "Configuration" section. Does not modify Graph credentials.
 */
export const patchAdminCompaniesIdOrgConfigMutation = (
    options?: Partial<Options<PatchAdminCompaniesIdOrgConfigData>>
): UseMutationOptions<PatchAdminCompaniesIdOrgConfigResponse, AxiosError<PatchAdminCompaniesIdOrgConfigError>, Options<PatchAdminCompaniesIdOrgConfigData>> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminCompaniesIdOrgConfigResponse,
        AxiosError<PatchAdminCompaniesIdOrgConfigError>,
        Options<PatchAdminCompaniesIdOrgConfigData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminCompaniesIdOrgConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingCreditCostsQueryKey = (options?: Options<GetAdminBillingCreditCostsData>) =>
    createQueryKey('getAdminBillingCreditCosts', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/credit-costs
 *
 * List named credit cost catalogs assignable to plans and companies.
 */
export const getAdminBillingCreditCostsOptions = (options?: Options<GetAdminBillingCreditCostsData>) =>
    queryOptions<
        GetAdminBillingCreditCostsResponse,
        AxiosError<GetAdminBillingCreditCostsError>,
        GetAdminBillingCreditCostsResponse,
        ReturnType<typeof getAdminBillingCreditCostsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingCreditCosts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingCreditCostsQueryKey(options),
    })

/**
 * POST /api/admin/billing/credit-costs
 *
 * Create a named credit cost catalog.
 */
export const postAdminBillingCreditCostsMutation = (
    options?: Partial<Options<PostAdminBillingCreditCostsData>>
): UseMutationOptions<PostAdminBillingCreditCostsResponse, AxiosError<PostAdminBillingCreditCostsError>, Options<PostAdminBillingCreditCostsData>> => {
    const mutationOptions: UseMutationOptions<
        PostAdminBillingCreditCostsResponse,
        AxiosError<PostAdminBillingCreditCostsError>,
        Options<PostAdminBillingCreditCostsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminBillingCreditCosts({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingPlansQueryKey = (options?: Options<GetAdminBillingPlansData>) =>
    createQueryKey('getAdminBillingPlans', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/plans — list all plans (SuperAdmin).
 *
 * List all billing plans ordered by freemium, price, then name.
 */
export const getAdminBillingPlansOptions = (options?: Options<GetAdminBillingPlansData>) =>
    queryOptions<
        GetAdminBillingPlansResponse,
        AxiosError<GetAdminBillingPlansError>,
        GetAdminBillingPlansResponse,
        ReturnType<typeof getAdminBillingPlansQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingPlans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingPlansQueryKey(options),
    })

/**
 * POST /api/admin/billing/plans — create plan; sync non-freemium to Stripe.
 *
 * Create a billing plan. Paid plans sync Product + Price to Stripe.
 */
export const postAdminBillingPlansMutation = (
    options?: Partial<Options<PostAdminBillingPlansData>>
): UseMutationOptions<PostAdminBillingPlansResponse, AxiosError<PostAdminBillingPlansError>, Options<PostAdminBillingPlansData>> => {
    const mutationOptions: UseMutationOptions<PostAdminBillingPlansResponse, AxiosError<PostAdminBillingPlansError>, Options<PostAdminBillingPlansData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminBillingPlans({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingSignupDraftsQueryKey = (options?: Options<GetAdminBillingSignupDraftsData>) =>
    createQueryKey('getAdminBillingSignupDrafts', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/signup-drafts — incomplete signup drafts (SuperAdmin).
 *
 * List incomplete signup drafts for SuperAdmin review.
 */
export const getAdminBillingSignupDraftsOptions = (options?: Options<GetAdminBillingSignupDraftsData>) =>
    queryOptions<
        GetAdminBillingSignupDraftsResponse,
        AxiosError<GetAdminBillingSignupDraftsError>,
        GetAdminBillingSignupDraftsResponse,
        ReturnType<typeof getAdminBillingSignupDraftsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingSignupDrafts({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingSignupDraftsQueryKey(options),
    })

/**
 * DELETE /api/admin/billing/credit-costs/[id]
 *
 * Delete a credit cost set. Blocked if default or referenced by plans/companies.
 */
export const deleteAdminBillingCreditCostsIdMutation = (
    options?: Partial<Options<DeleteAdminBillingCreditCostsIdData>>
): UseMutationOptions<
    DeleteAdminBillingCreditCostsIdResponse,
    AxiosError<DeleteAdminBillingCreditCostsIdError>,
    Options<DeleteAdminBillingCreditCostsIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteAdminBillingCreditCostsIdResponse,
        AxiosError<DeleteAdminBillingCreditCostsIdError>,
        Options<DeleteAdminBillingCreditCostsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAdminBillingCreditCostsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingCreditCostsIdQueryKey = (options: Options<GetAdminBillingCreditCostsIdData>) =>
    createQueryKey('getAdminBillingCreditCostsId', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/credit-costs/[id]
 *
 * Fetch a single credit cost set by id (SuperAdmin).
 */
export const getAdminBillingCreditCostsIdOptions = (options: Options<GetAdminBillingCreditCostsIdData>) =>
    queryOptions<
        GetAdminBillingCreditCostsIdResponse,
        AxiosError<GetAdminBillingCreditCostsIdError>,
        GetAdminBillingCreditCostsIdResponse,
        ReturnType<typeof getAdminBillingCreditCostsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingCreditCostsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingCreditCostsIdQueryKey(options),
    })

/**
 * PUT /api/admin/billing/credit-costs/[id]
 *
 * Update a credit cost set name/costs/default flag (SuperAdmin).
 */
export const putAdminBillingCreditCostsIdMutation = (
    options?: Partial<Options<PutAdminBillingCreditCostsIdData>>
): UseMutationOptions<PutAdminBillingCreditCostsIdResponse, AxiosError<PutAdminBillingCreditCostsIdError>, Options<PutAdminBillingCreditCostsIdData>> => {
    const mutationOptions: UseMutationOptions<
        PutAdminBillingCreditCostsIdResponse,
        AxiosError<PutAdminBillingCreditCostsIdError>,
        Options<PutAdminBillingCreditCostsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAdminBillingCreditCostsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingCreditCostsExportQueryKey = (options?: Options<GetAdminBillingCreditCostsExportData>) =>
    createQueryKey('getAdminBillingCreditCostsExport', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/credit-costs/export — portable JSON of all credit cost sets.
 *
 * Export named credit cost catalogs for cross-environment import.
 */
export const getAdminBillingCreditCostsExportOptions = (options?: Options<GetAdminBillingCreditCostsExportData>) =>
    queryOptions<
        GetAdminBillingCreditCostsExportResponse,
        AxiosError<GetAdminBillingCreditCostsExportError>,
        GetAdminBillingCreditCostsExportResponse,
        ReturnType<typeof getAdminBillingCreditCostsExportQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingCreditCostsExport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingCreditCostsExportQueryKey(options),
    })

/**
 * POST /api/admin/billing/credit-costs/import — upsert credit cost sets from a portable export.
 *
 * Import named credit cost catalogs (v2) or a single catalog onto the default set (v1).
 */
export const postAdminBillingCreditCostsImportMutation = (
    options?: Partial<Options<PostAdminBillingCreditCostsImportData>>
): UseMutationOptions<
    PostAdminBillingCreditCostsImportResponse,
    AxiosError<PostAdminBillingCreditCostsImportError>,
    Options<PostAdminBillingCreditCostsImportData>
> => {
    const mutationOptions: UseMutationOptions<
        PostAdminBillingCreditCostsImportResponse,
        AxiosError<PostAdminBillingCreditCostsImportError>,
        Options<PostAdminBillingCreditCostsImportData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminBillingCreditCostsImport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/admin/billing/plans/[id]
 *
 * Soft-deactivate a billing plan (isActive=false, isPublic=false).
 */
export const deleteAdminBillingPlansIdMutation = (
    options?: Partial<Options<DeleteAdminBillingPlansIdData>>
): UseMutationOptions<DeleteAdminBillingPlansIdResponse, AxiosError<DeleteAdminBillingPlansIdError>, Options<DeleteAdminBillingPlansIdData>> => {
    const mutationOptions: UseMutationOptions<
        DeleteAdminBillingPlansIdResponse,
        AxiosError<DeleteAdminBillingPlansIdError>,
        Options<DeleteAdminBillingPlansIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAdminBillingPlansId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingPlansIdQueryKey = (options: Options<GetAdminBillingPlansIdData>) =>
    createQueryKey('getAdminBillingPlansId', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/plans/[id]
 *
 * Fetch a single billing plan by id (SuperAdmin).
 */
export const getAdminBillingPlansIdOptions = (options: Options<GetAdminBillingPlansIdData>) =>
    queryOptions<
        GetAdminBillingPlansIdResponse,
        AxiosError<GetAdminBillingPlansIdError>,
        GetAdminBillingPlansIdResponse,
        ReturnType<typeof getAdminBillingPlansIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingPlansId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingPlansIdQueryKey(options),
    })

/**
 * PATCH /api/admin/billing/plans/[id]
 *
 * Update a billing plan; sync non-freemium plans to Stripe.
 */
export const patchAdminBillingPlansIdMutation = (
    options?: Partial<Options<PatchAdminBillingPlansIdData>>
): UseMutationOptions<PatchAdminBillingPlansIdResponse, AxiosError<PatchAdminBillingPlansIdError>, Options<PatchAdminBillingPlansIdData>> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminBillingPlansIdResponse,
        AxiosError<PatchAdminBillingPlansIdError>,
        Options<PatchAdminBillingPlansIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminBillingPlansId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminBillingPlansExportQueryKey = (options?: Options<GetAdminBillingPlansExportData>) =>
    createQueryKey('getAdminBillingPlansExport', options, false, ['AdminBilling'])

/**
 * GET /api/admin/billing/plans/export — portable JSON of all plans (no Stripe/env ids).
 *
 * Export all billing plans as a portable JSON payload for cross-environment import.
 */
export const getAdminBillingPlansExportOptions = (options?: Options<GetAdminBillingPlansExportData>) =>
    queryOptions<
        GetAdminBillingPlansExportResponse,
        AxiosError<GetAdminBillingPlansExportError>,
        GetAdminBillingPlansExportResponse,
        ReturnType<typeof getAdminBillingPlansExportQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminBillingPlansExport({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminBillingPlansExportQueryKey(options),
    })

/**
 * POST /api/admin/billing/plans/import — upsert plans by code from a portable export.
 *
 * Import portable billing plans by code; paid plans sync to this environment's Stripe.
 */
export const postAdminBillingPlansImportMutation = (
    options?: Partial<Options<PostAdminBillingPlansImportData>>
): UseMutationOptions<PostAdminBillingPlansImportResponse, AxiosError<PostAdminBillingPlansImportError>, Options<PostAdminBillingPlansImportData>> => {
    const mutationOptions: UseMutationOptions<
        PostAdminBillingPlansImportResponse,
        AxiosError<PostAdminBillingPlansImportError>,
        Options<PostAdminBillingPlansImportData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminBillingPlansImport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/admin/companies/[id]/billing — assign/update company billing plan (SuperAdmin).
 *
 * Assign or update the billing plan for a company. Stripe subscription cancel/price update only when syncStripeSubscription is true; pause_collection only when syncStripePause is true.
 */
export const patchAdminCompaniesIdBillingMutation = (
    options?: Partial<Options<PatchAdminCompaniesIdBillingData>>
): UseMutationOptions<PatchAdminCompaniesIdBillingResponse, AxiosError<PatchAdminCompaniesIdBillingError>, Options<PatchAdminCompaniesIdBillingData>> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminCompaniesIdBillingResponse,
        AxiosError<PatchAdminCompaniesIdBillingError>,
        Options<PatchAdminCompaniesIdBillingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminCompaniesIdBilling({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminCompaniesIdCreditsQueryKey = (options: Options<GetAdminCompaniesIdCreditsData>) =>
    createQueryKey('getAdminCompaniesIdCredits', options, false, ['AdminBilling'])

/**
 * GET /api/admin/companies/[id]/credits — current credit wallet balance (SuperAdmin).
 *
 * Fetch included, pack, and available credits for a company.
 */
export const getAdminCompaniesIdCreditsOptions = (options: Options<GetAdminCompaniesIdCreditsData>) =>
    queryOptions<
        GetAdminCompaniesIdCreditsResponse,
        AxiosError<GetAdminCompaniesIdCreditsError>,
        GetAdminCompaniesIdCreditsResponse,
        ReturnType<typeof getAdminCompaniesIdCreditsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminCompaniesIdCredits({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminCompaniesIdCreditsQueryKey(options),
    })

/**
 * POST /api/admin/companies/[id]/credits — grant credits to a company wallet (SuperAdmin).
 *
 * Grant included or pack credits to a company. Blocked for expired plans.
 */
export const postAdminCompaniesIdCreditsMutation = (
    options?: Partial<Options<PostAdminCompaniesIdCreditsData>>
): UseMutationOptions<PostAdminCompaniesIdCreditsResponse, AxiosError<PostAdminCompaniesIdCreditsError>, Options<PostAdminCompaniesIdCreditsData>> => {
    const mutationOptions: UseMutationOptions<
        PostAdminCompaniesIdCreditsResponse,
        AxiosError<PostAdminCompaniesIdCreditsError>,
        Options<PostAdminCompaniesIdCreditsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminCompaniesIdCredits({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/admin/billing/plans/[id]/sync — push plan Product + Price to Stripe.
 *
 * Sync a paid billing plan's Product and Price to Stripe.
 */
export const postAdminBillingPlansIdSyncMutation = (
    options?: Partial<Options<PostAdminBillingPlansIdSyncData>>
): UseMutationOptions<PostAdminBillingPlansIdSyncResponse, AxiosError<PostAdminBillingPlansIdSyncError>, Options<PostAdminBillingPlansIdSyncData>> => {
    const mutationOptions: UseMutationOptions<
        PostAdminBillingPlansIdSyncResponse,
        AxiosError<PostAdminBillingPlansIdSyncError>,
        Options<PostAdminBillingPlansIdSyncData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminBillingPlansIdSync({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminCompaniesIdCreditsLedgerQueryKey = (options: Options<GetAdminCompaniesIdCreditsLedgerData>) =>
    createQueryKey('getAdminCompaniesIdCreditsLedger', options, false, ['AdminBilling'])

/**
 * GET /api/admin/companies/[id]/credits/ledger — credit wallet ledger history (SuperAdmin).
 *
 * Paginated credit ledger entries (additions and deductions) for a company. Excludes internal hold/hold_release rows.
 */
export const getAdminCompaniesIdCreditsLedgerOptions = (options: Options<GetAdminCompaniesIdCreditsLedgerData>) =>
    queryOptions<
        GetAdminCompaniesIdCreditsLedgerResponse,
        AxiosError<GetAdminCompaniesIdCreditsLedgerError>,
        GetAdminCompaniesIdCreditsLedgerResponse,
        ReturnType<typeof getAdminCompaniesIdCreditsLedgerQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminCompaniesIdCreditsLedger({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminCompaniesIdCreditsLedgerQueryKey(options),
    })

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] }
    if (page.body) {
        params.body = {
            ...(queryKey[0].body as any),
            ...(page.body as any),
        }
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers,
        }
    }
    if (page.path) {
        params.path = {
            ...(queryKey[0].path as any),
            ...(page.path as any),
        }
    }
    if (page.query) {
        params.query = {
            ...(queryKey[0].query as any),
            ...(page.query as any),
        }
    }
    return params as unknown as typeof page
}

export const getAdminCompaniesIdCreditsLedgerInfiniteQueryKey = (
    options: Options<GetAdminCompaniesIdCreditsLedgerData>
): QueryKey<Options<GetAdminCompaniesIdCreditsLedgerData>> => createQueryKey('getAdminCompaniesIdCreditsLedger', options, true)

/**
 * GET /api/admin/companies/[id]/credits/ledger — credit wallet ledger history (SuperAdmin).
 *
 * Paginated credit ledger entries (additions and deductions) for a company. Excludes internal hold/hold_release rows.
 */
export const getAdminCompaniesIdCreditsLedgerInfiniteOptions = (options: Options<GetAdminCompaniesIdCreditsLedgerData>) => {
    const opts = infiniteQueryOptions<
        GetAdminCompaniesIdCreditsLedgerResponse,
        AxiosError<GetAdminCompaniesIdCreditsLedgerError>,
        InfiniteData<GetAdminCompaniesIdCreditsLedgerResponse>,
        QueryKey<Options<GetAdminCompaniesIdCreditsLedgerData>>,
        number | Pick<QueryKey<Options<GetAdminCompaniesIdCreditsLedgerData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetAdminCompaniesIdCreditsLedgerData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getAdminCompaniesIdCreditsLedger({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getAdminCompaniesIdCreditsLedgerInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * POST /api/admin/companies/[id]/integrations/[integrationId]/reencrypt — move a legacy-encrypted integration secret to Cloud KMS (SuperAdmin).
 *
 * Decrypts the secret with the legacy master key, re-encrypts it with Cloud KMS and verifies the round trip before saving. KMS rows are returned unchanged. The secret is never returned.
 */
export const postAdminCompaniesIdIntegrationsIntegrationIdReencryptMutation = (
    options?: Partial<Options<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData>>
): UseMutationOptions<
    PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponse,
    AxiosError<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptError>,
    Options<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData>
> => {
    const mutationOptions: UseMutationOptions<
        PostAdminCompaniesIdIntegrationsIntegrationIdReencryptResponse,
        AxiosError<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptError>,
        Options<PostAdminCompaniesIdIntegrationsIntegrationIdReencryptData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminCompaniesIdIntegrationsIntegrationIdReencrypt({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminInterviewQualityReportsQueryKey = (options?: Options<GetAdminInterviewQualityReportsData>) =>
    createQueryKey('getAdminInterviewQualityReports', options, false, ['AdminInterviewQuality'])

/**
 * GET /api/admin/interview-quality/reports — interview quality reports across all companies (SuperAdmin).
 *
 * Paginated, newest first. Cross-tenant on purpose: `companyId` is an optional filter. Issue filters (category, severity, source, triageStatus) match reports with at least one such issue.
 */
export const getAdminInterviewQualityReportsOptions = (options?: Options<GetAdminInterviewQualityReportsData>) =>
    queryOptions<
        GetAdminInterviewQualityReportsResponse,
        AxiosError<GetAdminInterviewQualityReportsError>,
        GetAdminInterviewQualityReportsResponse,
        ReturnType<typeof getAdminInterviewQualityReportsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminInterviewQualityReports({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminInterviewQualityReportsQueryKey(options),
    })

export const getAdminInterviewQualityReportsInfiniteQueryKey = (
    options?: Options<GetAdminInterviewQualityReportsData>
): QueryKey<Options<GetAdminInterviewQualityReportsData>> => createQueryKey('getAdminInterviewQualityReports', options, true)

/**
 * GET /api/admin/interview-quality/reports — interview quality reports across all companies (SuperAdmin).
 *
 * Paginated, newest first. Cross-tenant on purpose: `companyId` is an optional filter. Issue filters (category, severity, source, triageStatus) match reports with at least one such issue.
 */
export const getAdminInterviewQualityReportsInfiniteOptions = (options?: Options<GetAdminInterviewQualityReportsData>) => {
    const opts = infiniteQueryOptions<
        GetAdminInterviewQualityReportsResponse,
        AxiosError<GetAdminInterviewQualityReportsError>,
        InfiniteData<GetAdminInterviewQualityReportsResponse>,
        QueryKey<Options<GetAdminInterviewQualityReportsData>>,
        number | Pick<QueryKey<Options<GetAdminInterviewQualityReportsData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetAdminInterviewQualityReportsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getAdminInterviewQualityReports({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getAdminInterviewQualityReportsInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * POST /api/admin/interview-quality/resolve — find the AI interviews an id, link or candidate points to (SuperAdmin).
 *
 * Cross-tenant. With `jobId` + `candidate`: the AI screenings of the application with that email (case-insensitive) or phone (same digits) in the job — email + job is unique. Otherwise `input`: a bare number is an Interview id; `web:123` / `phone:456` a web / phone screening id; else `interviewId=`, `screeningId=` / `screeningInterviewId=`, `screeningCallId=`, `roomToken=` (candidate link), `applicationId=` (all AI screenings of the application). Empty `matches` when nothing is found.
 */
export const postAdminInterviewQualityResolveMutation = (
    options?: Partial<Options<PostAdminInterviewQualityResolveData>>
): UseMutationOptions<
    PostAdminInterviewQualityResolveResponse,
    AxiosError<PostAdminInterviewQualityResolveError>,
    Options<PostAdminInterviewQualityResolveData>
> => {
    const mutationOptions: UseMutationOptions<
        PostAdminInterviewQualityResolveResponse,
        AxiosError<PostAdminInterviewQualityResolveError>,
        Options<PostAdminInterviewQualityResolveData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminInterviewQualityResolve({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminInterviewQualityRunsQueryKey = (options?: Options<GetAdminInterviewQualityRunsData>) =>
    createQueryKey('getAdminInterviewQualityRuns', options, false, ['AdminInterviewQuality'])

/**
 * GET /api/admin/interview-quality/runs — recent manual interview quality runs (SuperAdmin).
 *
 * Newest first, with status, report id and issue count once finished.
 */
export const getAdminInterviewQualityRunsOptions = (options?: Options<GetAdminInterviewQualityRunsData>) =>
    queryOptions<
        GetAdminInterviewQualityRunsResponse,
        AxiosError<GetAdminInterviewQualityRunsError>,
        GetAdminInterviewQualityRunsResponse,
        ReturnType<typeof getAdminInterviewQualityRunsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminInterviewQualityRuns({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminInterviewQualityRunsQueryKey(options),
    })

export const getAdminInterviewQualityRunsInfiniteQueryKey = (
    options?: Options<GetAdminInterviewQualityRunsData>
): QueryKey<Options<GetAdminInterviewQualityRunsData>> => createQueryKey('getAdminInterviewQualityRuns', options, true)

/**
 * GET /api/admin/interview-quality/runs — recent manual interview quality runs (SuperAdmin).
 *
 * Newest first, with status, report id and issue count once finished.
 */
export const getAdminInterviewQualityRunsInfiniteOptions = (options?: Options<GetAdminInterviewQualityRunsData>) => {
    const opts = infiniteQueryOptions<
        GetAdminInterviewQualityRunsResponse,
        AxiosError<GetAdminInterviewQualityRunsError>,
        InfiniteData<GetAdminInterviewQualityRunsResponse>,
        QueryKey<Options<GetAdminInterviewQualityRunsData>>,
        number | Pick<QueryKey<Options<GetAdminInterviewQualityRunsData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetAdminInterviewQualityRunsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getAdminInterviewQualityRuns({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getAdminInterviewQualityRunsInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * POST /api/admin/interview-quality/runs — analyze an interview now (SuperAdmin).
 *
 * Creates a PENDING run and asks talent-ai to start the analysis (regardless of the company flag). If talent-ai can't be reached the run is returned as FAILED with the error. 404 for an unknown interview, 400 when it has no AI screening.
 */
export const postAdminInterviewQualityRunsMutation = (
    options?: Partial<Options<PostAdminInterviewQualityRunsData>>
): UseMutationOptions<PostAdminInterviewQualityRunsResponse, AxiosError<PostAdminInterviewQualityRunsError>, Options<PostAdminInterviewQualityRunsData>> => {
    const mutationOptions: UseMutationOptions<
        PostAdminInterviewQualityRunsResponse,
        AxiosError<PostAdminInterviewQualityRunsError>,
        Options<PostAdminInterviewQualityRunsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAdminInterviewQualityRuns({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/admin/interview-quality/issues/[id] — triage one interview quality issue (SuperAdmin).
 *
 * Sets the triage status (Confirmed / False positive / Fixed / Open) and note; records who triaged it and when.
 */
export const patchAdminInterviewQualityIssuesIdMutation = (
    options?: Partial<Options<PatchAdminInterviewQualityIssuesIdData>>
): UseMutationOptions<
    PatchAdminInterviewQualityIssuesIdResponse,
    AxiosError<PatchAdminInterviewQualityIssuesIdError>,
    Options<PatchAdminInterviewQualityIssuesIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchAdminInterviewQualityIssuesIdResponse,
        AxiosError<PatchAdminInterviewQualityIssuesIdError>,
        Options<PatchAdminInterviewQualityIssuesIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchAdminInterviewQualityIssuesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAdminInterviewQualityReportsIdQueryKey = (options: Options<GetAdminInterviewQualityReportsIdData>) =>
    createQueryKey('getAdminInterviewQualityReportsId', options, false, ['AdminInterviewQuality'])

/**
 * GET /api/admin/interview-quality/reports/[id] — one interview quality report with its issues (SuperAdmin).
 *
 * Report, issues (most severe first) and an interview summary: channel, date, recording URL and the candidate report link.
 */
export const getAdminInterviewQualityReportsIdOptions = (options: Options<GetAdminInterviewQualityReportsIdData>) =>
    queryOptions<
        GetAdminInterviewQualityReportsIdResponse,
        AxiosError<GetAdminInterviewQualityReportsIdError>,
        GetAdminInterviewQualityReportsIdResponse,
        ReturnType<typeof getAdminInterviewQualityReportsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAdminInterviewQualityReportsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAdminInterviewQualityReportsIdQueryKey(options),
    })

export const postAnalyticsAgentMutation = (
    options?: Partial<Options<PostAnalyticsAgentData>>
): UseMutationOptions<PostAnalyticsAgentResponse, AxiosError<PostAnalyticsAgentError>, Options<PostAnalyticsAgentData>> => {
    const mutationOptions: UseMutationOptions<PostAnalyticsAgentResponse, AxiosError<PostAnalyticsAgentError>, Options<PostAnalyticsAgentData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAnalyticsAgent({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postAnalyticsAgentStreamMutation = (
    options?: Partial<Options<PostAnalyticsAgentStreamData>>
): UseMutationOptions<PostAnalyticsAgentStreamResponse, AxiosError<PostAnalyticsAgentStreamError>, Options<PostAnalyticsAgentStreamData>> => {
    const mutationOptions: UseMutationOptions<
        PostAnalyticsAgentStreamResponse,
        AxiosError<PostAnalyticsAgentStreamError>,
        Options<PostAnalyticsAgentStreamData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAnalyticsAgentStream({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getApplicationsSearchQueryKey = (options?: Options<GetApplicationsSearchData>) =>
    createQueryKey('getApplicationsSearch', options, false, ['Applications'])

export const getApplicationsSearchOptions = (options?: Options<GetApplicationsSearchData>) =>
    queryOptions<
        GetApplicationsSearchResponse,
        AxiosError<GetApplicationsSearchError>,
        GetApplicationsSearchResponse,
        ReturnType<typeof getApplicationsSearchQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getApplicationsSearch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getApplicationsSearchQueryKey(options),
    })

export const getAssessmentParamsQueryKey = (options: Options<GetAssessmentParamsData>) => createQueryKey('getAssessmentParams', options, false, ['Assessment'])

/**
 * GET /api/assessment/params
 *
 * List assessment parameters (competencies) for a company
 */
export const getAssessmentParamsOptions = (options: Options<GetAssessmentParamsData>) =>
    queryOptions<
        GetAssessmentParamsResponse,
        AxiosError<GetAssessmentParamsError>,
        GetAssessmentParamsResponse,
        ReturnType<typeof getAssessmentParamsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssessmentParams({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAssessmentParamsQueryKey(options),
    })

export const getAssessmentParamsInfiniteQueryKey = (options: Options<GetAssessmentParamsData>): QueryKey<Options<GetAssessmentParamsData>> =>
    createQueryKey('getAssessmentParams', options, true)

/**
 * GET /api/assessment/params
 *
 * List assessment parameters (competencies) for a company
 */
export const getAssessmentParamsInfiniteOptions = (options: Options<GetAssessmentParamsData>) => {
    const opts = infiniteQueryOptions<
        GetAssessmentParamsResponse,
        AxiosError<GetAssessmentParamsError>,
        InfiniteData<GetAssessmentParamsResponse>,
        QueryKey<Options<GetAssessmentParamsData>>,
        string | Pick<QueryKey<Options<GetAssessmentParamsData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetAssessmentParamsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getAssessmentParams({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getAssessmentParamsInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * POST /api/assessment/params
 *
 * Create an assessment parameter (competency) with optional per-channel questions (template-save rules apply)
 */
export const postAssessmentParamsMutation = (
    options?: Partial<Options<PostAssessmentParamsData>>
): UseMutationOptions<PostAssessmentParamsResponse, AxiosError<PostAssessmentParamsError>, Options<PostAssessmentParamsData>> => {
    const mutationOptions: UseMutationOptions<PostAssessmentParamsResponse, AxiosError<PostAssessmentParamsError>, Options<PostAssessmentParamsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAssessmentParams({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAssessmentTemplatesQueryKey = (options: Options<GetAssessmentTemplatesData>) =>
    createQueryKey('getAssessmentTemplates', options, false, ['Assessment'])

/**
 * GET /api/assessment/templates
 *
 * List assessment templates for a company
 */
export const getAssessmentTemplatesOptions = (options: Options<GetAssessmentTemplatesData>) =>
    queryOptions<
        GetAssessmentTemplatesResponse,
        AxiosError<GetAssessmentTemplatesError>,
        GetAssessmentTemplatesResponse,
        ReturnType<typeof getAssessmentTemplatesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssessmentTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAssessmentTemplatesQueryKey(options),
    })

export const getAssessmentTemplatesInfiniteQueryKey = (options: Options<GetAssessmentTemplatesData>): QueryKey<Options<GetAssessmentTemplatesData>> =>
    createQueryKey('getAssessmentTemplates', options, true)

/**
 * GET /api/assessment/templates
 *
 * List assessment templates for a company
 */
export const getAssessmentTemplatesInfiniteOptions = (options: Options<GetAssessmentTemplatesData>) => {
    const opts = infiniteQueryOptions<
        GetAssessmentTemplatesResponse,
        AxiosError<GetAssessmentTemplatesError>,
        InfiniteData<GetAssessmentTemplatesResponse>,
        QueryKey<Options<GetAssessmentTemplatesData>>,
        string | Pick<QueryKey<Options<GetAssessmentTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetAssessmentTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getAssessmentTemplates({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getAssessmentTemplatesInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * POST /api/assessment/templates
 *
 * Create a new assessment template for a company
 */
export const postAssessmentTemplatesMutation = (
    options?: Partial<Options<PostAssessmentTemplatesData>>
): UseMutationOptions<PostAssessmentTemplatesResponse, AxiosError<PostAssessmentTemplatesError>, Options<PostAssessmentTemplatesData>> => {
    const mutationOptions: UseMutationOptions<
        PostAssessmentTemplatesResponse,
        AxiosError<PostAssessmentTemplatesError>,
        Options<PostAssessmentTemplatesData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAssessmentTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/assessment/params/{id}
 *
 * Delete an assessment parameter (409 when linked to an assessment template)
 */
export const deleteAssessmentParamsIdMutation = (
    options?: Partial<Options<DeleteAssessmentParamsIdData>>
): UseMutationOptions<DeleteAssessmentParamsIdResponse, AxiosError<DeleteAssessmentParamsIdError>, Options<DeleteAssessmentParamsIdData>> => {
    const mutationOptions: UseMutationOptions<
        DeleteAssessmentParamsIdResponse,
        AxiosError<DeleteAssessmentParamsIdError>,
        Options<DeleteAssessmentParamsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAssessmentParamsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAssessmentParamsIdQueryKey = (options: Options<GetAssessmentParamsIdData>) =>
    createQueryKey('getAssessmentParamsId', options, false, ['Assessment'])

/**
 * GET /api/assessment/params/{id}
 *
 * Fetch a single assessment parameter (competency) with its linked template/job usage
 */
export const getAssessmentParamsIdOptions = (options: Options<GetAssessmentParamsIdData>) =>
    queryOptions<
        GetAssessmentParamsIdResponse,
        AxiosError<GetAssessmentParamsIdError>,
        GetAssessmentParamsIdResponse,
        ReturnType<typeof getAssessmentParamsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssessmentParamsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAssessmentParamsIdQueryKey(options),
    })

/**
 * PUT /api/assessment/params/{id}
 *
 * Update an assessment parameter (competency). Scoped to the company in the body — cross-company ids return 404. Per-channel Q&A follows the template-save rules (400 on a missing or too-short question).
 */
export const putAssessmentParamsIdMutation = (
    options?: Partial<Options<PutAssessmentParamsIdData>>
): UseMutationOptions<PutAssessmentParamsIdResponse, AxiosError<PutAssessmentParamsIdError>, Options<PutAssessmentParamsIdData>> => {
    const mutationOptions: UseMutationOptions<PutAssessmentParamsIdResponse, AxiosError<PutAssessmentParamsIdError>, Options<PutAssessmentParamsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAssessmentParamsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/assessment/templates/{id}
 *
 * Delete an assessment template (409 when linked to job postings)
 */
export const deleteAssessmentTemplatesIdMutation = (
    options?: Partial<Options<DeleteAssessmentTemplatesIdData>>
): UseMutationOptions<DeleteAssessmentTemplatesIdResponse, AxiosError<DeleteAssessmentTemplatesIdError>, Options<DeleteAssessmentTemplatesIdData>> => {
    const mutationOptions: UseMutationOptions<
        DeleteAssessmentTemplatesIdResponse,
        AxiosError<DeleteAssessmentTemplatesIdError>,
        Options<DeleteAssessmentTemplatesIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteAssessmentTemplatesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAssessmentTemplatesIdQueryKey = (options: Options<GetAssessmentTemplatesIdData>) =>
    createQueryKey('getAssessmentTemplatesId', options, false, ['Assessment'])

/**
 * GET /api/assessment/templates/{id}
 *
 * Fetch a single assessment template including linked job count
 */
export const getAssessmentTemplatesIdOptions = (options: Options<GetAssessmentTemplatesIdData>) =>
    queryOptions<
        GetAssessmentTemplatesIdResponse,
        AxiosError<GetAssessmentTemplatesIdError>,
        GetAssessmentTemplatesIdResponse,
        ReturnType<typeof getAssessmentTemplatesIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAssessmentTemplatesId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAssessmentTemplatesIdQueryKey(options),
    })

/**
 * PUT /api/assessment/templates/{id}
 *
 * Update an assessment template. When `AssessmentParameters` is omitted, every existing link is removed — the frontend always sends the full list.
 */
export const putAssessmentTemplatesIdMutation = (
    options?: Partial<Options<PutAssessmentTemplatesIdData>>
): UseMutationOptions<PutAssessmentTemplatesIdResponse, AxiosError<PutAssessmentTemplatesIdError>, Options<PutAssessmentTemplatesIdData>> => {
    const mutationOptions: UseMutationOptions<
        PutAssessmentTemplatesIdResponse,
        AxiosError<PutAssessmentTemplatesIdError>,
        Options<PutAssessmentTemplatesIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAssessmentTemplatesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/assessment/params/{id}/copy
 *
 * Copy a competency under a new name — its definition, every channel's Q&A and question sources (template links are not copied). 409 when the name is taken.
 */
export const postAssessmentParamsIdCopyMutation = (
    options?: Partial<Options<PostAssessmentParamsIdCopyData>>
): UseMutationOptions<PostAssessmentParamsIdCopyResponse, AxiosError<PostAssessmentParamsIdCopyError>, Options<PostAssessmentParamsIdCopyData>> => {
    const mutationOptions: UseMutationOptions<
        PostAssessmentParamsIdCopyResponse,
        AxiosError<PostAssessmentParamsIdCopyError>,
        Options<PostAssessmentParamsIdCopyData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAssessmentParamsIdCopy({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAuthLogoutCallbackQueryKey = (options?: Options<GetAuthLogoutCallbackData>) => createQueryKey('getAuthLogoutCallback', options, false, ['Auth'])

/**
 * Public logout callback endpoint.
 */
export const getAuthLogoutCallbackOptions = (options?: Options<GetAuthLogoutCallbackData>) =>
    queryOptions<unknown, AxiosError<GetAuthLogoutCallbackError>, unknown, ReturnType<typeof getAuthLogoutCallbackQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAuthLogoutCallback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAuthLogoutCallbackQueryKey(options),
    })

export const getAuthMyCompaniesQueryKey = (options?: Options<GetAuthMyCompaniesData>) => createQueryKey('getAuthMyCompanies', options, false, ['Auth'])

/**
 * GET /api/auth/my-companies — organizations the signed-in user belongs to.
 *
 * Lists the user's active memberships on non-archived companies, for the company picker.
 */
export const getAuthMyCompaniesOptions = (options?: Options<GetAuthMyCompaniesData>) =>
    queryOptions<GetAuthMyCompaniesResponse, AxiosError<GetAuthMyCompaniesError>, GetAuthMyCompaniesResponse, ReturnType<typeof getAuthMyCompaniesQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAuthMyCompanies({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAuthMyCompaniesQueryKey(options),
    })

export const getAuthProfileQueryKey = (options: Options<GetAuthProfileData>) => createQueryKey('getAuthProfile', options, false, ['Auth'])

/**
 * GET /api/auth/profile?companySlug=… — current user name, email, picture (session + Auth0).
 */
export const getAuthProfileOptions = (options: Options<GetAuthProfileData>) =>
    queryOptions<GetAuthProfileResponse, AxiosError<GetAuthProfileError>, GetAuthProfileResponse, ReturnType<typeof getAuthProfileQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAuthProfile({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAuthProfileQueryKey(options),
    })

/**
 * PUT /api/auth/profile?companySlug=… — multipart: optional `name`, optional `avatar` file.
 */
export const putAuthProfileMutation = (
    options?: Partial<Options<PutAuthProfileData>>
): UseMutationOptions<PutAuthProfileResponse, AxiosError<PutAuthProfileError>, Options<PutAuthProfileData>> => {
    const mutationOptions: UseMutationOptions<PutAuthProfileResponse, AxiosError<PutAuthProfileError>, Options<PutAuthProfileData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putAuthProfile({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/auth/set-company — set the active company on the user's session.
 *
 * Verifies the user belongs to the company, then injects companyId and roles into the Auth0 session cookie.
 */
export const postAuthSetCompanyMutation = (
    options?: Partial<Options<PostAuthSetCompanyData>>
): UseMutationOptions<PostAuthSetCompanyResponse, AxiosError<PostAuthSetCompanyError>, Options<PostAuthSetCompanyData>> => {
    const mutationOptions: UseMutationOptions<PostAuthSetCompanyResponse, AxiosError<PostAuthSetCompanyError>, Options<PostAuthSetCompanyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postAuthSetCompany({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getAuthSwitchCompanyQueryKey = (options?: Options<GetAuthSwitchCompanyData>) => createQueryKey('getAuthSwitchCompany', options, false, ['Auth'])

export const getAuthSwitchCompanyOptions = (options?: Options<GetAuthSwitchCompanyData>) =>
    queryOptions<unknown, AxiosError<GetAuthSwitchCompanyError>, unknown, ReturnType<typeof getAuthSwitchCompanyQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAuthSwitchCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getAuthSwitchCompanyQueryKey(options),
    })

/**
 * POST /api/billing/change-plan
 *
 * Upgrade the company plan via Checkout (freemium) or subscription update (paid).
 */
export const postBillingChangePlanMutation = (
    options?: Partial<Options<PostBillingChangePlanData>>
): UseMutationOptions<PostBillingChangePlanResponse, AxiosError<PostBillingChangePlanError>, Options<PostBillingChangePlanData>> => {
    const mutationOptions: UseMutationOptions<PostBillingChangePlanResponse, AxiosError<PostBillingChangePlanError>, Options<PostBillingChangePlanData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postBillingChangePlan({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/billing/complete-checkout
 *
 * Apply upgrade or credit-pack Checkout session to the company billing state.
 */
export const postBillingCompleteCheckoutMutation = (
    options?: Partial<Options<PostBillingCompleteCheckoutData>>
): UseMutationOptions<PostBillingCompleteCheckoutResponse, AxiosError<PostBillingCompleteCheckoutError>, Options<PostBillingCompleteCheckoutData>> => {
    const mutationOptions: UseMutationOptions<
        PostBillingCompleteCheckoutResponse,
        AxiosError<PostBillingCompleteCheckoutError>,
        Options<PostBillingCompleteCheckoutData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postBillingCompleteCheckout({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/billing/credit-packs
 */
export const postBillingCreditPacksMutation = (
    options?: Partial<Options<PostBillingCreditPacksData>>
): UseMutationOptions<unknown, AxiosError<PostBillingCreditPacksError>, Options<PostBillingCreditPacksData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostBillingCreditPacksError>, Options<PostBillingCreditPacksData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postBillingCreditPacks({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getBillingPlansQueryKey = (options?: Options<GetBillingPlansData>) => createQueryKey('getBillingPlans', options, false, ['Billing'])

/**
 * GET /api/billing/plans?companySlug=…
 *
 * List public billing plans relative to the company's current plan.
 */
export const getBillingPlansOptions = (options?: Options<GetBillingPlansData>) =>
    queryOptions<GetBillingPlansResponse, AxiosError<GetBillingPlansError>, GetBillingPlansResponse, ReturnType<typeof getBillingPlansQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBillingPlans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getBillingPlansQueryKey(options),
    })

/**
 * POST /api/billing/portal
 *
 * Create a Stripe Billing Portal session for the company.
 */
export const postBillingPortalMutation = (
    options?: Partial<Options<PostBillingPortalData>>
): UseMutationOptions<PostBillingPortalResponse, AxiosError<PostBillingPortalError>, Options<PostBillingPortalData>> => {
    const mutationOptions: UseMutationOptions<PostBillingPortalResponse, AxiosError<PostBillingPortalError>, Options<PostBillingPortalData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postBillingPortal({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getBillingSubscriptionQueryKey = (options?: Options<GetBillingSubscriptionData>) =>
    createQueryKey('getBillingSubscription', options, false, ['Billing'])

/**
 * GET /api/billing/subscription?companySlug=…
 *
 * Fetch the current company's billing subscription and plan summary.
 */
export const getBillingSubscriptionOptions = (options?: Options<GetBillingSubscriptionData>) =>
    queryOptions<
        GetBillingSubscriptionResponse,
        AxiosError<GetBillingSubscriptionError>,
        GetBillingSubscriptionResponse,
        ReturnType<typeof getBillingSubscriptionQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBillingSubscription({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getBillingSubscriptionQueryKey(options),
    })

export const getBillingUsageQueryKey = (options?: Options<GetBillingUsageData>) => createQueryKey('getBillingUsage', options, false, ['Billing'])

/**
 * GET /api/billing/usage?companySlug=…
 *
 * Fetch current plan limits and usage counters for the company.
 */
export const getBillingUsageOptions = (options?: Options<GetBillingUsageData>) =>
    queryOptions<GetBillingUsageResponse, AxiosError<GetBillingUsageError>, GetBillingUsageResponse, ReturnType<typeof getBillingUsageQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getBillingUsage({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getBillingUsageQueryKey(options),
    })

export const postCalendarMutation = (
    options?: Partial<Options<PostCalendarData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarError>, Options<PostCalendarData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarError>, Options<PostCalendarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendar({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putCalendarMutation = (
    options?: Partial<Options<PutCalendarData>>
): UseMutationOptions<unknown, AxiosError<PutCalendarError>, Options<PutCalendarData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutCalendarError>, Options<PutCalendarData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCalendar({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCalendarAvailabilityMutation = (
    options?: Partial<Options<PostCalendarAvailabilityData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarAvailabilityError>, Options<PostCalendarAvailabilityData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarAvailabilityError>, Options<PostCalendarAvailabilityData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendarAvailability({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const patchCalendarGenerateTranscriptMutation = (
    options?: Partial<Options<PatchCalendarGenerateTranscriptData>>
): UseMutationOptions<unknown, AxiosError<PatchCalendarGenerateTranscriptError>, Options<PatchCalendarGenerateTranscriptData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchCalendarGenerateTranscriptError>, Options<PatchCalendarGenerateTranscriptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCalendarGenerateTranscript({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCalendarGenerateTranscriptMutation = (
    options?: Partial<Options<PostCalendarGenerateTranscriptData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarGenerateTranscriptError>, Options<PostCalendarGenerateTranscriptData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarGenerateTranscriptError>, Options<PostCalendarGenerateTranscriptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendarGenerateTranscript({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCalendarPanelistSlotsMutation = (
    options?: Partial<Options<PostCalendarPanelistSlotsData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarPanelistSlotsError>, Options<PostCalendarPanelistSlotsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarPanelistSlotsError>, Options<PostCalendarPanelistSlotsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendarPanelistSlots({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCalendarSchedulingSlotsMutation = (
    options?: Partial<Options<PostCalendarSchedulingSlotsData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarSchedulingSlotsError>, Options<PostCalendarSchedulingSlotsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarSchedulingSlotsError>, Options<PostCalendarSchedulingSlotsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendarSchedulingSlots({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCalendarPanelistSlotsCommentsMutation = (
    options?: Partial<Options<PostCalendarPanelistSlotsCommentsData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarPanelistSlotsCommentsError>, Options<PostCalendarPanelistSlotsCommentsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarPanelistSlotsCommentsError>, Options<PostCalendarPanelistSlotsCommentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendarPanelistSlotsComments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCalendarPanelistSlotsGenerateMutation = (
    options?: Partial<Options<PostCalendarPanelistSlotsGenerateData>>
): UseMutationOptions<unknown, AxiosError<PostCalendarPanelistSlotsGenerateError>, Options<PostCalendarPanelistSlotsGenerateData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCalendarPanelistSlotsGenerateError>, Options<PostCalendarPanelistSlotsGenerateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCalendarPanelistSlotsGenerate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCandidateSharingSharingSlugQueryKey = (options: Options<GetCandidateSharingSharingSlugData>) =>
    createQueryKey('getCandidateSharingSharingSlug', options, false, ['Candidate-sharing'])

export const getCandidateSharingSharingSlugOptions = (options: Options<GetCandidateSharingSharingSlugData>) =>
    queryOptions<unknown, AxiosError<GetCandidateSharingSharingSlugError>, unknown, ReturnType<typeof getCandidateSharingSharingSlugQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCandidateSharingSharingSlug({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCandidateSharingSharingSlugQueryKey(options),
    })

export const putCandidateSharingSharingSlugFeedbackMutation = (
    options?: Partial<Options<PutCandidateSharingSharingSlugFeedbackData>>
): UseMutationOptions<unknown, AxiosError<PutCandidateSharingSharingSlugFeedbackError>, Options<PutCandidateSharingSharingSlugFeedbackData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PutCandidateSharingSharingSlugFeedbackError>,
        Options<PutCandidateSharingSharingSlugFeedbackData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidateSharingSharingSlugFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCandidatesQueryKey = (options?: Options<GetCandidatesData>) => createQueryKey('getCandidates', options, false, ['Candidates'])

/**
 * GET /api/candidates
 *
 * List candidates for the session company (talent pool). Free text goes in `filterModel.quickFilterValues`; the legacy vector search is the default unless `useLegacySearch=false` selects the new search.
 */
export const getCandidatesOptions = (options?: Options<GetCandidatesData>) =>
    queryOptions<GetCandidatesResponse, AxiosError<GetCandidatesError>, GetCandidatesResponse, ReturnType<typeof getCandidatesQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCandidatesQueryKey(options),
    })

export const getCandidatesInfiniteQueryKey = (options?: Options<GetCandidatesData>): QueryKey<Options<GetCandidatesData>> =>
    createQueryKey('getCandidates', options, true)

/**
 * GET /api/candidates
 *
 * List candidates for the session company (talent pool). Free text goes in `filterModel.quickFilterValues`; the legacy vector search is the default unless `useLegacySearch=false` selects the new search.
 */
export const getCandidatesInfiniteOptions = (options?: Options<GetCandidatesData>) => {
    const opts = infiniteQueryOptions<
        GetCandidatesResponse,
        AxiosError<GetCandidatesError>,
        InfiniteData<GetCandidatesResponse>,
        QueryKey<Options<GetCandidatesData>>,
        string | Pick<QueryKey<Options<GetCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getCandidates({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getCandidatesInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * TODO: Make it generic so other integrations can also use it.
 */
export const postCandidatesMutation = (
    options?: Partial<Options<PostCandidatesData>>
): UseMutationOptions<PostCandidatesResponse, AxiosError<PostCandidatesError>, Options<PostCandidatesData>> => {
    const mutationOptions: UseMutationOptions<PostCandidatesResponse, AxiosError<PostCandidatesError>, Options<PostCandidatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Deletes a candidate and their associated job application candidate details.
 */
export const deleteCandidatesIdMutation = (
    options?: Partial<Options<DeleteCandidatesIdData>>
): UseMutationOptions<unknown, AxiosError<DeleteCandidatesIdError>, Options<DeleteCandidatesIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteCandidatesIdError>, Options<DeleteCandidatesIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCandidatesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCandidatesIdQueryKey = (options: Options<GetCandidatesIdData>) => createQueryKey('getCandidatesId', options, false, ['Candidates'])

/**
 * GET API for fetching Candidates by id
 */
export const getCandidatesIdOptions = (options: Options<GetCandidatesIdData>) =>
    queryOptions<unknown, AxiosError<GetCandidatesIdError>, unknown, ReturnType<typeof getCandidatesIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCandidatesId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCandidatesIdQueryKey(options),
    })

export const putCandidatesIdMutation = (
    options?: Partial<Options<PutCandidatesIdData>>
): UseMutationOptions<unknown, AxiosError<PutCandidatesIdError>, Options<PutCandidatesIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutCandidatesIdError>, Options<PutCandidatesIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCandidatesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCandidatesBulkDeleteMutation = (
    options?: Partial<Options<PostCandidatesBulkDeleteData>>
): UseMutationOptions<PostCandidatesBulkDeleteResponse, AxiosError<PostCandidatesBulkDeleteError>, Options<PostCandidatesBulkDeleteData>> => {
    const mutationOptions: UseMutationOptions<
        PostCandidatesBulkDeleteResponse,
        AxiosError<PostCandidatesBulkDeleteError>,
        Options<PostCandidatesBulkDeleteData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesBulkDelete({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCandidatesParseQueryMutation = (
    options?: Partial<Options<PostCandidatesParseQueryData>>
): UseMutationOptions<PostCandidatesParseQueryResponse, AxiosError<PostCandidatesParseQueryError>, Options<PostCandidatesParseQueryData>> => {
    const mutationOptions: UseMutationOptions<
        PostCandidatesParseQueryResponse,
        AxiosError<PostCandidatesParseQueryError>,
        Options<PostCandidatesParseQueryData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCandidatesParseQuery({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getChatbotConfigQueryKey = (options?: Options<GetChatbotConfigData>) => createQueryKey('getChatbotConfig', options, false, ['Chatbot'])

export const getChatbotConfigOptions = (options?: Options<GetChatbotConfigData>) =>
    queryOptions<GetChatbotConfigResponse, AxiosError<GetChatbotConfigError>, GetChatbotConfigResponse, ReturnType<typeof getChatbotConfigQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getChatbotConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getChatbotConfigQueryKey(options),
    })

export const getCommunicationStatusEmailClientIdQueryKey = (options: Options<GetCommunicationStatusEmailClientIdData>) =>
    createQueryKey('getCommunicationStatusEmailClientId', options, false, ['Communication-status'])

/**
 * GET /api/communication-status/email/[clientId]?clientType=screening_interview
 */
export const getCommunicationStatusEmailClientIdOptions = (options: Options<GetCommunicationStatusEmailClientIdData>) =>
    queryOptions<unknown, AxiosError<GetCommunicationStatusEmailClientIdError>, unknown, ReturnType<typeof getCommunicationStatusEmailClientIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCommunicationStatusEmailClientId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCommunicationStatusEmailClientIdQueryKey(options),
    })

export const getCompanyQueryKey = (options?: Options<GetCompanyData>) => createQueryKey('getCompany', options, false, ['Company'])

export const getCompanyOptions = (options?: Options<GetCompanyData>) =>
    queryOptions<unknown, AxiosError<GetCompanyError>, unknown, ReturnType<typeof getCompanyQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyQueryKey(options),
    })

export const getCompanyConfigQueryKey = (options?: Options<GetCompanyConfigData>) => createQueryKey('getCompanyConfig', options, false, ['Company'])

/**
 * GET /api/company/config — fetch a company's full config row. SuperAdmin only (returns sensitive fields like twilioDetails).
 */
export const getCompanyConfigOptions = (options?: Options<GetCompanyConfigData>) =>
    queryOptions<unknown, AxiosError<GetCompanyConfigError>, unknown, ReturnType<typeof getCompanyConfigQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyConfigQueryKey(options),
    })

/**
 * POST /api/company/config — create a CompanyConfig with autoApprove + default approvers. SuperAdmin only.
 */
export const postCompanyConfigMutation = (
    options?: Partial<Options<PostCompanyConfigData>>
): UseMutationOptions<PostCompanyConfigResponse, AxiosError<PostCompanyConfigError>, Options<PostCompanyConfigData>> => {
    const mutationOptions: UseMutationOptions<PostCompanyConfigResponse, AxiosError<PostCompanyConfigError>, Options<PostCompanyConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PUT /api/company/config — update autoApprove/default approvers, or store Twilio subaccount details. SuperAdmin only.
 */
export const putCompanyConfigMutation = (
    options?: Partial<Options<PutCompanyConfigData>>
): UseMutationOptions<PutCompanyConfigResponse, AxiosError<PutCompanyConfigError>, Options<PutCompanyConfigData>> => {
    const mutationOptions: UseMutationOptions<PutCompanyConfigResponse, AxiosError<PutCompanyConfigError>, Options<PutCompanyConfigData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCompanyConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyDepartmentsQueryKey = (options?: Options<GetCompanyDepartmentsData>) =>
    createQueryKey('getCompanyDepartments', options, false, ['Company'])

/**
 * GET /api/company/departments — departments of the company that the signed-in user belongs to
 */
export const getCompanyDepartmentsOptions = (options?: Options<GetCompanyDepartmentsData>) =>
    queryOptions<
        GetCompanyDepartmentsResponse,
        AxiosError<GetCompanyDepartmentsError>,
        GetCompanyDepartmentsResponse,
        ReturnType<typeof getCompanyDepartmentsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyDepartments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyDepartmentsQueryKey(options),
    })

export const getCompanyEmploymentTypesQueryKey = (options?: Options<GetCompanyEmploymentTypesData>) =>
    createQueryKey('getCompanyEmploymentTypes', options, false, ['Company'])

export const getCompanyEmploymentTypesOptions = (options?: Options<GetCompanyEmploymentTypesData>) =>
    queryOptions<unknown, AxiosError<GetCompanyEmploymentTypesError>, unknown, ReturnType<typeof getCompanyEmploymentTypesQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyEmploymentTypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyEmploymentTypesQueryKey(options),
    })

/**
 * POST /api/company/grade
 *
 * Add a grade to the session company's available grades.
 */
export const postCompanyGradeMutation = (
    options?: Partial<Options<PostCompanyGradeData>>
): UseMutationOptions<PostCompanyGradeResponse, AxiosError<PostCompanyGradeError>, Options<PostCompanyGradeData>> => {
    const mutationOptions: UseMutationOptions<PostCompanyGradeResponse, AxiosError<PostCompanyGradeError>, Options<PostCompanyGradeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyGrade({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/title-grade
 *
 * Add a job title and its grades to the session company's job posting config.
 */
export const postCompanyTitleGradeMutation = (
    options?: Partial<Options<PostCompanyTitleGradeData>>
): UseMutationOptions<PostCompanyTitleGradeResponse, AxiosError<PostCompanyTitleGradeError>, Options<PostCompanyTitleGradeData>> => {
    const mutationOptions: UseMutationOptions<PostCompanyTitleGradeResponse, AxiosError<PostCompanyTitleGradeError>, Options<PostCompanyTitleGradeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyTitleGrade({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugAccessControlConfigQueryKey = (options: Options<GetCompanyCompanySlugAccessControlConfigData>) =>
    createQueryKey('getCompanyCompanySlugAccessControlConfig', options, false, ['Company'])

export const getCompanyCompanySlugAccessControlConfigOptions = (options: Options<GetCompanyCompanySlugAccessControlConfigData>) =>
    queryOptions<
        GetCompanyCompanySlugAccessControlConfigResponse,
        AxiosError<GetCompanyCompanySlugAccessControlConfigError>,
        GetCompanyCompanySlugAccessControlConfigResponse,
        ReturnType<typeof getCompanyCompanySlugAccessControlConfigQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugAccessControlConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugAccessControlConfigQueryKey(options),
    })

export const putCompanyCompanySlugAccessControlConfigMutation = (
    options?: Partial<Options<PutCompanyCompanySlugAccessControlConfigData>>
): UseMutationOptions<
    PutCompanyCompanySlugAccessControlConfigResponse,
    AxiosError<PutCompanyCompanySlugAccessControlConfigError>,
    Options<PutCompanyCompanySlugAccessControlConfigData>
> => {
    const mutationOptions: UseMutationOptions<
        PutCompanyCompanySlugAccessControlConfigResponse,
        AxiosError<PutCompanyCompanySlugAccessControlConfigError>,
        Options<PutCompanyCompanySlugAccessControlConfigData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCompanyCompanySlugAccessControlConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugApprovalFlowQueryKey = (options: Options<GetCompanyCompanySlugApprovalFlowData>) =>
    createQueryKey('getCompanyCompanySlugApprovalFlow', options, false, ['Company'])

export const getCompanyCompanySlugApprovalFlowOptions = (options: Options<GetCompanyCompanySlugApprovalFlowData>) =>
    queryOptions<
        GetCompanyCompanySlugApprovalFlowResponse,
        AxiosError<GetCompanyCompanySlugApprovalFlowError>,
        GetCompanyCompanySlugApprovalFlowResponse,
        ReturnType<typeof getCompanyCompanySlugApprovalFlowQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugApprovalFlow({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugApprovalFlowQueryKey(options),
    })

export const patchCompanyCompanySlugApprovalFlowMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugApprovalFlowData>>
): UseMutationOptions<
    PatchCompanyCompanySlugApprovalFlowResponse,
    AxiosError<PatchCompanyCompanySlugApprovalFlowError>,
    Options<PatchCompanyCompanySlugApprovalFlowData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugApprovalFlowResponse,
        AxiosError<PatchCompanyCompanySlugApprovalFlowError>,
        Options<PatchCompanyCompanySlugApprovalFlowData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugApprovalFlow({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCompanyCompanySlugApprovalFlowMutation = (
    options?: Partial<Options<PostCompanyCompanySlugApprovalFlowData>>
): UseMutationOptions<
    PostCompanyCompanySlugApprovalFlowResponse,
    AxiosError<PostCompanyCompanySlugApprovalFlowError>,
    Options<PostCompanyCompanySlugApprovalFlowData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugApprovalFlowResponse,
        AxiosError<PostCompanyCompanySlugApprovalFlowError>,
        Options<PostCompanyCompanySlugApprovalFlowData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugApprovalFlow({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugCandidateStatusesConfigQueryKey = (options: Options<GetCompanyCompanySlugCandidateStatusesConfigData>) =>
    createQueryKey('getCompanyCompanySlugCandidateStatusesConfig', options, false, ['Company'])

/**
 * GET: Read candidate statuses configuration (CRUD: Read)
 */
export const getCompanyCompanySlugCandidateStatusesConfigOptions = (options: Options<GetCompanyCompanySlugCandidateStatusesConfigData>) =>
    queryOptions<
        GetCompanyCompanySlugCandidateStatusesConfigResponse,
        AxiosError<GetCompanyCompanySlugCandidateStatusesConfigError>,
        GetCompanyCompanySlugCandidateStatusesConfigResponse,
        ReturnType<typeof getCompanyCompanySlugCandidateStatusesConfigQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugCandidateStatusesConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugCandidateStatusesConfigQueryKey(options),
    })

/**
 * POST: Create a new custom status (CRUD: Create)
 */
export const postCompanyCompanySlugCandidateStatusesConfigMutation = (
    options?: Partial<Options<PostCompanyCompanySlugCandidateStatusesConfigData>>
): UseMutationOptions<
    PostCompanyCompanySlugCandidateStatusesConfigResponse,
    AxiosError<PostCompanyCompanySlugCandidateStatusesConfigError>,
    Options<PostCompanyCompanySlugCandidateStatusesConfigData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugCandidateStatusesConfigResponse,
        AxiosError<PostCompanyCompanySlugCandidateStatusesConfigError>,
        Options<PostCompanyCompanySlugCandidateStatusesConfigData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugCandidateStatusesConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PUT: Bulk Update / Reorder status configuration (CRUD: Bulk Update)
 */
export const putCompanyCompanySlugCandidateStatusesConfigMutation = (
    options?: Partial<Options<PutCompanyCompanySlugCandidateStatusesConfigData>>
): UseMutationOptions<
    PutCompanyCompanySlugCandidateStatusesConfigResponse,
    AxiosError<PutCompanyCompanySlugCandidateStatusesConfigError>,
    Options<PutCompanyCompanySlugCandidateStatusesConfigData>
> => {
    const mutationOptions: UseMutationOptions<
        PutCompanyCompanySlugCandidateStatusesConfigResponse,
        AxiosError<PutCompanyCompanySlugCandidateStatusesConfigError>,
        Options<PutCompanyCompanySlugCandidateStatusesConfigData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCompanyCompanySlugCandidateStatusesConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/company/[companySlug]/departments
 *
 * Delete a department that has no blocking relations. Admin or SuperAdmin only.
 */
export const deleteCompanyCompanySlugDepartmentsMutation = (
    options?: Partial<Options<DeleteCompanyCompanySlugDepartmentsData>>
): UseMutationOptions<
    DeleteCompanyCompanySlugDepartmentsResponse,
    AxiosError<DeleteCompanyCompanySlugDepartmentsError>,
    Options<DeleteCompanyCompanySlugDepartmentsData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteCompanyCompanySlugDepartmentsResponse,
        AxiosError<DeleteCompanyCompanySlugDepartmentsError>,
        Options<DeleteCompanyCompanySlugDepartmentsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCompanyCompanySlugDepartments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugDepartmentsQueryKey = (options: Options<GetCompanyCompanySlugDepartmentsData>) =>
    createQueryKey('getCompanyCompanySlugDepartments', options, false, ['Company'])

/**
 * GET /api/company/[companySlug]/departments
 *
 * List the company's departments (seeding the defaults when it has none).
 */
export const getCompanyCompanySlugDepartmentsOptions = (options: Options<GetCompanyCompanySlugDepartmentsData>) =>
    queryOptions<
        GetCompanyCompanySlugDepartmentsResponse,
        AxiosError<GetCompanyCompanySlugDepartmentsError>,
        GetCompanyCompanySlugDepartmentsResponse,
        ReturnType<typeof getCompanyCompanySlugDepartmentsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugDepartments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugDepartmentsQueryKey(options),
    })

/**
 * PATCH /api/company/[companySlug]/departments
 *
 * Rename a department. Admin or SuperAdmin only.
 */
export const patchCompanyCompanySlugDepartmentsMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugDepartmentsData>>
): UseMutationOptions<
    PatchCompanyCompanySlugDepartmentsResponse,
    AxiosError<PatchCompanyCompanySlugDepartmentsError>,
    Options<PatchCompanyCompanySlugDepartmentsData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugDepartmentsResponse,
        AxiosError<PatchCompanyCompanySlugDepartmentsError>,
        Options<PatchCompanyCompanySlugDepartmentsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugDepartments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/[companySlug]/departments
 *
 * Create a department. Admin or SuperAdmin only.
 */
export const postCompanyCompanySlugDepartmentsMutation = (
    options?: Partial<Options<PostCompanyCompanySlugDepartmentsData>>
): UseMutationOptions<
    PostCompanyCompanySlugDepartmentsResponse,
    AxiosError<PostCompanyCompanySlugDepartmentsError>,
    Options<PostCompanyCompanySlugDepartmentsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugDepartmentsResponse,
        AxiosError<PostCompanyCompanySlugDepartmentsError>,
        Options<PostCompanyCompanySlugDepartmentsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugDepartments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugIntegrationsQueryKey = (options: Options<GetCompanyCompanySlugIntegrationsData>) =>
    createQueryKey('getCompanyCompanySlugIntegrations', options, false, ['Company'])

/**
 * GET /api/company/[companySlug]/integrations
 */
export const getCompanyCompanySlugIntegrationsOptions = (options: Options<GetCompanyCompanySlugIntegrationsData>) =>
    queryOptions<
        GetCompanyCompanySlugIntegrationsResponse,
        AxiosError<GetCompanyCompanySlugIntegrationsError>,
        GetCompanyCompanySlugIntegrationsResponse,
        ReturnType<typeof getCompanyCompanySlugIntegrationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugIntegrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugIntegrationsQueryKey(options),
    })

/**
 * PATCH /api/company/[companySlug]/integrations
 */
export const patchCompanyCompanySlugIntegrationsMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugIntegrationsData>>
): UseMutationOptions<
    PatchCompanyCompanySlugIntegrationsResponse,
    AxiosError<PatchCompanyCompanySlugIntegrationsError>,
    Options<PatchCompanyCompanySlugIntegrationsData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugIntegrationsResponse,
        AxiosError<PatchCompanyCompanySlugIntegrationsError>,
        Options<PatchCompanyCompanySlugIntegrationsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugIntegrations({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugJdTemplateQueryKey = (options: Options<GetCompanyCompanySlugJdTemplateData>) =>
    createQueryKey('getCompanyCompanySlugJdTemplate', options, false, ['Company'])

export const getCompanyCompanySlugJdTemplateOptions = (options: Options<GetCompanyCompanySlugJdTemplateData>) =>
    queryOptions<
        GetCompanyCompanySlugJdTemplateResponse,
        AxiosError<GetCompanyCompanySlugJdTemplateError>,
        GetCompanyCompanySlugJdTemplateResponse,
        ReturnType<typeof getCompanyCompanySlugJdTemplateQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugJdTemplate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugJdTemplateQueryKey(options),
    })

export const putCompanyCompanySlugJdTemplateMutation = (
    options?: Partial<Options<PutCompanyCompanySlugJdTemplateData>>
): UseMutationOptions<
    PutCompanyCompanySlugJdTemplateResponse,
    AxiosError<PutCompanyCompanySlugJdTemplateError>,
    Options<PutCompanyCompanySlugJdTemplateData>
> => {
    const mutationOptions: UseMutationOptions<
        PutCompanyCompanySlugJdTemplateResponse,
        AxiosError<PutCompanyCompanySlugJdTemplateError>,
        Options<PutCompanyCompanySlugJdTemplateData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCompanyCompanySlugJdTemplate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugJobPostingConfigQueryKey = (options: Options<GetCompanyCompanySlugJobPostingConfigData>) =>
    createQueryKey('getCompanyCompanySlugJobPostingConfig', options, false, ['Company'])

/**
 * GET /api/company/[companySlug]/job-posting-config
 *
 * The company's job posting field config (location/title modes and options, currency and country options). Needs the JOB_POSTING_CONFIG flag.
 */
export const getCompanyCompanySlugJobPostingConfigOptions = (options: Options<GetCompanyCompanySlugJobPostingConfigData>) =>
    queryOptions<
        GetCompanyCompanySlugJobPostingConfigResponse,
        AxiosError<GetCompanyCompanySlugJobPostingConfigError>,
        GetCompanyCompanySlugJobPostingConfigResponse,
        ReturnType<typeof getCompanyCompanySlugJobPostingConfigQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugJobPostingConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugJobPostingConfigQueryKey(options),
    })

/**
 * PUT /api/company/[companySlug]/job-posting-config
 *
 * Save the company's job posting field config. Needs the JOB_POSTING_CONFIG flag.
 */
export const putCompanyCompanySlugJobPostingConfigMutation = (
    options?: Partial<Options<PutCompanyCompanySlugJobPostingConfigData>>
): UseMutationOptions<
    PutCompanyCompanySlugJobPostingConfigResponse,
    AxiosError<PutCompanyCompanySlugJobPostingConfigError>,
    Options<PutCompanyCompanySlugJobPostingConfigData>
> => {
    const mutationOptions: UseMutationOptions<
        PutCompanyCompanySlugJobPostingConfigResponse,
        AxiosError<PutCompanyCompanySlugJobPostingConfigError>,
        Options<PutCompanyCompanySlugJobPostingConfigData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putCompanyCompanySlugJobPostingConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/[companySlug]/logo
 */
export const postCompanyCompanySlugLogoMutation = (
    options?: Partial<Options<PostCompanyCompanySlugLogoData>>
): UseMutationOptions<PostCompanyCompanySlugLogoResponse, AxiosError<PostCompanyCompanySlugLogoError>, Options<PostCompanyCompanySlugLogoData>> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugLogoResponse,
        AxiosError<PostCompanyCompanySlugLogoError>,
        Options<PostCompanyCompanySlugLogoData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugLogo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugPanellistsQueryKey = (options: Options<GetCompanyCompanySlugPanellistsData>) =>
    createQueryKey('getCompanyCompanySlugPanellists', options, false, ['Company'])

/**
 * GET /api/company/{companySlug}/panellists
 *
 * Page through the company's active Manager/Panellist members for panelist pickers, optionally searched, narrowed to a department, and sorted A–Z.
 */
export const getCompanyCompanySlugPanellistsOptions = (options: Options<GetCompanyCompanySlugPanellistsData>) =>
    queryOptions<
        GetCompanyCompanySlugPanellistsResponse,
        AxiosError<GetCompanyCompanySlugPanellistsError>,
        GetCompanyCompanySlugPanellistsResponse,
        ReturnType<typeof getCompanyCompanySlugPanellistsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugPanellists({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugPanellistsQueryKey(options),
    })

export const getCompanyCompanySlugPanellistsInfiniteQueryKey = (
    options: Options<GetCompanyCompanySlugPanellistsData>
): QueryKey<Options<GetCompanyCompanySlugPanellistsData>> => createQueryKey('getCompanyCompanySlugPanellists', options, true)

/**
 * GET /api/company/{companySlug}/panellists
 *
 * Page through the company's active Manager/Panellist members for panelist pickers, optionally searched, narrowed to a department, and sorted A–Z.
 */
export const getCompanyCompanySlugPanellistsInfiniteOptions = (options: Options<GetCompanyCompanySlugPanellistsData>) => {
    const opts = infiniteQueryOptions<
        GetCompanyCompanySlugPanellistsResponse,
        AxiosError<GetCompanyCompanySlugPanellistsError>,
        InfiniteData<GetCompanyCompanySlugPanellistsResponse>,
        QueryKey<Options<GetCompanyCompanySlugPanellistsData>>,
        string | Pick<QueryKey<Options<GetCompanyCompanySlugPanellistsData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetCompanyCompanySlugPanellistsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getCompanyCompanySlugPanellists({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getCompanyCompanySlugPanellistsInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

export const getCompanyCompanySlugScreeningWebrtcConfigQueryKey = (options: Options<GetCompanyCompanySlugScreeningWebrtcConfigData>) =>
    createQueryKey('getCompanyCompanySlugScreeningWebrtcConfig', options, false, ['Company'])

export const getCompanyCompanySlugScreeningWebrtcConfigOptions = (options: Options<GetCompanyCompanySlugScreeningWebrtcConfigData>) =>
    queryOptions<
        GetCompanyCompanySlugScreeningWebrtcConfigResponse,
        AxiosError<GetCompanyCompanySlugScreeningWebrtcConfigError>,
        GetCompanyCompanySlugScreeningWebrtcConfigResponse,
        ReturnType<typeof getCompanyCompanySlugScreeningWebrtcConfigQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugScreeningWebrtcConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugScreeningWebrtcConfigQueryKey(options),
    })

export const patchCompanyCompanySlugScreeningWebrtcConfigMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugScreeningWebrtcConfigData>>
): UseMutationOptions<
    PatchCompanyCompanySlugScreeningWebrtcConfigResponse,
    AxiosError<PatchCompanyCompanySlugScreeningWebrtcConfigError>,
    Options<PatchCompanyCompanySlugScreeningWebrtcConfigData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugScreeningWebrtcConfigResponse,
        AxiosError<PatchCompanyCompanySlugScreeningWebrtcConfigError>,
        Options<PatchCompanyCompanySlugScreeningWebrtcConfigData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugScreeningWebrtcConfig({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanyCompanySlugUsersQueryKey = (options: Options<GetCompanyCompanySlugUsersData>) =>
    createQueryKey('getCompanyCompanySlugUsers', options, false, ['Company'])

/**
 * Get list of users under a company
 *
 * Fetches list of users under a company
 */
export const getCompanyCompanySlugUsersOptions = (options: Options<GetCompanyCompanySlugUsersData>) =>
    queryOptions<
        GetCompanyCompanySlugUsersResponse,
        AxiosError<GetCompanyCompanySlugUsersError>,
        GetCompanyCompanySlugUsersResponse,
        ReturnType<typeof getCompanyCompanySlugUsersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanyCompanySlugUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanyCompanySlugUsersQueryKey(options),
    })

/**
 * Add a user to the company. Caller must be Admin or SuperAdmin.
 */
export const postCompanyCompanySlugUsersMutation = (
    options?: Partial<Options<PostCompanyCompanySlugUsersData>>
): UseMutationOptions<PostCompanyCompanySlugUsersResponse, AxiosError<PostCompanyCompanySlugUsersError>, Options<PostCompanyCompanySlugUsersData>> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugUsersResponse,
        AxiosError<PostCompanyCompanySlugUsersError>,
        Options<PostCompanyCompanySlugUsersData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugUsers({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteCompanyCompanySlugApprovalFlowRuleIdMutation = (
    options?: Partial<Options<DeleteCompanyCompanySlugApprovalFlowRuleIdData>>
): UseMutationOptions<
    DeleteCompanyCompanySlugApprovalFlowRuleIdResponse,
    AxiosError<DeleteCompanyCompanySlugApprovalFlowRuleIdError>,
    Options<DeleteCompanyCompanySlugApprovalFlowRuleIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteCompanyCompanySlugApprovalFlowRuleIdResponse,
        AxiosError<DeleteCompanyCompanySlugApprovalFlowRuleIdError>,
        Options<DeleteCompanyCompanySlugApprovalFlowRuleIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCompanyCompanySlugApprovalFlowRuleId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const patchCompanyCompanySlugApprovalFlowRuleIdMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugApprovalFlowRuleIdData>>
): UseMutationOptions<
    PatchCompanyCompanySlugApprovalFlowRuleIdResponse,
    AxiosError<PatchCompanyCompanySlugApprovalFlowRuleIdError>,
    Options<PatchCompanyCompanySlugApprovalFlowRuleIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugApprovalFlowRuleIdResponse,
        AxiosError<PatchCompanyCompanySlugApprovalFlowRuleIdError>,
        Options<PatchCompanyCompanySlugApprovalFlowRuleIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugApprovalFlowRuleId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE: Delete a custom status by statusId (CRUD: Delete Single Item)
 */
export const deleteCompanyCompanySlugCandidateStatusesConfigStatusIdMutation = (
    options?: Partial<Options<DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData>>
): UseMutationOptions<
    DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
    AxiosError<DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdError>,
    Options<DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
        AxiosError<DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdError>,
        Options<DeleteCompanyCompanySlugCandidateStatusesConfigStatusIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCompanyCompanySlugCandidateStatusesConfigStatusId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH: Update an individual status definition by statusId (CRUD: Update Single Item)
 */
export const patchCompanyCompanySlugCandidateStatusesConfigStatusIdMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData>>
): UseMutationOptions<
    PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
    AxiosError<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdError>,
    Options<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugCandidateStatusesConfigStatusIdResponse,
        AxiosError<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdError>,
        Options<PatchCompanyCompanySlugCandidateStatusesConfigStatusIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugCandidateStatusesConfigStatusId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/[companySlug]/integrations/disconnect
 */
export const postCompanyCompanySlugIntegrationsDisconnectMutation = (
    options?: Partial<Options<PostCompanyCompanySlugIntegrationsDisconnectData>>
): UseMutationOptions<
    PostCompanyCompanySlugIntegrationsDisconnectResponse,
    AxiosError<PostCompanyCompanySlugIntegrationsDisconnectError>,
    Options<PostCompanyCompanySlugIntegrationsDisconnectData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugIntegrationsDisconnectResponse,
        AxiosError<PostCompanyCompanySlugIntegrationsDisconnectError>,
        Options<PostCompanyCompanySlugIntegrationsDisconnectData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugIntegrationsDisconnect({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/[companySlug]/integrations/test
 */
export const postCompanyCompanySlugIntegrationsTestMutation = (
    options?: Partial<Options<PostCompanyCompanySlugIntegrationsTestData>>
): UseMutationOptions<
    PostCompanyCompanySlugIntegrationsTestResponse,
    AxiosError<PostCompanyCompanySlugIntegrationsTestError>,
    Options<PostCompanyCompanySlugIntegrationsTestData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugIntegrationsTestResponse,
        AxiosError<PostCompanyCompanySlugIntegrationsTestError>,
        Options<PostCompanyCompanySlugIntegrationsTestData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugIntegrationsTest({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/company/[companySlug]/users/[userId]
 */
export const patchCompanyCompanySlugUsersUserIdMutation = (
    options?: Partial<Options<PatchCompanyCompanySlugUsersUserIdData>>
): UseMutationOptions<
    PatchCompanyCompanySlugUsersUserIdResponse,
    AxiosError<PatchCompanyCompanySlugUsersUserIdError>,
    Options<PatchCompanyCompanySlugUsersUserIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchCompanyCompanySlugUsersUserIdResponse,
        AxiosError<PatchCompanyCompanySlugUsersUserIdError>,
        Options<PatchCompanyCompanySlugUsersUserIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCompanyCompanySlugUsersUserId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Disable one or more users. Blocks them in Auth0 and sets disabled=true in DB.
 */
export const postCompanyCompanySlugUsersDisableMutation = (
    options?: Partial<Options<PostCompanyCompanySlugUsersDisableData>>
): UseMutationOptions<
    PostCompanyCompanySlugUsersDisableResponse,
    AxiosError<PostCompanyCompanySlugUsersDisableError>,
    Options<PostCompanyCompanySlugUsersDisableData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugUsersDisableResponse,
        AxiosError<PostCompanyCompanySlugUsersDisableError>,
        Options<PostCompanyCompanySlugUsersDisableData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugUsersDisable({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Enable (unblock) one or more users. Unblocks them in Auth0 and sets disabled=false in DB.
 */
export const postCompanyCompanySlugUsersEnableMutation = (
    options?: Partial<Options<PostCompanyCompanySlugUsersEnableData>>
): UseMutationOptions<
    PostCompanyCompanySlugUsersEnableResponse,
    AxiosError<PostCompanyCompanySlugUsersEnableError>,
    Options<PostCompanyCompanySlugUsersEnableData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugUsersEnableResponse,
        AxiosError<PostCompanyCompanySlugUsersEnableError>,
        Options<PostCompanyCompanySlugUsersEnableData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugUsersEnable({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/[companySlug]/integrations/linkedin/verify
 */
export const postCompanyCompanySlugIntegrationsLinkedinVerifyMutation = (
    options?: Partial<Options<PostCompanyCompanySlugIntegrationsLinkedinVerifyData>>
): UseMutationOptions<
    PostCompanyCompanySlugIntegrationsLinkedinVerifyResponse,
    AxiosError<PostCompanyCompanySlugIntegrationsLinkedinVerifyError>,
    Options<PostCompanyCompanySlugIntegrationsLinkedinVerifyData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugIntegrationsLinkedinVerifyResponse,
        AxiosError<PostCompanyCompanySlugIntegrationsLinkedinVerifyError>,
        Options<PostCompanyCompanySlugIntegrationsLinkedinVerifyData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugIntegrationsLinkedinVerify({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/company/[companySlug]/users/[userId]/reset-password
 */
export const postCompanyCompanySlugUsersUserIdResetPasswordMutation = (
    options?: Partial<Options<PostCompanyCompanySlugUsersUserIdResetPasswordData>>
): UseMutationOptions<
    PostCompanyCompanySlugUsersUserIdResetPasswordResponse,
    AxiosError<PostCompanyCompanySlugUsersUserIdResetPasswordError>,
    Options<PostCompanyCompanySlugUsersUserIdResetPasswordData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanyCompanySlugUsersUserIdResetPasswordResponse,
        AxiosError<PostCompanyCompanySlugUsersUserIdResetPasswordError>,
        Options<PostCompanyCompanySlugUsersUserIdResetPasswordData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanyCompanySlugUsersUserIdResetPassword({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCronAiInterviewRemindersQueryKey = (options?: Options<GetCronAiInterviewRemindersData>) =>
    createQueryKey('getCronAiInterviewReminders', options, false, ['Cron'])

/**
 * GET API for checking pending AI interviews (for monitoring)
 */
export const getCronAiInterviewRemindersOptions = (options?: Options<GetCronAiInterviewRemindersData>) =>
    queryOptions<unknown, AxiosError<GetCronAiInterviewRemindersError>, unknown, ReturnType<typeof getCronAiInterviewRemindersQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCronAiInterviewReminders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCronAiInterviewRemindersQueryKey(options),
    })

/**
 * POST API for sending AI interview reminder emails
 */
export const postCronAiInterviewRemindersMutation = (
    options?: Partial<Options<PostCronAiInterviewRemindersData>>
): UseMutationOptions<unknown, AxiosError<PostCronAiInterviewRemindersError>, Options<PostCronAiInterviewRemindersData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCronAiInterviewRemindersError>, Options<PostCronAiInterviewRemindersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronAiInterviewReminders({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/cron/analytics-refresh
 */
export const postCronAnalyticsRefreshMutation = (
    options?: Partial<Options<PostCronAnalyticsRefreshData>>
): UseMutationOptions<unknown, AxiosError<PostCronAnalyticsRefreshError>, Options<PostCronAnalyticsRefreshData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCronAnalyticsRefreshError>, Options<PostCronAnalyticsRefreshData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronAnalyticsRefresh({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/cron/billing-capacity-rebill
 */
export const postCronBillingCapacityRebillMutation = (
    options?: Partial<Options<PostCronBillingCapacityRebillData>>
): UseMutationOptions<unknown, AxiosError<PostCronBillingCapacityRebillError>, Options<PostCronBillingCapacityRebillData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCronBillingCapacityRebillError>, Options<PostCronBillingCapacityRebillData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronBillingCapacityRebill({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * This is a Next.js API route that runs a cron job to update Candidates in the database.
 */
export const patchCronCandidatesMutation = (
    options?: Partial<Options<PatchCronCandidatesData>>
): UseMutationOptions<unknown, AxiosError<PatchCronCandidatesError>, Options<PatchCronCandidatesData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchCronCandidatesError>, Options<PatchCronCandidatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCronCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCronFeedbackRemindersQueryKey = (options?: Options<GetCronFeedbackRemindersData>) =>
    createQueryKey('getCronFeedbackReminders', options, false, ['Cron'])

/**
 * GET API for checking pending feedbacks (for monitoring)
 */
export const getCronFeedbackRemindersOptions = (options?: Options<GetCronFeedbackRemindersData>) =>
    queryOptions<unknown, AxiosError<GetCronFeedbackRemindersError>, unknown, ReturnType<typeof getCronFeedbackRemindersQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCronFeedbackReminders({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCronFeedbackRemindersQueryKey(options),
    })

/**
 * POST API for sending feedback reminder emails
 */
export const postCronFeedbackRemindersMutation = (
    options?: Partial<Options<PostCronFeedbackRemindersData>>
): UseMutationOptions<unknown, AxiosError<PostCronFeedbackRemindersError>, Options<PostCronFeedbackRemindersData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCronFeedbackRemindersError>, Options<PostCronFeedbackRemindersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronFeedbackReminders({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/cron/job-application-processing
 */
export const postCronJobApplicationProcessingMutation = (
    options?: Partial<Options<PostCronJobApplicationProcessingData>>
): UseMutationOptions<
    PostCronJobApplicationProcessingResponse,
    AxiosError<PostCronJobApplicationProcessingError>,
    Options<PostCronJobApplicationProcessingData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCronJobApplicationProcessingResponse,
        AxiosError<PostCronJobApplicationProcessingError>,
        Options<PostCronJobApplicationProcessingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronJobApplicationProcessing({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCronRenewCalendarSubscriptionsQueryKey = (options?: Options<GetCronRenewCalendarSubscriptionsData>) =>
    createQueryKey('getCronRenewCalendarSubscriptions', options, false, ['Cron'])

/**
 * GET API for checking calendar subscription status (for monitoring)
 */
export const getCronRenewCalendarSubscriptionsOptions = (options?: Options<GetCronRenewCalendarSubscriptionsData>) =>
    queryOptions<unknown, AxiosError<GetCronRenewCalendarSubscriptionsError>, unknown, ReturnType<typeof getCronRenewCalendarSubscriptionsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCronRenewCalendarSubscriptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCronRenewCalendarSubscriptionsQueryKey(options),
    })

/**
 * POST API for renewing calendar subscriptions
 */
export const postCronRenewCalendarSubscriptionsMutation = (
    options?: Partial<Options<PostCronRenewCalendarSubscriptionsData>>
): UseMutationOptions<unknown, AxiosError<PostCronRenewCalendarSubscriptionsError>, Options<PostCronRenewCalendarSubscriptionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCronRenewCalendarSubscriptionsError>, Options<PostCronRenewCalendarSubscriptionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronRenewCalendarSubscriptions({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCronScreeningWebrtcLifecycleSweeperQueryKey = (options?: Options<GetCronScreeningWebrtcLifecycleSweeperData>) =>
    createQueryKey('getCronScreeningWebrtcLifecycleSweeper', options, false, ['Cron'])

export const getCronScreeningWebrtcLifecycleSweeperOptions = (options?: Options<GetCronScreeningWebrtcLifecycleSweeperData>) =>
    queryOptions<unknown, AxiosError<GetCronScreeningWebrtcLifecycleSweeperError>, unknown, ReturnType<typeof getCronScreeningWebrtcLifecycleSweeperQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCronScreeningWebrtcLifecycleSweeper({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCronScreeningWebrtcLifecycleSweeperQueryKey(options),
    })

/**
 * POST /api/cron/screening-webrtc-lifecycle-sweeper
 */
export const postCronScreeningWebrtcLifecycleSweeperMutation = (
    options?: Partial<Options<PostCronScreeningWebrtcLifecycleSweeperData>>
): UseMutationOptions<unknown, AxiosError<PostCronScreeningWebrtcLifecycleSweeperError>, Options<PostCronScreeningWebrtcLifecycleSweeperData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostCronScreeningWebrtcLifecycleSweeperError>,
        Options<PostCronScreeningWebrtcLifecycleSweeperData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCronScreeningWebrtcLifecycleSweeper({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCustomAnalyticsQueryKey = (options?: Options<GetCustomAnalyticsData>) =>
    createQueryKey('getCustomAnalytics', options, false, ['Custom-analytics'])

/**
 * GET endpoint for getting available schema information
 */
export const getCustomAnalyticsOptions = (options?: Options<GetCustomAnalyticsData>) =>
    queryOptions<unknown, AxiosError<GetCustomAnalyticsError>, unknown, ReturnType<typeof getCustomAnalyticsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCustomAnalytics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCustomAnalyticsQueryKey(options),
    })

/**
 * Main API endpoint
 */
export const postCustomAnalyticsMutation = (
    options?: Partial<Options<PostCustomAnalyticsData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsError>, Options<PostCustomAnalyticsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsError>, Options<PostCustomAnalyticsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalytics({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE endpoint for deleting a custom chart by id
 */
export const deleteCustomAnalyticsIdMutation = (
    options?: Partial<Options<DeleteCustomAnalyticsIdData>>
): UseMutationOptions<DeleteCustomAnalyticsIdResponse, AxiosError<DeleteCustomAnalyticsIdError>, Options<DeleteCustomAnalyticsIdData>> => {
    const mutationOptions: UseMutationOptions<
        DeleteCustomAnalyticsIdResponse,
        AxiosError<DeleteCustomAnalyticsIdError>,
        Options<DeleteCustomAnalyticsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCustomAnalyticsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCustomAnalyticsAssignDashboardMutation = (
    options?: Partial<Options<PostCustomAnalyticsAssignDashboardData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsAssignDashboardError>, Options<PostCustomAnalyticsAssignDashboardData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsAssignDashboardError>, Options<PostCustomAnalyticsAssignDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalyticsAssignDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteCustomAnalyticsDashboardMutation = (
    options?: Partial<Options<DeleteCustomAnalyticsDashboardData>>
): UseMutationOptions<unknown, AxiosError<DeleteCustomAnalyticsDashboardError>, Options<DeleteCustomAnalyticsDashboardData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteCustomAnalyticsDashboardError>, Options<DeleteCustomAnalyticsDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteCustomAnalyticsDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const patchCustomAnalyticsDashboardMutation = (
    options?: Partial<Options<PatchCustomAnalyticsDashboardData>>
): UseMutationOptions<unknown, AxiosError<PatchCustomAnalyticsDashboardError>, Options<PatchCustomAnalyticsDashboardData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchCustomAnalyticsDashboardError>, Options<PatchCustomAnalyticsDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchCustomAnalyticsDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCustomAnalyticsDashboardMutation = (
    options?: Partial<Options<PostCustomAnalyticsDashboardData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsDashboardError>, Options<PostCustomAnalyticsDashboardData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsDashboardError>, Options<PostCustomAnalyticsDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalyticsDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCustomAnalyticsOrderMutation = (
    options?: Partial<Options<PostCustomAnalyticsOrderData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsOrderError>, Options<PostCustomAnalyticsOrderData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsOrderError>, Options<PostCustomAnalyticsOrderData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalyticsOrder({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCustomAnalyticsPaginateMutation = (
    options?: Partial<Options<PostCustomAnalyticsPaginateData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsPaginateError>, Options<PostCustomAnalyticsPaginateData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsPaginateError>, Options<PostCustomAnalyticsPaginateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalyticsPaginate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Main API endpoint
 */
export const postCustomAnalyticsPreviewMutation = (
    options?: Partial<Options<PostCustomAnalyticsPreviewData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsPreviewError>, Options<PostCustomAnalyticsPreviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsPreviewError>, Options<PostCustomAnalyticsPreviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalyticsPreview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postCustomAnalyticsRemoveDashboardMutation = (
    options?: Partial<Options<PostCustomAnalyticsRemoveDashboardData>>
): UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsRemoveDashboardError>, Options<PostCustomAnalyticsRemoveDashboardData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostCustomAnalyticsRemoveDashboardError>, Options<PostCustomAnalyticsRemoveDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCustomAnalyticsRemoveDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getEmbeddingsQueryKey = (options?: Options<GetEmbeddingsData>) => createQueryKey('getEmbeddings', options, false, ['Embeddings'])

export const getEmbeddingsOptions = (options?: Options<GetEmbeddingsData>) =>
    queryOptions<GetEmbeddingsResponse, AxiosError<GetEmbeddingsError>, GetEmbeddingsResponse, ReturnType<typeof getEmbeddingsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getEmbeddings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getEmbeddingsQueryKey(options),
    })

export const postEmbeddingsMutation = (
    options?: Partial<Options<PostEmbeddingsData>>
): UseMutationOptions<PostEmbeddingsResponse, AxiosError<PostEmbeddingsError>, Options<PostEmbeddingsData>> => {
    const mutationOptions: UseMutationOptions<PostEmbeddingsResponse, AxiosError<PostEmbeddingsError>, Options<PostEmbeddingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postEmbeddings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST: Creates new interview questions for a screening round.
 */
export const postGenerateQuestionsMutation = (
    options?: Partial<Options<PostGenerateQuestionsData>>
): UseMutationOptions<unknown, AxiosError<PostGenerateQuestionsError>, Options<PostGenerateQuestionsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostGenerateQuestionsError>, Options<PostGenerateQuestionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postGenerateQuestions({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PUT: Updates/regenerates existing interview questions using interview ID from path.
 */
export const putGenerateQuestionsIdMutation = (
    options?: Partial<Options<PutGenerateQuestionsIdData>>
): UseMutationOptions<unknown, AxiosError<PutGenerateQuestionsIdError>, Options<PutGenerateQuestionsIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutGenerateQuestionsIdError>, Options<PutGenerateQuestionsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putGenerateQuestionsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getHiringManagersQueryKey = (options?: Options<GetHiringManagersData>) => createQueryKey('getHiringManagers', options, false, ['Hiring-managers'])

export const getHiringManagersOptions = (options?: Options<GetHiringManagersData>) =>
    queryOptions<unknown, AxiosError<GetHiringManagersError>, unknown, ReturnType<typeof getHiringManagersQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getHiringManagers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getHiringManagersQueryKey(options),
    })

export const postHiringManagersMutation = (
    options?: Partial<Options<PostHiringManagersData>>
): UseMutationOptions<unknown, AxiosError<PostHiringManagersError>, Options<PostHiringManagersData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostHiringManagersError>, Options<PostHiringManagersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postHiringManagers({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * delete manager - removes Manager role from user
 */
export const deleteHiringManagersIdMutation = (
    options?: Partial<Options<DeleteHiringManagersIdData>>
): UseMutationOptions<unknown, AxiosError<DeleteHiringManagersIdError>, Options<DeleteHiringManagersIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteHiringManagersIdError>, Options<DeleteHiringManagersIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteHiringManagersId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putHiringManagersIdMutation = (
    options?: Partial<Options<PutHiringManagersIdData>>
): UseMutationOptions<unknown, AxiosError<PutHiringManagersIdError>, Options<PutHiringManagersIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutHiringManagersIdError>, Options<PutHiringManagersIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putHiringManagersId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsBenettonApplicantsReportMutation = (
    options?: Partial<Options<PostInsightsBenettonApplicantsReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsBenettonApplicantsReportError>, Options<PostInsightsBenettonApplicantsReportData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInsightsBenettonApplicantsReportError>,
        Options<PostInsightsBenettonApplicantsReportData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsBenettonApplicantsReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsCandidatesByRolesReportMutation = (
    options?: Partial<Options<PostInsightsCandidatesByRolesReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsCandidatesByRolesReportError>, Options<PostInsightsCandidatesByRolesReportData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInsightsCandidatesByRolesReportError>,
        Options<PostInsightsCandidatesByRolesReportData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsCandidatesByRolesReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsCandidatesByStatusReportMutation = (
    options?: Partial<Options<PostInsightsCandidatesByStatusReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsCandidatesByStatusReportError>, Options<PostInsightsCandidatesByStatusReportData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInsightsCandidatesByStatusReportError>,
        Options<PostInsightsCandidatesByStatusReportData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsCandidatesByStatusReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsCustomChartsMutation = (
    options?: Partial<Options<PostInsightsCustomChartsData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsCustomChartsError>, Options<PostInsightsCustomChartsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsCustomChartsError>, Options<PostInsightsCustomChartsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsCustomCharts({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsMonthlyDashboardMutation = (
    options?: Partial<Options<PostInsightsMonthlyDashboardData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsMonthlyDashboardError>, Options<PostInsightsMonthlyDashboardData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsMonthlyDashboardError>, Options<PostInsightsMonthlyDashboardData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsMonthlyDashboard({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsOfferJoinedReportMutation = (
    options?: Partial<Options<PostInsightsOfferJoinedReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsOfferJoinedReportError>, Options<PostInsightsOfferJoinedReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsOfferJoinedReportError>, Options<PostInsightsOfferJoinedReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsOfferJoinedReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsOpenPositionsReportMutation = (
    options?: Partial<Options<PostInsightsOpenPositionsReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsOpenPositionsReportError>, Options<PostInsightsOpenPositionsReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsOpenPositionsReportError>, Options<PostInsightsOpenPositionsReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsOpenPositionsReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsPositionsClosedReportMutation = (
    options?: Partial<Options<PostInsightsPositionsClosedReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsPositionsClosedReportError>, Options<PostInsightsPositionsClosedReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsPositionsClosedReportError>, Options<PostInsightsPositionsClosedReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsPositionsClosedReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsPositionsCreatedReportMutation = (
    options?: Partial<Options<PostInsightsPositionsCreatedReportData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsPositionsCreatedReportError>, Options<PostInsightsPositionsCreatedReportData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsPositionsCreatedReportError>, Options<PostInsightsPositionsCreatedReportData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsPositionsCreatedReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsPredefinedGraphsMutation = (
    options?: Partial<Options<PostInsightsPredefinedGraphsData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsPredefinedGraphsError>, Options<PostInsightsPredefinedGraphsData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsPredefinedGraphsError>, Options<PostInsightsPredefinedGraphsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsPredefinedGraphs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInsightsPredefinedGraphsSaveMutation = (
    options?: Partial<Options<PostInsightsPredefinedGraphsSaveData>>
): UseMutationOptions<unknown, AxiosError<PostInsightsPredefinedGraphsSaveError>, Options<PostInsightsPredefinedGraphsSaveData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInsightsPredefinedGraphsSaveError>, Options<PostInsightsPredefinedGraphsSaveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInsightsPredefinedGraphsSave({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getIntegrationsGoogleAuthorizeQueryKey = (options?: Options<GetIntegrationsGoogleAuthorizeData>) =>
    createQueryKey('getIntegrationsGoogleAuthorize', options, false, ['Integrations'])

/**
 * GET /api/integrations/google/authorize?companySlug=xxx
 */
export const getIntegrationsGoogleAuthorizeOptions = (options?: Options<GetIntegrationsGoogleAuthorizeData>) =>
    queryOptions<unknown, AxiosError<GetIntegrationsGoogleAuthorizeError>, unknown, ReturnType<typeof getIntegrationsGoogleAuthorizeQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIntegrationsGoogleAuthorize({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getIntegrationsGoogleAuthorizeQueryKey(options),
    })

export const getIntegrationsGoogleCallbackQueryKey = (options?: Options<GetIntegrationsGoogleCallbackData>) =>
    createQueryKey('getIntegrationsGoogleCallback', options, false, ['Integrations'])

/**
 * GET /api/integrations/google/callback?code=xxx&state=xxx
 */
export const getIntegrationsGoogleCallbackOptions = (options?: Options<GetIntegrationsGoogleCallbackData>) =>
    queryOptions<unknown, AxiosError<GetIntegrationsGoogleCallbackError>, unknown, ReturnType<typeof getIntegrationsGoogleCallbackQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIntegrationsGoogleCallback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getIntegrationsGoogleCallbackQueryKey(options),
    })

export const getIntegrationsMicrosoftAuthorizeQueryKey = (options?: Options<GetIntegrationsMicrosoftAuthorizeData>) =>
    createQueryKey('getIntegrationsMicrosoftAuthorize', options, false, ['Integrations'])

/**
 * GET /api/integrations/microsoft/authorize?companySlug=xxx
 */
export const getIntegrationsMicrosoftAuthorizeOptions = (options?: Options<GetIntegrationsMicrosoftAuthorizeData>) =>
    queryOptions<unknown, AxiosError<GetIntegrationsMicrosoftAuthorizeError>, unknown, ReturnType<typeof getIntegrationsMicrosoftAuthorizeQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIntegrationsMicrosoftAuthorize({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getIntegrationsMicrosoftAuthorizeQueryKey(options),
    })

export const getIntegrationsMicrosoftCallbackQueryKey = (options?: Options<GetIntegrationsMicrosoftCallbackData>) =>
    createQueryKey('getIntegrationsMicrosoftCallback', options, false, ['Integrations'])

/**
 * GET /api/integrations/microsoft/callback?code=xxx&state=xxx
 */
export const getIntegrationsMicrosoftCallbackOptions = (options?: Options<GetIntegrationsMicrosoftCallbackData>) =>
    queryOptions<unknown, AxiosError<GetIntegrationsMicrosoftCallbackError>, unknown, ReturnType<typeof getIntegrationsMicrosoftCallbackQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getIntegrationsMicrosoftCallback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getIntegrationsMicrosoftCallbackQueryKey(options),
    })

export const postInternalSttMutation = (
    options?: Partial<Options<PostInternalSttData>>
): UseMutationOptions<PostInternalSttResponse, AxiosError<PostInternalSttError>, Options<PostInternalSttData>> => {
    const mutationOptions: UseMutationOptions<PostInternalSttResponse, AxiosError<PostInternalSttError>, Options<PostInternalSttData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInternalStt({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInternalAnalyticsQueryMutation = (
    options?: Partial<Options<PostInternalAnalyticsQueryData>>
): UseMutationOptions<PostInternalAnalyticsQueryResponse, AxiosError<PostInternalAnalyticsQueryError>, Options<PostInternalAnalyticsQueryData>> => {
    const mutationOptions: UseMutationOptions<
        PostInternalAnalyticsQueryResponse,
        AxiosError<PostInternalAnalyticsQueryError>,
        Options<PostInternalAnalyticsQueryData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInternalAnalyticsQuery({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInternalSttTokenQueryKey = (options?: Options<GetInternalSttTokenData>) => createQueryKey('getInternalSttToken', options, false, ['Internal'])

export const getInternalSttTokenOptions = (options?: Options<GetInternalSttTokenData>) =>
    queryOptions<
        GetInternalSttTokenResponse,
        AxiosError<GetInternalSttTokenError>,
        GetInternalSttTokenResponse,
        ReturnType<typeof getInternalSttTokenQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInternalSttToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInternalSttTokenQueryKey(options),
    })

export const getInterviewsQueryKey = (options?: Options<GetInterviewsData>) => createQueryKey('getInterviews', options, false, ['Interviews'])

export const getInterviewsOptions = (options?: Options<GetInterviewsData>) =>
    queryOptions<GetInterviewsResponse, AxiosError<GetInterviewsError>, GetInterviewsResponse, ReturnType<typeof getInterviewsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviews({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsQueryKey(options),
    })

export const postInterviewsMutation = (
    options?: Partial<Options<PostInterviewsData>>
): UseMutationOptions<PostInterviewsResponse, AxiosError<PostInterviewsError>, Options<PostInterviewsData>> => {
    const mutationOptions: UseMutationOptions<PostInterviewsResponse, AxiosError<PostInterviewsError>, Options<PostInterviewsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviews({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteInterviewsIdMutation = (
    options?: Partial<Options<DeleteInterviewsIdData>>
): UseMutationOptions<DeleteInterviewsIdResponse, AxiosError<DeleteInterviewsIdError>, Options<DeleteInterviewsIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteInterviewsIdResponse, AxiosError<DeleteInterviewsIdError>, Options<DeleteInterviewsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsIdQueryKey = (options: Options<GetInterviewsIdData>) => createQueryKey('getInterviewsId', options, false, ['Interviews'])

/**
 * GET API for fetching Interviews by id
 */
export const getInterviewsIdOptions = (options: Options<GetInterviewsIdData>) =>
    queryOptions<GetInterviewsIdResponse, AxiosError<GetInterviewsIdError>, GetInterviewsIdResponse, ReturnType<typeof getInterviewsIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsIdQueryKey(options),
    })

export const putInterviewsIdMutation = (
    options?: Partial<Options<PutInterviewsIdData>>
): UseMutationOptions<PutInterviewsIdResponse, AxiosError<PutInterviewsIdError>, Options<PutInterviewsIdData>> => {
    const mutationOptions: UseMutationOptions<PutInterviewsIdResponse, AxiosError<PutInterviewsIdError>, Options<PutInterviewsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsFeedbackQueryKey = (options?: Options<GetInterviewsFeedbackData>) =>
    createQueryKey('getInterviewsFeedback', options, false, ['Interviews'])

/**
 * GET API for fetching Interview by panelist
 */
export const getInterviewsFeedbackOptions = (options?: Options<GetInterviewsFeedbackData>) =>
    queryOptions<unknown, AxiosError<GetInterviewsFeedbackError>, unknown, ReturnType<typeof getInterviewsFeedbackQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsFeedback({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsFeedbackQueryKey(options),
    })

export const putInterviewsFeedbackMutation = (
    options?: Partial<Options<PutInterviewsFeedbackData>>
): UseMutationOptions<unknown, AxiosError<PutInterviewsFeedbackError>, Options<PutInterviewsFeedbackData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutInterviewsFeedbackError>, Options<PutInterviewsFeedbackData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsFeedback({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST handler for receiving AI-generated human interview questions from backend.
 */
export const postInterviewsHumanInterviewQuestionsMutation = (
    options?: Partial<Options<PostInterviewsHumanInterviewQuestionsData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsHumanInterviewQuestionsError>, Options<PostInterviewsHumanInterviewQuestionsData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsHumanInterviewQuestionsError>,
        Options<PostInterviewsHumanInterviewQuestionsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsHumanInterviewQuestions({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE handler to delete/cancel a ScreeningCall.
 */
export const deleteInterviewsScreeningCallMutation = (
    options?: Partial<Options<DeleteInterviewsScreeningCallData>>
): UseMutationOptions<unknown, AxiosError<DeleteInterviewsScreeningCallError>, Options<DeleteInterviewsScreeningCallData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteInterviewsScreeningCallError>, Options<DeleteInterviewsScreeningCallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsScreeningCall({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST handler to create and schedule a ScreeningCall for a job application.
 */
export const postInterviewsScreeningCallMutation = (
    options?: Partial<Options<PostInterviewsScreeningCallData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningCallError>, Options<PostInterviewsScreeningCallData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningCallError>, Options<PostInterviewsScreeningCallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningCall({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PUT handler to update a ScreeningCall (e.g. status, callEvents, recordingUrl).
 */
export const putInterviewsScreeningCallMutation = (
    options?: Partial<Options<PutInterviewsScreeningCallData>>
): UseMutationOptions<unknown, AxiosError<PutInterviewsScreeningCallError>, Options<PutInterviewsScreeningCallData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutInterviewsScreeningCallError>, Options<PutInterviewsScreeningCallData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsScreeningCall({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningInterviewQueryKey = (options?: Options<GetInterviewsScreeningInterviewData>) =>
    createQueryKey('getInterviewsScreeningInterview', options, false, ['Interviews'])

/**
 * GET handler for fetching screening interview information.
 */
export const getInterviewsScreeningInterviewOptions = (options?: Options<GetInterviewsScreeningInterviewData>) =>
    queryOptions<unknown, AxiosError<GetInterviewsScreeningInterviewError>, unknown, ReturnType<typeof getInterviewsScreeningInterviewQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewQueryKey(options),
    })

/**
 * POST handler for bulk screening interview creation.
 */
export const postInterviewsScreeningInterviewMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningInterviewError>, Options<PostInterviewsScreeningInterviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningInterviewError>, Options<PostInterviewsScreeningInterviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putInterviewsScreeningInterviewMutation = (
    options?: Partial<Options<PutInterviewsScreeningInterviewData>>
): UseMutationOptions<unknown, AxiosError<PutInterviewsScreeningInterviewError>, Options<PutInterviewsScreeningInterviewData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutInterviewsScreeningInterviewError>, Options<PutInterviewsScreeningInterviewData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsScreeningInterview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsIdInterviewRoundMutation = (
    options?: Partial<Options<PostInterviewsIdInterviewRoundData>>
): UseMutationOptions<PostInterviewsIdInterviewRoundResponse, AxiosError<PostInterviewsIdInterviewRoundError>, Options<PostInterviewsIdInterviewRoundData>> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsIdInterviewRoundResponse,
        AxiosError<PostInterviewsIdInterviewRoundError>,
        Options<PostInterviewsIdInterviewRoundData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsIdInterviewRound({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putInterviewsIdInterviewRoundMutation = (
    options?: Partial<Options<PutInterviewsIdInterviewRoundData>>
): UseMutationOptions<PutInterviewsIdInterviewRoundResponse, AxiosError<PutInterviewsIdInterviewRoundError>, Options<PutInterviewsIdInterviewRoundData>> => {
    const mutationOptions: UseMutationOptions<
        PutInterviewsIdInterviewRoundResponse,
        AxiosError<PutInterviewsIdInterviewRoundError>,
        Options<PutInterviewsIdInterviewRoundData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsIdInterviewRound({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsFeedbackGenerateMutation = (
    options?: Partial<Options<PostInterviewsFeedbackGenerateData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsFeedbackGenerateError>, Options<PostInterviewsFeedbackGenerateData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInterviewsFeedbackGenerateError>, Options<PostInterviewsFeedbackGenerateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsFeedbackGenerate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsFeedbackTranscriptQueryKey = (options?: Options<GetInterviewsFeedbackTranscriptData>) =>
    createQueryKey('getInterviewsFeedbackTranscript', options, false, ['Interviews'])

/**
 * Lightweight GET endpoint for polling transcript and summary availability.
 */
export const getInterviewsFeedbackTranscriptOptions = (options?: Options<GetInterviewsFeedbackTranscriptData>) =>
    queryOptions<unknown, AxiosError<GetInterviewsFeedbackTranscriptError>, unknown, ReturnType<typeof getInterviewsFeedbackTranscriptQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsFeedbackTranscript({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsFeedbackTranscriptQueryKey(options),
    })

/**
 * POST /api/interviews/humanInterviewQuestions/trigger
 */
export const postInterviewsHumanInterviewQuestionsTriggerMutation = (
    options?: Partial<Options<PostInterviewsHumanInterviewQuestionsTriggerData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsHumanInterviewQuestionsTriggerError>, Options<PostInterviewsHumanInterviewQuestionsTriggerData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsHumanInterviewQuestionsTriggerError>,
        Options<PostInterviewsHumanInterviewQuestionsTriggerData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsHumanInterviewQuestionsTrigger({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST handler to bulk create and schedule ScreeningCall records for multiple job applications.
 */
export const postInterviewsScreeningCallBulkMutation = (
    options?: Partial<Options<PostInterviewsScreeningCallBulkData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningCallBulkError>, Options<PostInterviewsScreeningCallBulkData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningCallBulkError>, Options<PostInterviewsScreeningCallBulkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningCallBulk({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screening-call/endInterview
 */
export const postInterviewsScreeningCallEndInterviewMutation = (
    options?: Partial<Options<PostInterviewsScreeningCallEndInterviewData>>
): UseMutationOptions<
    PostInterviewsScreeningCallEndInterviewResponse,
    AxiosError<PostInterviewsScreeningCallEndInterviewError>,
    Options<PostInterviewsScreeningCallEndInterviewData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningCallEndInterviewResponse,
        AxiosError<PostInterviewsScreeningCallEndInterviewError>,
        Options<PostInterviewsScreeningCallEndInterviewData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningCallEndInterview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screening-call/lifecycle
 */
export const postInterviewsScreeningCallLifecycleMutation = (
    options?: Partial<Options<PostInterviewsScreeningCallLifecycleData>>
): UseMutationOptions<
    PostInterviewsScreeningCallLifecycleResponse,
    AxiosError<PostInterviewsScreeningCallLifecycleError>,
    Options<PostInterviewsScreeningCallLifecycleData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningCallLifecycleResponse,
        AxiosError<PostInterviewsScreeningCallLifecycleError>,
        Options<PostInterviewsScreeningCallLifecycleData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningCallLifecycle({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Browser hint closer (pagehide / Leave keepalive). Thin wrapper around shared finalize.
 */
export const postInterviewsScreeningWebrtcAbandonMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcAbandonData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcAbandonResponse,
    AxiosError<PostInterviewsScreeningWebrtcAbandonError>,
    Options<PostInterviewsScreeningWebrtcAbandonData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcAbandonResponse,
        AxiosError<PostInterviewsScreeningWebrtcAbandonError>,
        Options<PostInterviewsScreeningWebrtcAbandonData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcAbandon({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningWebrtcBootstrapQueryKey = (options?: Options<GetInterviewsScreeningWebrtcBootstrapData>) =>
    createQueryKey('getInterviewsScreeningWebrtcBootstrap', options, false, ['Interviews'])

export const getInterviewsScreeningWebrtcBootstrapOptions = (options?: Options<GetInterviewsScreeningWebrtcBootstrapData>) =>
    queryOptions<
        GetInterviewsScreeningWebrtcBootstrapResponse,
        AxiosError<GetInterviewsScreeningWebrtcBootstrapError>,
        GetInterviewsScreeningWebrtcBootstrapResponse,
        ReturnType<typeof getInterviewsScreeningWebrtcBootstrapQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningWebrtcBootstrap({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningWebrtcBootstrapQueryKey(options),
    })

/**
 * POST /api/interviews/screening-webrtc/lifecycle
 */
export const postInterviewsScreeningWebrtcLifecycleMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcLifecycleData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcLifecycleResponse,
    AxiosError<PostInterviewsScreeningWebrtcLifecycleError>,
    Options<PostInterviewsScreeningWebrtcLifecycleData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcLifecycleResponse,
        AxiosError<PostInterviewsScreeningWebrtcLifecycleError>,
        Options<PostInterviewsScreeningWebrtcLifecycleData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcLifecycle({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningWebrtcNetworkProbeQueryKey = (options?: Options<GetInterviewsScreeningWebrtcNetworkProbeData>) =>
    createQueryKey('getInterviewsScreeningWebrtcNetworkProbe', options, false, ['Interviews'])

export const getInterviewsScreeningWebrtcNetworkProbeOptions = (options?: Options<GetInterviewsScreeningWebrtcNetworkProbeData>) =>
    queryOptions<
        unknown,
        AxiosError<GetInterviewsScreeningWebrtcNetworkProbeError>,
        unknown,
        ReturnType<typeof getInterviewsScreeningWebrtcNetworkProbeQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningWebrtcNetworkProbe({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningWebrtcNetworkProbeQueryKey(options),
    })

export const putInterviewsScreeningWebrtcNetworkProbeMutation = (
    options?: Partial<Options<PutInterviewsScreeningWebrtcNetworkProbeData>>
): UseMutationOptions<unknown, AxiosError<PutInterviewsScreeningWebrtcNetworkProbeError>, Options<PutInterviewsScreeningWebrtcNetworkProbeData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PutInterviewsScreeningWebrtcNetworkProbeError>,
        Options<PutInterviewsScreeningWebrtcNetworkProbeData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsScreeningWebrtcNetworkProbe({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningWebrtcOfferMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcOfferData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcOfferResponse,
    AxiosError<PostInterviewsScreeningWebrtcOfferError>,
    Options<PostInterviewsScreeningWebrtcOfferData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcOfferResponse,
        AxiosError<PostInterviewsScreeningWebrtcOfferError>,
        Options<PostInterviewsScreeningWebrtcOfferData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcOffer({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningWebrtcOutputQueryKey = (options?: Options<GetInterviewsScreeningWebrtcOutputData>) =>
    createQueryKey('getInterviewsScreeningWebrtcOutput', options, false, ['Interviews'])

/**
 * SSE proxy for the ScreenAI /output endpoint.
 */
export const getInterviewsScreeningWebrtcOutputOptions = (options?: Options<GetInterviewsScreeningWebrtcOutputData>) =>
    queryOptions<
        GetInterviewsScreeningWebrtcOutputResponse,
        AxiosError<GetInterviewsScreeningWebrtcOutputError>,
        GetInterviewsScreeningWebrtcOutputResponse,
        ReturnType<typeof getInterviewsScreeningWebrtcOutputQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningWebrtcOutput({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningWebrtcOutputQueryKey(options),
    })

export const postInterviewsScreeningWebrtcSessionMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcSessionData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcSessionResponse,
    AxiosError<PostInterviewsScreeningWebrtcSessionError>,
    Options<PostInterviewsScreeningWebrtcSessionData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcSessionResponse,
        AxiosError<PostInterviewsScreeningWebrtcSessionError>,
        Options<PostInterviewsScreeningWebrtcSessionData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Mint a short-lived candidate capability JWT for direct browser FastRTC
 */
export const postInterviewsScreeningWebrtcTokenMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcTokenData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcTokenResponse,
    AxiosError<PostInterviewsScreeningWebrtcTokenError>,
    Options<PostInterviewsScreeningWebrtcTokenData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcTokenResponse,
        AxiosError<PostInterviewsScreeningWebrtcTokenError>,
        Options<PostInterviewsScreeningWebrtcTokenData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningInterviewCandidateQueryKey = (options?: Options<GetInterviewsScreeningInterviewCandidateData>) =>
    createQueryKey('getInterviewsScreeningInterviewCandidate', options, false, ['Interviews'])

/**
 * GET handler for fetching screening interview details needed for the candidate's browser
 */
export const getInterviewsScreeningInterviewCandidateOptions = (options?: Options<GetInterviewsScreeningInterviewCandidateData>) =>
    queryOptions<
        unknown,
        AxiosError<GetInterviewsScreeningInterviewCandidateError>,
        unknown,
        ReturnType<typeof getInterviewsScreeningInterviewCandidateQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewCandidate({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewCandidateQueryKey(options),
    })

export const getInterviewsScreeningInterviewClientTokenQueryKey = (options?: Options<GetInterviewsScreeningInterviewClientTokenData>) =>
    createQueryKey('getInterviewsScreeningInterviewClientToken', options, false, ['Interviews'])

/**
 * GET /api/interviews/screeningInterview/clientToken
 */
export const getInterviewsScreeningInterviewClientTokenOptions = (options?: Options<GetInterviewsScreeningInterviewClientTokenData>) =>
    queryOptions<
        GetInterviewsScreeningInterviewClientTokenResponse,
        AxiosError<GetInterviewsScreeningInterviewClientTokenError>,
        GetInterviewsScreeningInterviewClientTokenResponse,
        ReturnType<typeof getInterviewsScreeningInterviewClientTokenQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewClientToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewClientTokenQueryKey(options),
    })

/**
 * POST /api/interviews/screeningInterview/clientToken
 */
export const postInterviewsScreeningInterviewClientTokenMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewClientTokenData>>
): UseMutationOptions<
    PostInterviewsScreeningInterviewClientTokenResponse,
    AxiosError<PostInterviewsScreeningInterviewClientTokenError>,
    Options<PostInterviewsScreeningInterviewClientTokenData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningInterviewClientTokenResponse,
        AxiosError<PostInterviewsScreeningInterviewClientTokenError>,
        Options<PostInterviewsScreeningInterviewClientTokenData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewClientToken({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningInterviewDailyRecordingMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewDailyRecordingData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostInterviewsScreeningInterviewDailyRecordingError>,
    Options<PostInterviewsScreeningInterviewDailyRecordingData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsScreeningInterviewDailyRecordingError>,
        Options<PostInterviewsScreeningInterviewDailyRecordingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewDailyRecording({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screeningInterview/endInterview
 */
export const postInterviewsScreeningInterviewEndInterviewMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewEndInterviewData>>
): UseMutationOptions<
    PostInterviewsScreeningInterviewEndInterviewResponse,
    AxiosError<PostInterviewsScreeningInterviewEndInterviewError>,
    Options<PostInterviewsScreeningInterviewEndInterviewData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningInterviewEndInterviewResponse,
        AxiosError<PostInterviewsScreeningInterviewEndInterviewError>,
        Options<PostInterviewsScreeningInterviewEndInterviewData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewEndInterview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screeningInterview/events
 */
export const postInterviewsScreeningInterviewEventsMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewEventsData>>
): UseMutationOptions<
    PostInterviewsScreeningInterviewEventsResponse,
    AxiosError<PostInterviewsScreeningInterviewEventsError>,
    Options<PostInterviewsScreeningInterviewEventsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningInterviewEventsResponse,
        AxiosError<PostInterviewsScreeningInterviewEventsError>,
        Options<PostInterviewsScreeningInterviewEventsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewEvents({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningInterviewFastrtcRecordingMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewFastrtcRecordingData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostInterviewsScreeningInterviewFastrtcRecordingError>,
    Options<PostInterviewsScreeningInterviewFastrtcRecordingData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsScreeningInterviewFastrtcRecordingError>,
        Options<PostInterviewsScreeningInterviewFastrtcRecordingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewFastrtcRecording({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screeningInterview/fetchDailyRecording
 */
export const postInterviewsScreeningInterviewFetchDailyRecordingMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewFetchDailyRecordingData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostInterviewsScreeningInterviewFetchDailyRecordingError>,
    Options<PostInterviewsScreeningInterviewFetchDailyRecordingData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsScreeningInterviewFetchDailyRecordingError>,
        Options<PostInterviewsScreeningInterviewFetchDailyRecordingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewFetchDailyRecording({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST handler for fixing liveness verification status based on screening configuration.
 */
export const postInterviewsScreeningInterviewFixLivenessStatusMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewFixLivenessStatusData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostInterviewsScreeningInterviewFixLivenessStatusError>,
    Options<PostInterviewsScreeningInterviewFixLivenessStatusData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsScreeningInterviewFixLivenessStatusError>,
        Options<PostInterviewsScreeningInterviewFixLivenessStatusData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewFixLivenessStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningInterviewIceServersQueryKey = (options?: Options<GetInterviewsScreeningInterviewIceServersData>) =>
    createQueryKey('getInterviewsScreeningInterviewIceServers', options, false, ['Interviews'])

/**
 * GET /api/interviews/screeningInterview/iceServers
 */
export const getInterviewsScreeningInterviewIceServersOptions = (options?: Options<GetInterviewsScreeningInterviewIceServersData>) =>
    queryOptions<
        GetInterviewsScreeningInterviewIceServersResponse,
        AxiosError<GetInterviewsScreeningInterviewIceServersError>,
        GetInterviewsScreeningInterviewIceServersResponse,
        ReturnType<typeof getInterviewsScreeningInterviewIceServersQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewIceServers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewIceServersQueryKey(options),
    })

export const getInterviewsScreeningInterviewProctoringQueryKey = (options?: Options<GetInterviewsScreeningInterviewProctoringData>) =>
    createQueryKey('getInterviewsScreeningInterviewProctoring', options, false, ['Interviews'])

/**
 * GET /api/interviews/screeningInterview/proctoring
 */
export const getInterviewsScreeningInterviewProctoringOptions = (options?: Options<GetInterviewsScreeningInterviewProctoringData>) =>
    queryOptions<
        GetInterviewsScreeningInterviewProctoringResponse,
        AxiosError<GetInterviewsScreeningInterviewProctoringError>,
        GetInterviewsScreeningInterviewProctoringResponse,
        ReturnType<typeof getInterviewsScreeningInterviewProctoringQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewProctoring({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewProctoringQueryKey(options),
    })

/**
 * POST /api/interviews/screeningInterview/proctoring
 */
export const postInterviewsScreeningInterviewProctoringMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewProctoringData>>
): UseMutationOptions<
    PostInterviewsScreeningInterviewProctoringResponse,
    AxiosError<PostInterviewsScreeningInterviewProctoringError>,
    Options<PostInterviewsScreeningInterviewProctoringData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningInterviewProctoringResponse,
        AxiosError<PostInterviewsScreeningInterviewProctoringError>,
        Options<PostInterviewsScreeningInterviewProctoringData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewProctoring({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningInterviewRemindQueryKey = (options?: Options<GetInterviewsScreeningInterviewRemindData>) =>
    createQueryKey('getInterviewsScreeningInterviewRemind', options, false, ['Interviews'])

export const getInterviewsScreeningInterviewRemindOptions = (options?: Options<GetInterviewsScreeningInterviewRemindData>) =>
    queryOptions<
        GetInterviewsScreeningInterviewRemindResponse,
        AxiosError<GetInterviewsScreeningInterviewRemindError>,
        GetInterviewsScreeningInterviewRemindResponse,
        ReturnType<typeof getInterviewsScreeningInterviewRemindQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewRemind({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewRemindQueryKey(options),
    })

export const getInterviewsScreeningInterviewSpeechTokenQueryKey = (options?: Options<GetInterviewsScreeningInterviewSpeechTokenData>) =>
    createQueryKey('getInterviewsScreeningInterviewSpeechToken', options, false, ['Interviews'])

/**
 * GET /api/interviews/screeningInterview/speechToken
 */
export const getInterviewsScreeningInterviewSpeechTokenOptions = (options?: Options<GetInterviewsScreeningInterviewSpeechTokenData>) =>
    queryOptions<
        GetInterviewsScreeningInterviewSpeechTokenResponse,
        AxiosError<GetInterviewsScreeningInterviewSpeechTokenError>,
        GetInterviewsScreeningInterviewSpeechTokenResponse,
        ReturnType<typeof getInterviewsScreeningInterviewSpeechTokenQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewSpeechToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewSpeechTokenQueryKey(options),
    })

/**
 * POST handler for starting a screening interview.
 */
export const postInterviewsScreeningInterviewStartMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewStartData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningInterviewStartError>, Options<PostInterviewsScreeningInterviewStartData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsScreeningInterviewStartError>,
        Options<PostInterviewsScreeningInterviewStartData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewStart({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screeningInterview/transitionToStarted
 */
export const postInterviewsScreeningInterviewTransitionToStartedMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewTransitionToStartedData>>
): UseMutationOptions<
    PostInterviewsScreeningInterviewTransitionToStartedResponse,
    AxiosError<PostInterviewsScreeningInterviewTransitionToStartedError>,
    Options<PostInterviewsScreeningInterviewTransitionToStartedData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningInterviewTransitionToStartedResponse,
        AxiosError<PostInterviewsScreeningInterviewTransitionToStartedError>,
        Options<PostInterviewsScreeningInterviewTransitionToStartedData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewTransitionToStarted({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteInterviewsIdInterviewRoundInterviewRoundIdMutation = (
    options?: Partial<Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdData>>
): UseMutationOptions<
    DeleteInterviewsIdInterviewRoundInterviewRoundIdResponse,
    AxiosError<DeleteInterviewsIdInterviewRoundInterviewRoundIdError>,
    Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteInterviewsIdInterviewRoundInterviewRoundIdResponse,
        AxiosError<DeleteInterviewsIdInterviewRoundInterviewRoundIdError>,
        Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsIdInterviewRoundInterviewRoundId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putInterviewsIdInterviewRoundInterviewRoundIdMutation = (
    options?: Partial<Options<PutInterviewsIdInterviewRoundInterviewRoundIdData>>
): UseMutationOptions<unknown, AxiosError<PutInterviewsIdInterviewRoundInterviewRoundIdError>, Options<PutInterviewsIdInterviewRoundInterviewRoundIdData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PutInterviewsIdInterviewRoundInterviewRoundIdError>,
        Options<PutInterviewsIdInterviewRoundInterviewRoundIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putInterviewsIdInterviewRoundInterviewRoundId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningCallIdRecordingQueryKey = (options: Options<GetInterviewsScreeningCallIdRecordingData>) =>
    createQueryKey('getInterviewsScreeningCallIdRecording', options, false, ['Interviews'])

/**
 * GET /api/interviews/screening-call/[id]/recording — short-lived signed URL for an AI phone screening call recording.
 *
 * Caller must belong to the call's company. 404 when the call has no recording.
 */
export const getInterviewsScreeningCallIdRecordingOptions = (options: Options<GetInterviewsScreeningCallIdRecordingData>) =>
    queryOptions<
        GetInterviewsScreeningCallIdRecordingResponse,
        AxiosError<GetInterviewsScreeningCallIdRecordingError>,
        GetInterviewsScreeningCallIdRecordingResponse,
        ReturnType<typeof getInterviewsScreeningCallIdRecordingQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningCallIdRecording({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningCallIdRecordingQueryKey(options),
    })

export const postInterviewsScreeningWebrtcRecordingChunkMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcRecordingChunkData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcRecordingChunkResponse,
    AxiosError<PostInterviewsScreeningWebrtcRecordingChunkError>,
    Options<PostInterviewsScreeningWebrtcRecordingChunkData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcRecordingChunkResponse,
        AxiosError<PostInterviewsScreeningWebrtcRecordingChunkError>,
        Options<PostInterviewsScreeningWebrtcRecordingChunkData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcRecordingChunk({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Post-flush recording compose. ScreenAI lifecycle (interview_completed / client_end /
 */
export const postInterviewsScreeningWebrtcRecordingFinalizeMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcRecordingFinalizeData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcRecordingFinalizeResponse,
    AxiosError<PostInterviewsScreeningWebrtcRecordingFinalizeError>,
    Options<PostInterviewsScreeningWebrtcRecordingFinalizeData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcRecordingFinalizeResponse,
        AxiosError<PostInterviewsScreeningWebrtcRecordingFinalizeError>,
        Options<PostInterviewsScreeningWebrtcRecordingFinalizeData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcRecordingFinalize({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningWebrtcRecordingInitMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcRecordingInitData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcRecordingInitResponse,
    AxiosError<PostInterviewsScreeningWebrtcRecordingInitError>,
    Options<PostInterviewsScreeningWebrtcRecordingInitData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcRecordingInitResponse,
        AxiosError<PostInterviewsScreeningWebrtcRecordingInitError>,
        Options<PostInterviewsScreeningWebrtcRecordingInitData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcRecordingInit({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Mint a signed PUT URL for one GCS compose part (or Azure unused path).
 */
export const postInterviewsScreeningWebrtcRecordingPartUrlMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcRecordingPartUrlData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcRecordingPartUrlResponse,
    AxiosError<PostInterviewsScreeningWebrtcRecordingPartUrlError>,
    Options<PostInterviewsScreeningWebrtcRecordingPartUrlData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcRecordingPartUrlResponse,
        AxiosError<PostInterviewsScreeningWebrtcRecordingPartUrlError>,
        Options<PostInterviewsScreeningWebrtcRecordingPartUrlData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcRecordingPartUrl({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningWebrtcSessionLogAppendMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcSessionLogAppendData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcSessionLogAppendResponse,
    AxiosError<PostInterviewsScreeningWebrtcSessionLogAppendError>,
    Options<PostInterviewsScreeningWebrtcSessionLogAppendData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcSessionLogAppendResponse,
        AxiosError<PostInterviewsScreeningWebrtcSessionLogAppendError>,
        Options<PostInterviewsScreeningWebrtcSessionLogAppendData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcSessionLogAppend({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Leave-path session-log finalize (Phase 1 dual-write). Prefer ScreenAI lifecycle.
 */
export const postInterviewsScreeningWebrtcSessionLogFinalizeMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcSessionLogFinalizeData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcSessionLogFinalizeResponse,
    AxiosError<PostInterviewsScreeningWebrtcSessionLogFinalizeError>,
    Options<PostInterviewsScreeningWebrtcSessionLogFinalizeData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcSessionLogFinalizeResponse,
        AxiosError<PostInterviewsScreeningWebrtcSessionLogFinalizeError>,
        Options<PostInterviewsScreeningWebrtcSessionLogFinalizeData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcSessionLogFinalize({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/interviews/screeningInterview/clientToken/[id]
 */
export const deleteInterviewsScreeningInterviewClientTokenIdMutation = (
    options?: Partial<Options<DeleteInterviewsScreeningInterviewClientTokenIdData>>
): UseMutationOptions<
    DeleteInterviewsScreeningInterviewClientTokenIdResponse,
    AxiosError<DeleteInterviewsScreeningInterviewClientTokenIdError>,
    Options<DeleteInterviewsScreeningInterviewClientTokenIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteInterviewsScreeningInterviewClientTokenIdResponse,
        AxiosError<DeleteInterviewsScreeningInterviewClientTokenIdError>,
        Options<DeleteInterviewsScreeningInterviewClientTokenIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsScreeningInterviewClientTokenId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/interviews/screeningInterview/identity-check/[id]
 */
export const deleteInterviewsScreeningInterviewIdentityCheckIdMutation = (
    options?: Partial<Options<DeleteInterviewsScreeningInterviewIdentityCheckIdData>>
): UseMutationOptions<
    unknown,
    AxiosError<DeleteInterviewsScreeningInterviewIdentityCheckIdError>,
    Options<DeleteInterviewsScreeningInterviewIdentityCheckIdData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<DeleteInterviewsScreeningInterviewIdentityCheckIdError>,
        Options<DeleteInterviewsScreeningInterviewIdentityCheckIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsScreeningInterviewIdentityCheckId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getInterviewsScreeningInterviewIdentityCheckIdQueryKey = (options: Options<GetInterviewsScreeningInterviewIdentityCheckIdData>) =>
    createQueryKey('getInterviewsScreeningInterviewIdentityCheckId', options, false, ['Interviews'])

/**
 * GET /api/interviews/screeningInterview/identity-check/[id]
 */
export const getInterviewsScreeningInterviewIdentityCheckIdOptions = (options: Options<GetInterviewsScreeningInterviewIdentityCheckIdData>) =>
    queryOptions<
        unknown,
        AxiosError<GetInterviewsScreeningInterviewIdentityCheckIdError>,
        unknown,
        ReturnType<typeof getInterviewsScreeningInterviewIdentityCheckIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getInterviewsScreeningInterviewIdentityCheckId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getInterviewsScreeningInterviewIdentityCheckIdQueryKey(options),
    })

/**
 * DELETE /api/interviews/screeningInterview/speechToken/[id]
 */
export const deleteInterviewsScreeningInterviewSpeechTokenIdMutation = (
    options?: Partial<Options<DeleteInterviewsScreeningInterviewSpeechTokenIdData>>
): UseMutationOptions<
    DeleteInterviewsScreeningInterviewSpeechTokenIdResponse,
    AxiosError<DeleteInterviewsScreeningInterviewSpeechTokenIdError>,
    Options<DeleteInterviewsScreeningInterviewSpeechTokenIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteInterviewsScreeningInterviewSpeechTokenIdResponse,
        AxiosError<DeleteInterviewsScreeningInterviewSpeechTokenIdError>,
        Options<DeleteInterviewsScreeningInterviewSpeechTokenIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsScreeningInterviewSpeechTokenId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningInterviewTtsEnsureMutation = (
    options?: Partial<Options<PostInterviewsScreeningInterviewTtsEnsureData>>
): UseMutationOptions<unknown, AxiosError<PostInterviewsScreeningInterviewTtsEnsureError>, Options<PostInterviewsScreeningInterviewTtsEnsureData>> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsScreeningInterviewTtsEnsureError>,
        Options<PostInterviewsScreeningInterviewTtsEnsureData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningInterviewTtsEnsure({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryMutation = (
    options?: Partial<Options<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData>>
): UseMutationOptions<
    PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponse,
    AxiosError<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError>,
    Options<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryResponse,
        AxiosError<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError>,
        Options<PatchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/interviewRound/endInterview
 */
export const postInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryMutation = (
    options?: Partial<Options<PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError>,
    Options<PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryError>,
        Options<PostInterviewsIdInterviewRoundInterviewRoundIdGenerateSummaryData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsIdInterviewRoundInterviewRoundIdGenerateSummary({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteInterviewsIdInterviewRoundInterviewRoundIdPanellistMutation = (
    options?: Partial<Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData>>
): UseMutationOptions<
    unknown,
    AxiosError<DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistError>,
    Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistError>,
        Options<DeleteInterviewsIdInterviewRoundInterviewRoundIdPanellistData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteInterviewsIdInterviewRoundInterviewRoundIdPanellist({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsIdInterviewRoundInterviewRoundIdRatingsMutation = (
    options?: Partial<Options<PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData>>
): UseMutationOptions<
    unknown,
    AxiosError<PostInterviewsIdInterviewRoundInterviewRoundIdRatingsError>,
    Options<PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData>
> => {
    const mutationOptions: UseMutationOptions<
        unknown,
        AxiosError<PostInterviewsIdInterviewRoundInterviewRoundIdRatingsError>,
        Options<PostInterviewsIdInterviewRoundInterviewRoundIdRatingsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsIdInterviewRoundInterviewRoundIdRatings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/interviews/screening-call/[id]/recording/fetch — fetch a missing AI phone screening call recording from the provider.
 *
 * Looks the call's recording up at its telephony provider (Plivo / Twilio) and stores it like the provider's
 */
export const postInterviewsScreeningCallIdRecordingFetchMutation = (
    options?: Partial<Options<PostInterviewsScreeningCallIdRecordingFetchData>>
): UseMutationOptions<
    PostInterviewsScreeningCallIdRecordingFetchResponse,
    AxiosError<PostInterviewsScreeningCallIdRecordingFetchError>,
    Options<PostInterviewsScreeningCallIdRecordingFetchData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningCallIdRecordingFetchResponse,
        AxiosError<PostInterviewsScreeningCallIdRecordingFetchError>,
        Options<PostInterviewsScreeningCallIdRecordingFetchData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningCallIdRecordingFetch({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postInterviewsScreeningWebrtcSessionSessionIdConnectMutation = (
    options?: Partial<Options<PostInterviewsScreeningWebrtcSessionSessionIdConnectData>>
): UseMutationOptions<
    PostInterviewsScreeningWebrtcSessionSessionIdConnectResponse,
    AxiosError<PostInterviewsScreeningWebrtcSessionSessionIdConnectError>,
    Options<PostInterviewsScreeningWebrtcSessionSessionIdConnectData>
> => {
    const mutationOptions: UseMutationOptions<
        PostInterviewsScreeningWebrtcSessionSessionIdConnectResponse,
        AxiosError<PostInterviewsScreeningWebrtcSessionSessionIdConnectError>,
        Options<PostInterviewsScreeningWebrtcSessionSessionIdConnectData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postInterviewsScreeningWebrtcSessionSessionIdConnect({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJdAgentConversationQueryKey = (options?: Options<GetJdAgentConversationData>) =>
    createQueryKey('getJdAgentConversation', options, false, ['Jd-agent'])

export const getJdAgentConversationOptions = (options?: Options<GetJdAgentConversationData>) =>
    queryOptions<
        GetJdAgentConversationResponse,
        AxiosError<GetJdAgentConversationError>,
        GetJdAgentConversationResponse,
        ReturnType<typeof getJdAgentConversationQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJdAgentConversation({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJdAgentConversationQueryKey(options),
    })

export const getJdAgentSpeechTokenQueryKey = (options?: Options<GetJdAgentSpeechTokenData>) =>
    createQueryKey('getJdAgentSpeechToken', options, false, ['Jd-agent'])

export const getJdAgentSpeechTokenOptions = (options?: Options<GetJdAgentSpeechTokenData>) =>
    queryOptions<
        GetJdAgentSpeechTokenResponse,
        AxiosError<GetJdAgentSpeechTokenError>,
        GetJdAgentSpeechTokenResponse,
        ReturnType<typeof getJdAgentSpeechTokenQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJdAgentSpeechToken({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJdAgentSpeechTokenQueryKey(options),
    })

export const postJdAgentConversationSyncMutation = (
    options?: Partial<Options<PostJdAgentConversationSyncData>>
): UseMutationOptions<PostJdAgentConversationSyncResponse, AxiosError<PostJdAgentConversationSyncError>, Options<PostJdAgentConversationSyncData>> => {
    const mutationOptions: UseMutationOptions<
        PostJdAgentConversationSyncResponse,
        AxiosError<PostJdAgentConversationSyncError>,
        Options<PostJdAgentConversationSyncData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJdAgentConversationSync({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postJdAgentBackendMutation = (
    options?: Partial<Options<PostJdAgentBackendData>>
): UseMutationOptions<PostJdAgentBackendResponse, AxiosError<PostJdAgentBackendError>, Options<PostJdAgentBackendData>> => {
    const mutationOptions: UseMutationOptions<PostJdAgentBackendResponse, AxiosError<PostJdAgentBackendError>, Options<PostJdAgentBackendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJdAgentBackend({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postJdAgentBackendStreamMutation = (
    options?: Partial<Options<PostJdAgentBackendStreamData>>
): UseMutationOptions<PostJdAgentBackendStreamResponse, AxiosError<PostJdAgentBackendStreamError>, Options<PostJdAgentBackendStreamData>> => {
    const mutationOptions: UseMutationOptions<
        PostJdAgentBackendStreamResponse,
        AxiosError<PostJdAgentBackendStreamError>,
        Options<PostJdAgentBackendStreamData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJdAgentBackendStream({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobApplicationsQueryKey = (options: Options<GetJobApplicationsData>) =>
    createQueryKey('getJobApplications', options, false, ['JobApplications'])

/**
 * TODO: Split this handler into smaller, well-named helper functions for maintainability
 *
 * List job applications — powers the per-job Applications grid and the referrals list. Handles special filtering for AI interview score/status. Free text goes in `filterModel.quickFilterValues`.
 */
export const getJobApplicationsOptions = (options: Options<GetJobApplicationsData>) =>
    queryOptions<GetJobApplicationsResponse, AxiosError<GetJobApplicationsError>, GetJobApplicationsResponse, ReturnType<typeof getJobApplicationsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApplications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApplicationsQueryKey(options),
    })

export const patchJobApplicationsMutation = (
    options?: Partial<Options<PatchJobApplicationsData>>
): UseMutationOptions<PatchJobApplicationsResponse, AxiosError<PatchJobApplicationsError>, Options<PatchJobApplicationsData>> => {
    const mutationOptions: UseMutationOptions<PatchJobApplicationsResponse, AxiosError<PatchJobApplicationsError>, Options<PatchJobApplicationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJobApplications({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobApplications — add applications to a job (recruiter add/bulk upload, talent-pool add-to-job,
 *
 * Deprecated: Only used by demote-candidates and affected-candidates for rule-based filtering. List queries now use isShortlisted column directly.
 *
 * @deprecated
 */
export const postJobApplicationsMutation = (
    options?: Partial<Options<PostJobApplicationsData>>
): UseMutationOptions<PostJobApplicationsResponse, AxiosError<PostJobApplicationsError>, Options<PostJobApplicationsData>> => {
    const mutationOptions: UseMutationOptions<PostJobApplicationsResponse, AxiosError<PostJobApplicationsError>, Options<PostJobApplicationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApplications({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/jobApplications/{id}
 *
 * Deletes one job application, its JACD candidate-details subtree, and the resume blob when no other application or document references it. Notifies the processing backend and re-dispatches queued applications afterwards.
 */
export const deleteJobApplicationsIdMutation = (
    options?: Partial<Options<DeleteJobApplicationsIdData>>
): UseMutationOptions<DeleteJobApplicationsIdResponse, AxiosError<DeleteJobApplicationsIdError>, Options<DeleteJobApplicationsIdData>> => {
    const mutationOptions: UseMutationOptions<
        DeleteJobApplicationsIdResponse,
        AxiosError<DeleteJobApplicationsIdError>,
        Options<DeleteJobApplicationsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteJobApplicationsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobApplicationsIdQueryKey = (options: Options<GetJobApplicationsIdData>) =>
    createQueryKey('getJobApplicationsId', options, false, ['JobApplications'])

export const getJobApplicationsIdOptions = (options: Options<GetJobApplicationsIdData>) =>
    queryOptions<
        GetJobApplicationsIdResponse,
        AxiosError<GetJobApplicationsIdError>,
        GetJobApplicationsIdResponse,
        ReturnType<typeof getJobApplicationsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApplicationsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApplicationsIdQueryKey(options),
    })

/**
 * / This is called for resubmitting the jobApplication for backend Processing again.
 */
export const postJobApplicationsIdMutation = (
    options?: Partial<Options<PostJobApplicationsIdData>>
): UseMutationOptions<PostJobApplicationsIdResponse, AxiosError<PostJobApplicationsIdError>, Options<PostJobApplicationsIdData>> => {
    const mutationOptions: UseMutationOptions<PostJobApplicationsIdResponse, AxiosError<PostJobApplicationsIdError>, Options<PostJobApplicationsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApplicationsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putJobApplicationsIdMutation = (
    options?: Partial<Options<PutJobApplicationsIdData>>
): UseMutationOptions<PutJobApplicationsIdResponse, AxiosError<PutJobApplicationsIdError>, Options<PutJobApplicationsIdData>> => {
    const mutationOptions: UseMutationOptions<PutJobApplicationsIdResponse, AxiosError<PutJobApplicationsIdError>, Options<PutJobApplicationsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putJobApplicationsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putJobApplicationsApproveMutation = (
    options?: Partial<Options<PutJobApplicationsApproveData>>
): UseMutationOptions<PutJobApplicationsApproveResponse, AxiosError<PutJobApplicationsApproveError>, Options<PutJobApplicationsApproveData>> => {
    const mutationOptions: UseMutationOptions<
        PutJobApplicationsApproveResponse,
        AxiosError<PutJobApplicationsApproveError>,
        Options<PutJobApplicationsApproveData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putJobApplicationsApprove({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postJobApplicationsBulkDeleteMutation = (
    options?: Partial<Options<PostJobApplicationsBulkDeleteData>>
): UseMutationOptions<PostJobApplicationsBulkDeleteResponse, AxiosError<PostJobApplicationsBulkDeleteError>, Options<PostJobApplicationsBulkDeleteData>> => {
    const mutationOptions: UseMutationOptions<
        PostJobApplicationsBulkDeleteResponse,
        AxiosError<PostJobApplicationsBulkDeleteError>,
        Options<PostJobApplicationsBulkDeleteData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApplicationsBulkDelete({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobApplications/bulk-reprocess
 */
export const postJobApplicationsBulkReprocessMutation = (
    options?: Partial<Options<PostJobApplicationsBulkReprocessData>>
): UseMutationOptions<
    PostJobApplicationsBulkReprocessResponse,
    AxiosError<PostJobApplicationsBulkReprocessError>,
    Options<PostJobApplicationsBulkReprocessData>
> => {
    const mutationOptions: UseMutationOptions<
        PostJobApplicationsBulkReprocessResponse,
        AxiosError<PostJobApplicationsBulkReprocessError>,
        Options<PostJobApplicationsBulkReprocessData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApplicationsBulkReprocess({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobApplicationsProcessingQueryKey = (options: Options<GetJobApplicationsProcessingData>) =>
    createQueryKey('getJobApplicationsProcessing', options, false, ['JobApplications'])

/**
 * GET /api/jobApplications/processing
 *
 * Resume-processing workspace rows for a job (unprocessed/failed subset) plus status counts across all its applications — powers the Add Candidates grid.
 */
export const getJobApplicationsProcessingOptions = (options: Options<GetJobApplicationsProcessingData>) =>
    queryOptions<
        GetJobApplicationsProcessingResponse,
        AxiosError<GetJobApplicationsProcessingError>,
        GetJobApplicationsProcessingResponse,
        ReturnType<typeof getJobApplicationsProcessingQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApplicationsProcessing({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApplicationsProcessingQueryKey(options),
    })

export const getJobApplicationsProcessingInfiniteQueryKey = (
    options: Options<GetJobApplicationsProcessingData>
): QueryKey<Options<GetJobApplicationsProcessingData>> => createQueryKey('getJobApplicationsProcessing', options, true)

/**
 * GET /api/jobApplications/processing
 *
 * Resume-processing workspace rows for a job (unprocessed/failed subset) plus status counts across all its applications — powers the Add Candidates grid.
 */
export const getJobApplicationsProcessingInfiniteOptions = (options: Options<GetJobApplicationsProcessingData>) => {
    const opts = infiniteQueryOptions<
        GetJobApplicationsProcessingResponse,
        AxiosError<GetJobApplicationsProcessingError>,
        InfiniteData<GetJobApplicationsProcessingResponse>,
        QueryKey<Options<GetJobApplicationsProcessingData>>,
        string | Pick<QueryKey<Options<GetJobApplicationsProcessingData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetJobApplicationsProcessingData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getJobApplicationsProcessing({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getJobApplicationsProcessingInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

export const getJobApplicationsStatusQueryKey = (options?: Options<GetJobApplicationsStatusData>) =>
    createQueryKey('getJobApplicationsStatus', options, false, ['JobApplications'])

export const getJobApplicationsStatusOptions = (options?: Options<GetJobApplicationsStatusData>) =>
    queryOptions<
        GetJobApplicationsStatusResponse,
        AxiosError<GetJobApplicationsStatusError>,
        GetJobApplicationsStatusResponse,
        ReturnType<typeof getJobApplicationsStatusQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApplicationsStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApplicationsStatusQueryKey(options),
    })

export const patchJobApplicationsStatusMutation = (
    options?: Partial<Options<PatchJobApplicationsStatusData>>
): UseMutationOptions<PatchJobApplicationsStatusResponse, AxiosError<PatchJobApplicationsStatusError>, Options<PatchJobApplicationsStatusData>> => {
    const mutationOptions: UseMutationOptions<
        PatchJobApplicationsStatusResponse,
        AxiosError<PatchJobApplicationsStatusError>,
        Options<PatchJobApplicationsStatusData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJobApplicationsStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobApplicationsIdApplicantHistoryQueryKey = (options: Options<GetJobApplicationsIdApplicantHistoryData>) =>
    createQueryKey('getJobApplicationsIdApplicantHistory', options, false, ['JobApplications'])

/**
 * GET /api/jobApplications/{id}/applicantHistory
 *
 * The candidate's other applications and active interview rounds in the same company, matched by the application's email. Returns empty history (still 200) if computing it fails.
 */
export const getJobApplicationsIdApplicantHistoryOptions = (options: Options<GetJobApplicationsIdApplicantHistoryData>) =>
    queryOptions<
        GetJobApplicationsIdApplicantHistoryResponse,
        AxiosError<GetJobApplicationsIdApplicantHistoryError>,
        GetJobApplicationsIdApplicantHistoryResponse,
        ReturnType<typeof getJobApplicationsIdApplicantHistoryQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApplicationsIdApplicantHistory({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApplicationsIdApplicantHistoryQueryKey(options),
    })

/**
 * POST /api/jobApplications/{id}/reprocess
 *
 * Re-queues one application for resume processing — holds resume credits (403 with an ApiError envelope when the plan limit is hit).
 */
export const postJobApplicationsIdReprocessMutation = (
    options?: Partial<Options<PostJobApplicationsIdReprocessData>>
): UseMutationOptions<PostJobApplicationsIdReprocessResponse, AxiosError<PostJobApplicationsIdReprocessError>, Options<PostJobApplicationsIdReprocessData>> => {
    const mutationOptions: UseMutationOptions<
        PostJobApplicationsIdReprocessResponse,
        AxiosError<PostJobApplicationsIdReprocessError>,
        Options<PostJobApplicationsIdReprocessData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApplicationsIdReprocess({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobApproversQueryKey = (options?: Options<GetJobApproversData>) => createQueryKey('getJobApprovers', options, false, ['JobApprovers'])

export const getJobApproversOptions = (options?: Options<GetJobApproversData>) =>
    queryOptions<GetJobApproversResponse, AxiosError<GetJobApproversError>, GetJobApproversResponse, ReturnType<typeof getJobApproversQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApprovers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApproversQueryKey(options),
    })

export const postJobApproversMutation = (
    options?: Partial<Options<PostJobApproversData>>
): UseMutationOptions<PostJobApproversResponse, AxiosError<PostJobApproversError>, Options<PostJobApproversData>> => {
    const mutationOptions: UseMutationOptions<PostJobApproversResponse, AxiosError<PostJobApproversError>, Options<PostJobApproversData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApprovers({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobApproversApproveQueryKey = (options?: Options<GetJobApproversApproveData>) =>
    createQueryKey('getJobApproversApprove', options, false, ['JobApprovers'])

export const getJobApproversApproveOptions = (options?: Options<GetJobApproversApproveData>) =>
    queryOptions<
        GetJobApproversApproveResponse,
        AxiosError<GetJobApproversApproveError>,
        GetJobApproversApproveResponse,
        ReturnType<typeof getJobApproversApproveQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobApproversApprove({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobApproversApproveQueryKey(options),
    })

export const putJobApproversApproveMutation = (
    options?: Partial<Options<PutJobApproversApproveData>>
): UseMutationOptions<PutJobApproversApproveResponse, AxiosError<PutJobApproversApproveError>, Options<PutJobApproversApproveData>> => {
    const mutationOptions: UseMutationOptions<PutJobApproversApproveResponse, AxiosError<PutJobApproversApproveError>, Options<PutJobApproversApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putJobApproversApprove({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobApprovers/bypass/[id]
 */
export const postJobApproversBypassIdMutation = (
    options?: Partial<Options<PostJobApproversBypassIdData>>
): UseMutationOptions<unknown, AxiosError<PostJobApproversBypassIdError>, Options<PostJobApproversBypassIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostJobApproversBypassIdError>, Options<PostJobApproversBypassIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApproversBypassId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postJobApproversReminderIdMutation = (
    options?: Partial<Options<PostJobApproversReminderIdData>>
): UseMutationOptions<PostJobApproversReminderIdResponse, AxiosError<PostJobApproversReminderIdError>, Options<PostJobApproversReminderIdData>> => {
    const mutationOptions: UseMutationOptions<
        PostJobApproversReminderIdResponse,
        AxiosError<PostJobApproversReminderIdError>,
        Options<PostJobApproversReminderIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobApproversReminderId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJdQueryKey = (options?: Options<GetJdData>) => createQueryKey('getJd', options, false, ['JobDescription'])

/**
 * GET /api/jd
 *
 * List job descriptions for the session company. `companyId` in the query is accepted for compatibility but must match the session company.
 */
export const getJdOptions = (options?: Options<GetJdData>) =>
    queryOptions<GetJdResponse, AxiosError<GetJdError>, GetJdResponse, ReturnType<typeof getJdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJd({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJdQueryKey(options),
    })

export const getJdInfiniteQueryKey = (options?: Options<GetJdData>): QueryKey<Options<GetJdData>> => createQueryKey('getJd', options, true)

/**
 * GET /api/jd
 *
 * List job descriptions for the session company. `companyId` in the query is accepted for compatibility but must match the session company.
 */
export const getJdInfiniteOptions = (options?: Options<GetJdData>) => {
    const opts = infiniteQueryOptions<
        GetJdResponse,
        AxiosError<GetJdError>,
        InfiniteData<GetJdResponse>,
        QueryKey<Options<GetJdData>>,
        string | Pick<QueryKey<Options<GetJdData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetJdData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getJd({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getJdInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * POST /api/jd
 *
 * Create a job description for the session company. `companyId` in the body is accepted for compatibility but must match the session company.
 */
export const postJdMutation = (options?: Partial<Options<PostJdData>>): UseMutationOptions<PostJdResponse, AxiosError<PostJdError>, Options<PostJdData>> => {
    const mutationOptions: UseMutationOptions<PostJdResponse, AxiosError<PostJdError>, Options<PostJdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJd({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/jd/{id}
 *
 * Delete a job description. Scoped to the session company; 409 while live job postings still reference it.
 */
export const deleteJdIdMutation = (
    options?: Partial<Options<DeleteJdIdData>>
): UseMutationOptions<DeleteJdIdResponse, AxiosError<DeleteJdIdError>, Options<DeleteJdIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteJdIdResponse, AxiosError<DeleteJdIdError>, Options<DeleteJdIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteJdId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJdIdQueryKey = (options: Options<GetJdIdData>) => createQueryKey('getJdId', options, false, ['JobDescription'])

/**
 * GET /api/jd/{id}
 *
 * Fetch a single job description. Public — powers guest create-jd links and the candidate-sharing page; never includes company data.
 */
export const getJdIdOptions = (options: Options<GetJdIdData>) =>
    queryOptions<GetJdIdResponse, AxiosError<GetJdIdError>, GetJdIdResponse, ReturnType<typeof getJdIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJdId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJdIdQueryKey(options),
    })

/**
 * PATCH /api/jd/{id}
 *
 * Update a job description. Scoped to the session company; a changed `content` re-syncs JD agent state and reprocesses live linked job postings.
 */
export const patchJdIdMutation = (
    options?: Partial<Options<PatchJdIdData>>
): UseMutationOptions<PatchJdIdResponse, AxiosError<PatchJdIdError>, Options<PatchJdIdData>> => {
    const mutationOptions: UseMutationOptions<PatchJdIdResponse, AxiosError<PatchJdIdError>, Options<PatchJdIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJdId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJdExtractTextQueryKey = (options: Options<GetJdExtractTextData>) => createQueryKey('getJdExtractText', options, false, ['JobDescription'])

/**
 * GET /api/jd/extract-text
 *
 * Extract text from a JD document already in blob storage. `fileUrl` must be a storage object URL.
 */
export const getJdExtractTextOptions = (options: Options<GetJdExtractTextData>) =>
    queryOptions<GetJdExtractTextResponse, AxiosError<GetJdExtractTextError>, GetJdExtractTextResponse, ReturnType<typeof getJdExtractTextQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJdExtractText({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJdExtractTextQueryKey(options),
    })

/**
 * POST /api/jd/extract-text
 *
 * Extract text from an uploaded JD document (PDF, DOCX, or TXT up to 10 MB). The file signature must match the declared type.
 */
export const postJdExtractTextMutation = (
    options?: Partial<Options<PostJdExtractTextData>>
): UseMutationOptions<PostJdExtractTextResponse, AxiosError<PostJdExtractTextError>, Options<PostJdExtractTextData>> => {
    const mutationOptions: UseMutationOptions<PostJdExtractTextResponse, AxiosError<PostJdExtractTextError>, Options<PostJdExtractTextData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJdExtractText({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJdIdLinkedJobsQueryKey = (options: Options<GetJdIdLinkedJobsData>) => createQueryKey('getJdIdLinkedJobs', options, false, ['JobDescription'])

/**
 * GET /api/jd/{id}/linked-jobs
 *
 * List the live job postings that use a job description (id, title, created date), newest first. Signed-in only and scoped to the session company — the public JD endpoint only exposes the count.
 */
export const getJdIdLinkedJobsOptions = (options: Options<GetJdIdLinkedJobsData>) =>
    queryOptions<GetJdIdLinkedJobsResponse, AxiosError<GetJdIdLinkedJobsError>, GetJdIdLinkedJobsResponse, ReturnType<typeof getJdIdLinkedJobsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJdIdLinkedJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJdIdLinkedJobsQueryKey(options),
    })

export const patchJobOpeningsIdMutation = (
    options?: Partial<Options<PatchJobOpeningsIdData>>
): UseMutationOptions<unknown, AxiosError<PatchJobOpeningsIdError>, Options<PatchJobOpeningsIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PatchJobOpeningsIdError>, Options<PatchJobOpeningsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJobOpeningsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobsQueryKey = (options?: Options<GetJobsData>) => createQueryKey('getJobs', options, false, ['Jobs'])

/**
 * GET /api/jobs
 *
 * List job postings for the session company — powers the My Jobs grid. Free-text search goes in `filterModel.searchTerms` and is tokenized server-side.
 */
export const getJobsOptions = (options?: Options<GetJobsData>) =>
    queryOptions<GetJobsResponse, AxiosError<GetJobsError>, GetJobsResponse, ReturnType<typeof getJobsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsQueryKey(options),
    })

/**
 * POST /api/jobs — create a job posting
 *
 * Signed-in users, or verified backend callers (Marlee) acting for one. The body is validated against the company's JobPosting field config (required fields, options, JD selection, min/max pairs); a 400 lists every field issue in `errors`. Only parsed values are stored.
 */
export const postJobsMutation = (
    options?: Partial<Options<PostJobsData>>
): UseMutationOptions<PostJobsResponse, AxiosError<PostJobsError>, Options<PostJobsData>> => {
    const mutationOptions: UseMutationOptions<PostJobsResponse, AxiosError<PostJobsError>, Options<PostJobsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobs({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/jobs/[id]
 */
export const deleteJobsIdMutation = (
    options?: Partial<Options<DeleteJobsIdData>>
): UseMutationOptions<DeleteJobsIdResponse, AxiosError<DeleteJobsIdError>, Options<DeleteJobsIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteJobsIdResponse, AxiosError<DeleteJobsIdError>, Options<DeleteJobsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteJobsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobsIdQueryKey = (options: Options<GetJobsIdData>) => createQueryKey('getJobsId', options, false, ['Jobs'])

/**
 * GET /api/jobs/[id]
 */
export const getJobsIdOptions = (options: Options<GetJobsIdData>) =>
    queryOptions<unknown, AxiosError<GetJobsIdError>, unknown, ReturnType<typeof getJobsIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdQueryKey(options),
    })

/**
 * PUT /api/jobs/[id]
 */
export const putJobsIdMutation = (
    options?: Partial<Options<PutJobsIdData>>
): UseMutationOptions<PutJobsIdResponse, AxiosError<PutJobsIdError>, Options<PutJobsIdData>> => {
    const mutationOptions: UseMutationOptions<PutJobsIdResponse, AxiosError<PutJobsIdError>, Options<PutJobsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putJobsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postJobsBulkDeleteMutation = (
    options?: Partial<Options<PostJobsBulkDeleteData>>
): UseMutationOptions<PostJobsBulkDeleteResponse, AxiosError<PostJobsBulkDeleteError>, Options<PostJobsBulkDeleteData>> => {
    const mutationOptions: UseMutationOptions<PostJobsBulkDeleteResponse, AxiosError<PostJobsBulkDeleteError>, Options<PostJobsBulkDeleteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobsBulkDelete({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobsSearchQueryKey = (options?: Options<GetJobsSearchData>) => createQueryKey('getJobsSearch', options, false, ['Jobs'])

export const getJobsSearchOptions = (options?: Options<GetJobsSearchData>) =>
    queryOptions<GetJobsSearchResponse, AxiosError<GetJobsSearchError>, GetJobsSearchResponse, ReturnType<typeof getJobsSearchQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsSearch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsSearchQueryKey(options),
    })

export const getJobsIdActivityQueryKey = (options: Options<GetJobsIdActivityData>) => createQueryKey('getJobsIdActivity', options, false, ['Jobs'])

/**
 * GET /api/jobs/[id]/activity — the job's activity log, newest first.
 *
 * Merged at read time from posting, position and application activity history and the posting's approvals. Cursor-paginated (`cursor` / `nextCursor`, not page/pageSize — the feed has no stable offsets). Requires the JOB_ACTIVITY_TAB feature flag. Session callers need read access to the job; M2M callers are checked for tenancy only, like GET /api/jobs/[id].
 */
export const getJobsIdActivityOptions = (options: Options<GetJobsIdActivityData>) =>
    queryOptions<GetJobsIdActivityResponse, AxiosError<GetJobsIdActivityError>, GetJobsIdActivityResponse, ReturnType<typeof getJobsIdActivityQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsIdActivity({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdActivityQueryKey(options),
    })

export const getJobsIdActivityInfiniteQueryKey = (options: Options<GetJobsIdActivityData>): QueryKey<Options<GetJobsIdActivityData>> =>
    createQueryKey('getJobsIdActivity', options, true)

/**
 * GET /api/jobs/[id]/activity — the job's activity log, newest first.
 *
 * Merged at read time from posting, position and application activity history and the posting's approvals. Cursor-paginated (`cursor` / `nextCursor`, not page/pageSize — the feed has no stable offsets). Requires the JOB_ACTIVITY_TAB feature flag. Session callers need read access to the job; M2M callers are checked for tenancy only, like GET /api/jobs/[id].
 */
export const getJobsIdActivityInfiniteOptions = (options: Options<GetJobsIdActivityData>) => {
    const opts = infiniteQueryOptions<
        GetJobsIdActivityResponse,
        AxiosError<GetJobsIdActivityError>,
        InfiniteData<GetJobsIdActivityResponse>,
        QueryKey<Options<GetJobsIdActivityData>>,
        string | Pick<QueryKey<Options<GetJobsIdActivityData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetJobsIdActivityData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  cursor: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getJobsIdActivity({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getJobsIdActivityInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

export const getJobsIdCandidateMatchingQueryKey = (options: Options<GetJobsIdCandidateMatchingData>) =>
    createQueryKey('getJobsIdCandidateMatching', options, false, ['Jobs'])

/**
 * GET /api/jobs/[id]/candidate-matching
 *
 * Hybrid vector + filter search of the talent pool for a job — powers the Talent Matching grid. Free text goes in `filterModel.quickFilterValues`.
 */
export const getJobsIdCandidateMatchingOptions = (options: Options<GetJobsIdCandidateMatchingData>) =>
    queryOptions<
        GetJobsIdCandidateMatchingResponse,
        AxiosError<GetJobsIdCandidateMatchingError>,
        GetJobsIdCandidateMatchingResponse,
        ReturnType<typeof getJobsIdCandidateMatchingQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsIdCandidateMatching({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdCandidateMatchingQueryKey(options),
    })

export const getJobsIdCandidateMatchingInfiniteQueryKey = (
    options: Options<GetJobsIdCandidateMatchingData>
): QueryKey<Options<GetJobsIdCandidateMatchingData>> => createQueryKey('getJobsIdCandidateMatching', options, true)

/**
 * GET /api/jobs/[id]/candidate-matching
 *
 * Hybrid vector + filter search of the talent pool for a job — powers the Talent Matching grid. Free text goes in `filterModel.quickFilterValues`.
 */
export const getJobsIdCandidateMatchingInfiniteOptions = (options: Options<GetJobsIdCandidateMatchingData>) => {
    const opts = infiniteQueryOptions<
        GetJobsIdCandidateMatchingResponse,
        AxiosError<GetJobsIdCandidateMatchingError>,
        InfiniteData<GetJobsIdCandidateMatchingResponse>,
        QueryKey<Options<GetJobsIdCandidateMatchingData>>,
        string | Pick<QueryKey<Options<GetJobsIdCandidateMatchingData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetJobsIdCandidateMatchingData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  offset: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getJobsIdCandidateMatching({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getJobsIdCandidateMatchingInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

export const getJobsIdLocationsQueryKey = (options: Options<GetJobsIdLocationsData>) => createQueryKey('getJobsIdLocations', options, false, ['Jobs'])

/**
 * GET /api/jobs/[id]/locations
 */
export const getJobsIdLocationsOptions = (options: Options<GetJobsIdLocationsData>) =>
    queryOptions<GetJobsIdLocationsResponse, AxiosError<GetJobsIdLocationsError>, GetJobsIdLocationsResponse, ReturnType<typeof getJobsIdLocationsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsIdLocations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdLocationsQueryKey(options),
    })

/**
 * PATCH /api/jobs/[id]/status
 */
export const patchJobsIdStatusMutation = (
    options?: Partial<Options<PatchJobsIdStatusData>>
): UseMutationOptions<PatchJobsIdStatusResponse, AxiosError<PatchJobsIdStatusError>, Options<PatchJobsIdStatusData>> => {
    const mutationOptions: UseMutationOptions<PatchJobsIdStatusResponse, AxiosError<PatchJobsIdStatusError>, Options<PatchJobsIdStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJobsIdStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobsIdShortlistRuleAffectedCandidatesQueryKey = (options: Options<GetJobsIdShortlistRuleAffectedCandidatesData>) =>
    createQueryKey('getJobsIdShortlistRuleAffectedCandidates', options, false, ['Jobs'])

/**
 * GET /api/jobs/[id]/shortlist-rule/affected-candidates — shortlisted candidates a new rule would demote
 *
 * Used by the job edit form to confirm before saving stricter auto-shortlist criteria.
 */
export const getJobsIdShortlistRuleAffectedCandidatesOptions = (options: Options<GetJobsIdShortlistRuleAffectedCandidatesData>) =>
    queryOptions<
        GetJobsIdShortlistRuleAffectedCandidatesResponse,
        AxiosError<GetJobsIdShortlistRuleAffectedCandidatesError>,
        GetJobsIdShortlistRuleAffectedCandidatesResponse,
        ReturnType<typeof getJobsIdShortlistRuleAffectedCandidatesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsIdShortlistRuleAffectedCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdShortlistRuleAffectedCandidatesQueryKey(options),
    })

export const postMailboxMonitoringMutation = (
    options?: Partial<Options<PostMailboxMonitoringData>>
): UseMutationOptions<unknown, AxiosError<PostMailboxMonitoringError>, Options<PostMailboxMonitoringData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostMailboxMonitoringError>, Options<PostMailboxMonitoringData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMailboxMonitoring({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postMailboxMonitoringProcessMutation = (
    options?: Partial<Options<PostMailboxMonitoringProcessData>>
): UseMutationOptions<unknown, AxiosError<PostMailboxMonitoringProcessError>, Options<PostMailboxMonitoringProcessData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostMailboxMonitoringProcessError>, Options<PostMailboxMonitoringProcessData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMailboxMonitoringProcess({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postMarleeCommandMutation = (
    options?: Partial<Options<PostMarleeCommandData>>
): UseMutationOptions<PostMarleeCommandResponse, AxiosError<PostMarleeCommandError>, Options<PostMarleeCommandData>> => {
    const mutationOptions: UseMutationOptions<PostMarleeCommandResponse, AxiosError<PostMarleeCommandError>, Options<PostMarleeCommandData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMarleeCommand({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postMarleeSessionMutation = (
    options?: Partial<Options<PostMarleeSessionData>>
): UseMutationOptions<PostMarleeSessionResponse, AxiosError<PostMarleeSessionError>, Options<PostMarleeSessionData>> => {
    const mutationOptions: UseMutationOptions<PostMarleeSessionResponse, AxiosError<PostMarleeSessionError>, Options<PostMarleeSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postMarleeSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteMarleeSessionSessionIdMutation = (
    options?: Partial<Options<DeleteMarleeSessionSessionIdData>>
): UseMutationOptions<DeleteMarleeSessionSessionIdResponse, AxiosError<DeleteMarleeSessionSessionIdError>, Options<DeleteMarleeSessionSessionIdData>> => {
    const mutationOptions: UseMutationOptions<
        DeleteMarleeSessionSessionIdResponse,
        AxiosError<DeleteMarleeSessionSessionIdError>,
        Options<DeleteMarleeSessionSessionIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteMarleeSessionSessionId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getMetricsQueryKey = (options?: Options<GetMetricsData>) => createQueryKey('getMetrics', options, false, ['Metrics'])

export const getMetricsOptions = (options?: Options<GetMetricsData>) =>
    queryOptions<GetMetricsResponse, AxiosError<GetMetricsError>, GetMetricsResponse, ReturnType<typeof getMetricsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMetrics({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getMetricsQueryKey(options),
    })

export const getMetricsInfiniteQueryKey = (options?: Options<GetMetricsData>): QueryKey<Options<GetMetricsData>> => createQueryKey('getMetrics', options, true)

export const getMetricsInfiniteOptions = (options?: Options<GetMetricsData>) => {
    const opts = infiniteQueryOptions<
        GetMetricsResponse,
        AxiosError<GetMetricsError>,
        InfiniteData<GetMetricsResponse>,
        QueryKey<Options<GetMetricsData>>,
        string | Pick<QueryKey<Options<GetMetricsData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetMetricsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  start: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getMetrics({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getMetricsInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

export const getMetricsStatusChangeQueryKey = (options?: Options<GetMetricsStatusChangeData>) =>
    createQueryKey('getMetricsStatusChange', options, false, ['Metrics'])

export const getMetricsStatusChangeOptions = (options?: Options<GetMetricsStatusChangeData>) =>
    queryOptions<unknown, AxiosError<GetMetricsStatusChangeError>, unknown, ReturnType<typeof getMetricsStatusChangeQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMetricsStatusChange({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getMetricsStatusChangeQueryKey(options),
    })

export const postNaukriJobMutation = (
    options?: Partial<Options<PostNaukriJobData>>
): UseMutationOptions<PostNaukriJobResponse, AxiosError<PostNaukriJobError>, Options<PostNaukriJobData>> => {
    const mutationOptions: UseMutationOptions<PostNaukriJobResponse, AxiosError<PostNaukriJobError>, Options<PostNaukriJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postNaukriJob({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getNotesQueryKey = (options?: Options<GetNotesData>) => createQueryKey('getNotes', options, false, ['Notes'])

export const getNotesOptions = (options?: Options<GetNotesData>) =>
    queryOptions<unknown, AxiosError<GetNotesError>, unknown, ReturnType<typeof getNotesQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNotes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getNotesQueryKey(options),
    })

export const postNotesMutation = (
    options?: Partial<Options<PostNotesData>>
): UseMutationOptions<unknown, AxiosError<PostNotesError>, Options<PostNotesData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostNotesError>, Options<PostNotesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postNotes({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteNotesIdMutation = (
    options?: Partial<Options<DeleteNotesIdData>>
): UseMutationOptions<unknown, AxiosError<DeleteNotesIdError>, Options<DeleteNotesIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<DeleteNotesIdError>, Options<DeleteNotesIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteNotesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putNotesIdMutation = (
    options?: Partial<Options<PutNotesIdData>>
): UseMutationOptions<unknown, AxiosError<PutNotesIdError>, Options<PutNotesIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PutNotesIdError>, Options<PutNotesIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putNotesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getNotesByEmailQueryKey = (options?: Options<GetNotesByEmailData>) => createQueryKey('getNotesByEmail', options, false, ['Notes'])

export const getNotesByEmailOptions = (options?: Options<GetNotesByEmailData>) =>
    queryOptions<unknown, AxiosError<GetNotesByEmailError>, unknown, ReturnType<typeof getNotesByEmailQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNotesByEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getNotesByEmailQueryKey(options),
    })

export const getNotificationsQueryKey = (options?: Options<GetNotificationsData>) => createQueryKey('getNotifications', options, false, ['Notifications'])

/**
 * GET /api/notifications — the signed-in user's notifications, or (with `unreadCount=true`) the unread count and
 */
export const getNotificationsOptions = (options?: Options<GetNotificationsData>) =>
    queryOptions<GetNotificationsResponse, AxiosError<GetNotificationsError>, GetNotificationsResponse, ReturnType<typeof getNotificationsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getNotifications({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getNotificationsQueryKey(options),
    })

/**
 * PUT /api/notifications — marks one notification (`notificationId`) or all of the user's notifications read.
 */
export const putNotificationsMutation = (
    options?: Partial<Options<PutNotificationsData>>
): UseMutationOptions<PutNotificationsResponse, AxiosError<PutNotificationsError>, Options<PutNotificationsData>> => {
    const mutationOptions: UseMutationOptions<PutNotificationsResponse, AxiosError<PutNotificationsError>, Options<PutNotificationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putNotifications({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/notifications/{id} — deletes one of the signed-in user's notifications.
 */
export const deleteNotificationsIdMutation = (
    options?: Partial<Options<DeleteNotificationsIdData>>
): UseMutationOptions<DeleteNotificationsIdResponse, AxiosError<DeleteNotificationsIdError>, Options<DeleteNotificationsIdData>> => {
    const mutationOptions: UseMutationOptions<DeleteNotificationsIdResponse, AxiosError<DeleteNotificationsIdError>, Options<DeleteNotificationsIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteNotificationsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOffersQueryKey = (options?: Options<GetOffersData>) => createQueryKey('getOffers', options, false, ['Offers'])

export const getOffersOptions = (options?: Options<GetOffersData>) =>
    queryOptions<GetOffersResponse, AxiosError<GetOffersError>, GetOffersResponse, ReturnType<typeof getOffersQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOffers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOffersQueryKey(options),
    })

export const postOffersMutation = (
    options?: Partial<Options<PostOffersData>>
): UseMutationOptions<PostOffersResponse, AxiosError<PostOffersError>, Options<PostOffersData>> => {
    const mutationOptions: UseMutationOptions<PostOffersResponse, AxiosError<PostOffersError>, Options<PostOffersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOffers({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putOffersMutation = (
    options?: Partial<Options<PutOffersData>>
): UseMutationOptions<PutOffersResponse, AxiosError<PutOffersError>, Options<PutOffersData>> => {
    const mutationOptions: UseMutationOptions<PutOffersResponse, AxiosError<PutOffersError>, Options<PutOffersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putOffers({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putOffersAcceptMutation = (
    options?: Partial<Options<PutOffersAcceptData>>
): UseMutationOptions<PutOffersAcceptResponse, AxiosError<PutOffersAcceptError>, Options<PutOffersAcceptData>> => {
    const mutationOptions: UseMutationOptions<PutOffersAcceptResponse, AxiosError<PutOffersAcceptError>, Options<PutOffersAcceptData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putOffersAccept({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOffersApproveQueryKey = (options?: Options<GetOffersApproveData>) => createQueryKey('getOffersApprove', options, false, ['Offers'])

/**
 * GET: Fetch offer/application data by jobOfferSlug (public - for approval page)
 */
export const getOffersApproveOptions = (options?: Options<GetOffersApproveData>) =>
    queryOptions<GetOffersApproveResponse, AxiosError<GetOffersApproveError>, GetOffersApproveResponse, ReturnType<typeof getOffersApproveQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOffersApprove({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOffersApproveQueryKey(options),
    })

export const putOffersApproveMutation = (
    options?: Partial<Options<PutOffersApproveData>>
): UseMutationOptions<PutOffersApproveResponse, AxiosError<PutOffersApproveError>, Options<PutOffersApproveData>> => {
    const mutationOptions: UseMutationOptions<PutOffersApproveResponse, AxiosError<PutOffersApproveError>, Options<PutOffersApproveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putOffersApprove({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putOffersDocumentsMutation = (
    options?: Partial<Options<PutOffersDocumentsData>>
): UseMutationOptions<PutOffersDocumentsResponse, AxiosError<PutOffersDocumentsError>, Options<PutOffersDocumentsData>> => {
    const mutationOptions: UseMutationOptions<PutOffersDocumentsResponse, AxiosError<PutOffersDocumentsError>, Options<PutOffersDocumentsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putOffersDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postOffersRemindMutation = (
    options?: Partial<Options<PostOffersRemindData>>
): UseMutationOptions<PostOffersRemindResponse, AxiosError<PostOffersRemindError>, Options<PostOffersRemindData>> => {
    const mutationOptions: UseMutationOptions<PostOffersRemindResponse, AxiosError<PostOffersRemindError>, Options<PostOffersRemindData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOffersRemind({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postOffersRequestDocumentsMutation = (
    options?: Partial<Options<PostOffersRequestDocumentsData>>
): UseMutationOptions<PostOffersRequestDocumentsResponse, AxiosError<PostOffersRequestDocumentsError>, Options<PostOffersRequestDocumentsData>> => {
    const mutationOptions: UseMutationOptions<
        PostOffersRequestDocumentsResponse,
        AxiosError<PostOffersRequestDocumentsError>,
        Options<PostOffersRequestDocumentsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOffersRequestDocuments({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postOffersSendMutation = (
    options?: Partial<Options<PostOffersSendData>>
): UseMutationOptions<PostOffersSendResponse, AxiosError<PostOffersSendError>, Options<PostOffersSendData>> => {
    const mutationOptions: UseMutationOptions<PostOffersSendResponse, AxiosError<PostOffersSendError>, Options<PostOffersSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOffersSend({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postOffersSendForApprovalMutation = (
    options?: Partial<Options<PostOffersSendForApprovalData>>
): UseMutationOptions<PostOffersSendForApprovalResponse, AxiosError<PostOffersSendForApprovalError>, Options<PostOffersSendForApprovalData>> => {
    const mutationOptions: UseMutationOptions<
        PostOffersSendForApprovalResponse,
        AxiosError<PostOffersSendForApprovalError>,
        Options<PostOffersSendForApprovalData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOffersSendForApproval({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOffersUploadDocumentsIdQueryKey = (options: Options<GetOffersUploadDocumentsIdData>) =>
    createQueryKey('getOffersUploadDocumentsId', options, false, ['Offers'])

export const getOffersUploadDocumentsIdOptions = (options: Options<GetOffersUploadDocumentsIdData>) =>
    queryOptions<
        GetOffersUploadDocumentsIdResponse,
        AxiosError<GetOffersUploadDocumentsIdError>,
        GetOffersUploadDocumentsIdResponse,
        ReturnType<typeof getOffersUploadDocumentsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOffersUploadDocumentsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOffersUploadDocumentsIdQueryKey(options),
    })

export const postOffersUploadDocumentsIdMutation = (
    options?: Partial<Options<PostOffersUploadDocumentsIdData>>
): UseMutationOptions<PostOffersUploadDocumentsIdResponse, AxiosError<PostOffersUploadDocumentsIdError>, Options<PostOffersUploadDocumentsIdData>> => {
    const mutationOptions: UseMutationOptions<
        PostOffersUploadDocumentsIdResponse,
        AxiosError<PostOffersUploadDocumentsIdError>,
        Options<PostOffersUploadDocumentsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOffersUploadDocumentsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const putOffersUploadDocumentsIdMutation = (
    options?: Partial<Options<PutOffersUploadDocumentsIdData>>
): UseMutationOptions<PutOffersUploadDocumentsIdResponse, AxiosError<PutOffersUploadDocumentsIdError>, Options<PutOffersUploadDocumentsIdData>> => {
    const mutationOptions: UseMutationOptions<
        PutOffersUploadDocumentsIdResponse,
        AxiosError<PutOffersUploadDocumentsIdError>,
        Options<PutOffersUploadDocumentsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putOffersUploadDocumentsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOgApplyQueryKey = (options?: Options<GetOgApplyData>) => createQueryKey('getOgApply', options, false, ['Og'])

/**
 * Job share image. Redirects to the pre-rendered PNG in the static bucket (rendering and storing it
 */
export const getOgApplyOptions = (options?: Options<GetOgApplyData>) =>
    queryOptions<unknown, AxiosError<GetOgApplyError>, unknown, ReturnType<typeof getOgApplyQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOgApply({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOgApplyQueryKey(options),
    })

export const getOgCompanyQueryKey = (options?: Options<GetOgCompanyData>) => createQueryKey('getOgCompany', options, false, ['Og'])

/**
 * Career-page share image. Redirects to the pre-rendered PNG in the static bucket (rendering and
 */
export const getOgCompanyOptions = (options?: Options<GetOgCompanyData>) =>
    queryOptions<unknown, AxiosError<GetOgCompanyError>, unknown, ReturnType<typeof getOgCompanyQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOgCompany({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOgCompanyQueryKey(options),
    })

export const getOgDefaultQueryKey = (options?: Options<GetOgDefaultData>) => createQueryKey('getOgDefault', options, false, ['Og'])

export const getOgDefaultOptions = (options?: Options<GetOgDefaultData>) =>
    queryOptions<unknown, AxiosError<GetOgDefaultError>, unknown, ReturnType<typeof getOgDefaultQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOgDefault({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOgDefaultQueryKey(options),
    })

/**
 * POST /api/onboarding/complete-checkout
 *
 * Complete paid signup provisioning from a Stripe Checkout session id.
 */
export const postOnboardingCompleteCheckoutMutation = (
    options?: Partial<Options<PostOnboardingCompleteCheckoutData>>
): UseMutationOptions<PostOnboardingCompleteCheckoutResponse, AxiosError<PostOnboardingCompleteCheckoutError>, Options<PostOnboardingCompleteCheckoutData>> => {
    const mutationOptions: UseMutationOptions<
        PostOnboardingCompleteCheckoutResponse,
        AxiosError<PostOnboardingCompleteCheckoutError>,
        Options<PostOnboardingCompleteCheckoutData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingCompleteCheckout({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/onboarding/complete-signup
 *
 * Verify OTP and create the Auth0 account for self-service signup.
 */
export const postOnboardingCompleteSignupMutation = (
    options?: Partial<Options<PostOnboardingCompleteSignupData>>
): UseMutationOptions<PostOnboardingCompleteSignupResponse, AxiosError<PostOnboardingCompleteSignupError>, Options<PostOnboardingCompleteSignupData>> => {
    const mutationOptions: UseMutationOptions<
        PostOnboardingCompleteSignupResponse,
        AxiosError<PostOnboardingCompleteSignupError>,
        Options<PostOnboardingCompleteSignupData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingCompleteSignup({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/onboarding/org — set company name, slug, and logo on draft.
 *
 * Save organization details on the active signup draft.
 */
export const patchOnboardingOrgMutation = (
    options?: Partial<Options<PatchOnboardingOrgData>>
): UseMutationOptions<PatchOnboardingOrgResponse, AxiosError<PatchOnboardingOrgError>, Options<PatchOnboardingOrgData>> => {
    const mutationOptions: UseMutationOptions<PatchOnboardingOrgResponse, AxiosError<PatchOnboardingOrgError>, Options<PatchOnboardingOrgData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchOnboardingOrg({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOnboardingPlansQueryKey = (options?: Options<GetOnboardingPlansData>) => createQueryKey('getOnboardingPlans', options, false, ['Onboarding'])

/**
 * GET /api/onboarding/plans — public active + public billing plans.
 *
 * List active public billing plans available for self-service signup.
 */
export const getOnboardingPlansOptions = (options?: Options<GetOnboardingPlansData>) =>
    queryOptions<GetOnboardingPlansResponse, AxiosError<GetOnboardingPlansError>, GetOnboardingPlansResponse, ReturnType<typeof getOnboardingPlansQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOnboardingPlans({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOnboardingPlansQueryKey(options),
    })

/**
 * POST /api/onboarding/select-plan
 *
 * Select a public plan; freemium provisions immediately, paid starts Stripe Checkout.
 */
export const postOnboardingSelectPlanMutation = (
    options?: Partial<Options<PostOnboardingSelectPlanData>>
): UseMutationOptions<PostOnboardingSelectPlanResponse, AxiosError<PostOnboardingSelectPlanError>, Options<PostOnboardingSelectPlanData>> => {
    const mutationOptions: UseMutationOptions<
        PostOnboardingSelectPlanResponse,
        AxiosError<PostOnboardingSelectPlanError>,
        Options<PostOnboardingSelectPlanData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingSelectPlan({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/onboarding/signup
 *
 * Start self-service signup and send an email verification code.
 */
export const postOnboardingSignupMutation = (
    options?: Partial<Options<PostOnboardingSignupData>>
): UseMutationOptions<PostOnboardingSignupResponse, AxiosError<PostOnboardingSignupError>, Options<PostOnboardingSignupData>> => {
    const mutationOptions: UseMutationOptions<PostOnboardingSignupResponse, AxiosError<PostOnboardingSignupError>, Options<PostOnboardingSignupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingSignup({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOnboardingStatusQueryKey = (options?: Options<GetOnboardingStatusData>) => createQueryKey('getOnboardingStatus', options, false, ['Onboarding'])

/**
 * GET /api/onboarding/status — current draft for the logged-in Auth0 user.
 *
 * Return the active signup draft for the authenticated user.
 */
export const getOnboardingStatusOptions = (options?: Options<GetOnboardingStatusData>) =>
    queryOptions<
        GetOnboardingStatusResponse,
        AxiosError<GetOnboardingStatusError>,
        GetOnboardingStatusResponse,
        ReturnType<typeof getOnboardingStatusQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOnboardingStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOnboardingStatusQueryKey(options),
    })

/**
 * POST /api/onboarding/upload-logo
 *
 * Upload a company logo during onboarding (multipart form).
 */
export const postOnboardingUploadLogoMutation = (
    options?: Partial<Options<PostOnboardingUploadLogoData>>
): UseMutationOptions<PostOnboardingUploadLogoResponse, AxiosError<PostOnboardingUploadLogoError>, Options<PostOnboardingUploadLogoData>> => {
    const mutationOptions: UseMutationOptions<
        PostOnboardingUploadLogoResponse,
        AxiosError<PostOnboardingUploadLogoError>,
        Options<PostOnboardingUploadLogoData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingUploadLogo({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/onboarding/verify-code
 *
 * Verify the 6-digit signup email OTP for the active draft.
 */
export const postOnboardingVerifyCodeMutation = (
    options?: Partial<Options<PostOnboardingVerifyCodeData>>
): UseMutationOptions<PostOnboardingVerifyCodeResponse, AxiosError<PostOnboardingVerifyCodeError>, Options<PostOnboardingVerifyCodeData>> => {
    const mutationOptions: UseMutationOptions<
        PostOnboardingVerifyCodeResponse,
        AxiosError<PostOnboardingVerifyCodeError>,
        Options<PostOnboardingVerifyCodeData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingVerifyCode({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getOnboardingVerifyStatusQueryKey = (options?: Options<GetOnboardingVerifyStatusData>) =>
    createQueryKey('getOnboardingVerifyStatus', options, false, ['Onboarding'])

/**
 * GET /api/onboarding/verify-status — return draft verification status from DB.
 *
 * Return email verification status for the active signup draft.
 */
export const getOnboardingVerifyStatusOptions = (options?: Options<GetOnboardingVerifyStatusData>) =>
    queryOptions<
        GetOnboardingVerifyStatusResponse,
        AxiosError<GetOnboardingVerifyStatusError>,
        GetOnboardingVerifyStatusResponse,
        ReturnType<typeof getOnboardingVerifyStatusQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOnboardingVerifyStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getOnboardingVerifyStatusQueryKey(options),
    })

/**
 * POST /api/onboarding/verify-status — resend verification code email.
 *
 * Resend the signup email verification code.
 */
export const postOnboardingVerifyStatusMutation = (
    options?: Partial<Options<PostOnboardingVerifyStatusData>>
): UseMutationOptions<PostOnboardingVerifyStatusResponse, AxiosError<PostOnboardingVerifyStatusError>, Options<PostOnboardingVerifyStatusData>> => {
    const mutationOptions: UseMutationOptions<
        PostOnboardingVerifyStatusResponse,
        AxiosError<PostOnboardingVerifyStatusError>,
        Options<PostOnboardingVerifyStatusData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postOnboardingVerifyStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postPermissionsMutation = (
    options?: Partial<Options<PostPermissionsData>>
): UseMutationOptions<PostPermissionsResponse, AxiosError<PostPermissionsError>, Options<PostPermissionsData>> => {
    const mutationOptions: UseMutationOptions<PostPermissionsResponse, AxiosError<PostPermissionsError>, Options<PostPermissionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postPermissions({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanySlugPublicCareerConfigQueryKey = (options: Options<GetCompanySlugPublicCareerConfigData>) =>
    createQueryKey('getCompanySlugPublicCareerConfig', options, false, ['PublicCareer'])

/**
 * GET /api/{companySlug}/public/career/config — what the public career pages render about a company.
 *
 * Anonymous; resolved by the slug only, never the session. Logo, career flags, the JobApplication form config and job field labels for the career list, job apply and talent-pool apply pages.
 */
export const getCompanySlugPublicCareerConfigOptions = (options: Options<GetCompanySlugPublicCareerConfigData>) =>
    queryOptions<
        GetCompanySlugPublicCareerConfigResponse,
        AxiosError<GetCompanySlugPublicCareerConfigError>,
        GetCompanySlugPublicCareerConfigResponse,
        ReturnType<typeof getCompanySlugPublicCareerConfigQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugPublicCareerConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugPublicCareerConfigQueryKey(options),
    })

export const getCompanySlugPublicCareerDepartmentsQueryKey = (options: Options<GetCompanySlugPublicCareerDepartmentsData>) =>
    createQueryKey('getCompanySlugPublicCareerDepartments', options, false, ['PublicCareer'])

/**
 * GET /api/{companySlug}/public/career/departments
 *
 * List all departments for a company's public career page filters.
 */
export const getCompanySlugPublicCareerDepartmentsOptions = (options: Options<GetCompanySlugPublicCareerDepartmentsData>) =>
    queryOptions<
        GetCompanySlugPublicCareerDepartmentsResponse,
        AxiosError<GetCompanySlugPublicCareerDepartmentsError>,
        GetCompanySlugPublicCareerDepartmentsResponse,
        ReturnType<typeof getCompanySlugPublicCareerDepartmentsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugPublicCareerDepartments({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugPublicCareerDepartmentsQueryKey(options),
    })

export const getCompanySlugPublicCareerJobsQueryKey = (options: Options<GetCompanySlugPublicCareerJobsData>) =>
    createQueryKey('getCompanySlugPublicCareerJobs', options, false, ['PublicCareer'])

/**
 * GET /api/{companySlug}/public/career/jobs
 *
 * List externally visible jobs for a company's public career page. Supports pagination, filters, XML feed, and all=true for full export.
 */
export const getCompanySlugPublicCareerJobsOptions = (options: Options<GetCompanySlugPublicCareerJobsData>) =>
    queryOptions<
        GetCompanySlugPublicCareerJobsResponse,
        AxiosError<GetCompanySlugPublicCareerJobsError>,
        GetCompanySlugPublicCareerJobsResponse,
        ReturnType<typeof getCompanySlugPublicCareerJobsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugPublicCareerJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugPublicCareerJobsQueryKey(options),
    })

export const getCompanySlugPublicCareerJobsInfiniteQueryKey = (
    options: Options<GetCompanySlugPublicCareerJobsData>
): QueryKey<Options<GetCompanySlugPublicCareerJobsData>> => createQueryKey('getCompanySlugPublicCareerJobs', options, true)

/**
 * GET /api/{companySlug}/public/career/jobs
 *
 * List externally visible jobs for a company's public career page. Supports pagination, filters, XML feed, and all=true for full export.
 */
export const getCompanySlugPublicCareerJobsInfiniteOptions = (options: Options<GetCompanySlugPublicCareerJobsData>) => {
    const opts = infiniteQueryOptions<
        GetCompanySlugPublicCareerJobsResponse,
        AxiosError<GetCompanySlugPublicCareerJobsError>,
        InfiniteData<GetCompanySlugPublicCareerJobsResponse>,
        QueryKey<Options<GetCompanySlugPublicCareerJobsData>>,
        number | Pick<QueryKey<Options<GetCompanySlugPublicCareerJobsData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetCompanySlugPublicCareerJobsData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getCompanySlugPublicCareerJobs({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getCompanySlugPublicCareerJobsInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

export const getCompanySlugPublicCareerJobsIdQueryKey = (options: Options<GetCompanySlugPublicCareerJobsIdData>) =>
    createQueryKey('getCompanySlugPublicCareerJobsId', options, false, ['PublicCareer'])

/**
 * GET /api/{companySlug}/public/career/jobs/{id}
 *
 * Fetch a single public job for the apply flow. Job must belong to the company in the path.
 */
export const getCompanySlugPublicCareerJobsIdOptions = (options: Options<GetCompanySlugPublicCareerJobsIdData>) =>
    queryOptions<
        GetCompanySlugPublicCareerJobsIdResponse,
        AxiosError<GetCompanySlugPublicCareerJobsIdError>,
        GetCompanySlugPublicCareerJobsIdResponse,
        ReturnType<typeof getCompanySlugPublicCareerJobsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugPublicCareerJobsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugPublicCareerJobsIdQueryKey(options),
    })

/**
 * POST /api/{companySlug}/public/career/talent-pool/applications — join the company's talent pool without a job.
 *
 * Anonymous; a signed-in member of the company (or SuperAdmin) is recorded as the candidate's `appliedBy`. Only when the company's career page and the CAREER_TALENT_POOL_APPLY flag are on. Creates a talent-pool candidate (or updates the company's candidate with the same email, else phone) and queues resume processing. The response never says whether the candidate already existed. Rate-limited per IP.
 */
export const postCompanySlugPublicCareerTalentPoolApplicationsMutation = (
    options?: Partial<Options<PostCompanySlugPublicCareerTalentPoolApplicationsData>>
): UseMutationOptions<
    PostCompanySlugPublicCareerTalentPoolApplicationsResponse,
    AxiosError<PostCompanySlugPublicCareerTalentPoolApplicationsError>,
    Options<PostCompanySlugPublicCareerTalentPoolApplicationsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanySlugPublicCareerTalentPoolApplicationsResponse,
        AxiosError<PostCompanySlugPublicCareerTalentPoolApplicationsError>,
        Options<PostCompanySlugPublicCareerTalentPoolApplicationsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanySlugPublicCareerTalentPoolApplications({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanySlugPublicCareerTalentPoolUploadUrlQueryKey = (options: Options<GetCompanySlugPublicCareerTalentPoolUploadUrlData>) =>
    createQueryKey('getCompanySlugPublicCareerTalentPoolUploadUrl', options, false, ['PublicCareer'])

/**
 * GET /api/{companySlug}/public/career/talent-pool/upload-url — signed upload URL for the public talent-pool apply page.
 *
 * Anonymous. Only when the company's career page and the CAREER_TALENT_POOL_APPLY flag are on; documents only (resume / attachment types), the server picks the object name under the company's folder, URLs expire in 10 minutes, and requests share the per-IP public upload rate limit.
 */
export const getCompanySlugPublicCareerTalentPoolUploadUrlOptions = (options: Options<GetCompanySlugPublicCareerTalentPoolUploadUrlData>) =>
    queryOptions<
        GetCompanySlugPublicCareerTalentPoolUploadUrlResponse,
        AxiosError<GetCompanySlugPublicCareerTalentPoolUploadUrlError>,
        GetCompanySlugPublicCareerTalentPoolUploadUrlResponse,
        ReturnType<typeof getCompanySlugPublicCareerTalentPoolUploadUrlQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugPublicCareerTalentPoolUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugPublicCareerTalentPoolUploadUrlQueryKey(options),
    })

/**
 * POST /api/{companySlug}/public/career/jobs/{id}/applications — apply to a public job (signed out).
 *
 * Anonymous; a signed-in member of the company (or SuperAdmin) is recorded as `appliedBy`. The posting must belong to the slug's company, be approved and visible (externally or internal-only, as on the public job page) and processed. The resume (and intro video, if any) must be files the public upload endpoint minted for this company. Rate-limited per IP.
 */
export const postCompanySlugPublicCareerJobsIdApplicationsMutation = (
    options?: Partial<Options<PostCompanySlugPublicCareerJobsIdApplicationsData>>
): UseMutationOptions<
    PostCompanySlugPublicCareerJobsIdApplicationsResponse,
    AxiosError<PostCompanySlugPublicCareerJobsIdApplicationsError>,
    Options<PostCompanySlugPublicCareerJobsIdApplicationsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostCompanySlugPublicCareerJobsIdApplicationsResponse,
        AxiosError<PostCompanySlugPublicCareerJobsIdApplicationsError>,
        Options<PostCompanySlugPublicCareerJobsIdApplicationsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postCompanySlugPublicCareerJobsIdApplications({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getCompanySlugPublicCareerJobsIdUploadUrlQueryKey = (options: Options<GetCompanySlugPublicCareerJobsIdUploadUrlData>) =>
    createQueryKey('getCompanySlugPublicCareerJobsIdUploadUrl', options, false, ['PublicCareer'])

/**
 * GET /api/{companySlug}/public/career/jobs/{id}/upload-url — signed upload URL for the public apply page.
 *
 * Anonymous. Only for a job that is publicly open (same rules as the public job detail); the server picks the object name under the company's folder, only resume/attachment and intro-video file types are allowed, URLs expire in 10 minutes, and requests are rate-limited per IP.
 */
export const getCompanySlugPublicCareerJobsIdUploadUrlOptions = (options: Options<GetCompanySlugPublicCareerJobsIdUploadUrlData>) =>
    queryOptions<
        GetCompanySlugPublicCareerJobsIdUploadUrlResponse,
        AxiosError<GetCompanySlugPublicCareerJobsIdUploadUrlError>,
        GetCompanySlugPublicCareerJobsIdUploadUrlResponse,
        ReturnType<typeof getCompanySlugPublicCareerJobsIdUploadUrlQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCompanySlugPublicCareerJobsIdUploadUrl({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getCompanySlugPublicCareerJobsIdUploadUrlQueryKey(options),
    })

export const postReachOutMutation = (
    options?: Partial<Options<PostReachOutData>>
): UseMutationOptions<unknown, AxiosError<PostReachOutError>, Options<PostReachOutData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostReachOutError>, Options<PostReachOutData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postReachOut({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postReachOutSlotBookingMutation = (
    options?: Partial<Options<PostReachOutSlotBookingData>>
): UseMutationOptions<unknown, AxiosError<PostReachOutSlotBookingError>, Options<PostReachOutSlotBookingData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostReachOutSlotBookingError>, Options<PostReachOutSlotBookingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postReachOutSlotBooking({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getRecordingsRecordingIdQueryKey = (options: Options<GetRecordingsRecordingIdData>) =>
    createQueryKey('getRecordingsRecordingId', options, false, ['Recordings'])

/**
 * GET /api/recordings/[recordingId]
 */
export const getRecordingsRecordingIdOptions = (options: Options<GetRecordingsRecordingIdData>) =>
    queryOptions<unknown, AxiosError<GetRecordingsRecordingIdError>, unknown, ReturnType<typeof getRecordingsRecordingIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRecordingsRecordingId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getRecordingsRecordingIdQueryKey(options),
    })

/**
 * POST handler for creating a Face Liveness Session (Phase 2).
 */
export const postRekognitionCreateSessionMutation = (
    options?: Partial<Options<PostRekognitionCreateSessionData>>
): UseMutationOptions<unknown, AxiosError<PostRekognitionCreateSessionError>, Options<PostRekognitionCreateSessionData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostRekognitionCreateSessionError>, Options<PostRekognitionCreateSessionData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postRekognitionCreateSession({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getRekognitionGetResultsSessionIdQueryKey = (options: Options<GetRekognitionGetResultsSessionIdData>) =>
    createQueryKey('getRekognitionGetResultsSessionId', options, false, ['Rekognition'])

/**
 * GET handler for retrieving Face Liveness Session Results (Phase 2).
 */
export const getRekognitionGetResultsSessionIdOptions = (options: Options<GetRekognitionGetResultsSessionIdData>) =>
    queryOptions<unknown, AxiosError<GetRekognitionGetResultsSessionIdError>, unknown, ReturnType<typeof getRekognitionGetResultsSessionIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRekognitionGetResultsSessionId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getRekognitionGetResultsSessionIdQueryKey(options),
    })

export const postReportsExecuteMutation = (
    options?: Partial<Options<PostReportsExecuteData>>
): UseMutationOptions<PostReportsExecuteResponse, AxiosError<PostReportsExecuteError>, Options<PostReportsExecuteData>> => {
    const mutationOptions: UseMutationOptions<PostReportsExecuteResponse, AxiosError<PostReportsExecuteError>, Options<PostReportsExecuteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postReportsExecute({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getReportsTaTrackerQueryKey = (options?: Options<GetReportsTaTrackerData>) => createQueryKey('getReportsTaTracker', options, false, ['Reports'])

export const getReportsTaTrackerOptions = (options?: Options<GetReportsTaTrackerData>) =>
    queryOptions<unknown, AxiosError<GetReportsTaTrackerError>, unknown, ReturnType<typeof getReportsTaTrackerQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReportsTaTracker({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getReportsTaTrackerQueryKey(options),
    })

export const getReportsConfigCompanyIdQueryKey = (options: Options<GetReportsConfigCompanyIdData>) =>
    createQueryKey('getReportsConfigCompanyId', options, false, ['Reports'])

export const getReportsConfigCompanyIdOptions = (options: Options<GetReportsConfigCompanyIdData>) =>
    queryOptions<
        GetReportsConfigCompanyIdResponse,
        AxiosError<GetReportsConfigCompanyIdError>,
        GetReportsConfigCompanyIdResponse,
        ReturnType<typeof getReportsConfigCompanyIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getReportsConfigCompanyId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getReportsConfigCompanyIdQueryKey(options),
    })

export const postReportsConfigCompanyIdMutation = (
    options?: Partial<Options<PostReportsConfigCompanyIdData>>
): UseMutationOptions<PostReportsConfigCompanyIdResponse, AxiosError<PostReportsConfigCompanyIdError>, Options<PostReportsConfigCompanyIdData>> => {
    const mutationOptions: UseMutationOptions<
        PostReportsConfigCompanyIdResponse,
        AxiosError<PostReportsConfigCompanyIdError>,
        Options<PostReportsConfigCompanyIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postReportsConfigCompanyId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/screening-report/pdf — generate AI screening report PDF.
 */
export const postScreeningReportPdfMutation = (
    options?: Partial<Options<PostScreeningReportPdfData>>
): UseMutationOptions<PostScreeningReportPdfResponse, AxiosError<PostScreeningReportPdfError>, Options<PostScreeningReportPdfData>> => {
    const mutationOptions: UseMutationOptions<PostScreeningReportPdfResponse, AxiosError<PostScreeningReportPdfError>, Options<PostScreeningReportPdfData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postScreeningReportPdf({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postSendEmailMutation = (
    options?: Partial<Options<PostSendEmailData>>
): UseMutationOptions<unknown, AxiosError<PostSendEmailError>, Options<PostSendEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostSendEmailError>, Options<PostSendEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSendEmail({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getSettingsCommunicationTemplatesQueryKey = (options?: Options<GetSettingsCommunicationTemplatesData>) =>
    createQueryKey('getSettingsCommunicationTemplates', options, false, ['Settings'])

export const getSettingsCommunicationTemplatesOptions = (options?: Options<GetSettingsCommunicationTemplatesData>) =>
    queryOptions<
        GetSettingsCommunicationTemplatesResponse,
        AxiosError<GetSettingsCommunicationTemplatesError>,
        GetSettingsCommunicationTemplatesResponse,
        ReturnType<typeof getSettingsCommunicationTemplatesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSettingsCommunicationTemplates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getSettingsCommunicationTemplatesQueryKey(options),
    })

export const postSettingsCommunicationTemplatesMutation = (
    options?: Partial<Options<PostSettingsCommunicationTemplatesData>>
): UseMutationOptions<
    PostSettingsCommunicationTemplatesResponse,
    AxiosError<PostSettingsCommunicationTemplatesError>,
    Options<PostSettingsCommunicationTemplatesData>
> => {
    const mutationOptions: UseMutationOptions<
        PostSettingsCommunicationTemplatesResponse,
        AxiosError<PostSettingsCommunicationTemplatesError>,
        Options<PostSettingsCommunicationTemplatesData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSettingsCommunicationTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const deleteSettingsCommunicationTemplatesIdMutation = (
    options?: Partial<Options<DeleteSettingsCommunicationTemplatesIdData>>
): UseMutationOptions<
    DeleteSettingsCommunicationTemplatesIdResponse,
    AxiosError<DeleteSettingsCommunicationTemplatesIdError>,
    Options<DeleteSettingsCommunicationTemplatesIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteSettingsCommunicationTemplatesIdResponse,
        AxiosError<DeleteSettingsCommunicationTemplatesIdError>,
        Options<DeleteSettingsCommunicationTemplatesIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteSettingsCommunicationTemplatesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getSettingsCommunicationTemplatesIdQueryKey = (options: Options<GetSettingsCommunicationTemplatesIdData>) =>
    createQueryKey('getSettingsCommunicationTemplatesId', options, false, ['Settings'])

export const getSettingsCommunicationTemplatesIdOptions = (options: Options<GetSettingsCommunicationTemplatesIdData>) =>
    queryOptions<
        GetSettingsCommunicationTemplatesIdResponse,
        AxiosError<GetSettingsCommunicationTemplatesIdError>,
        GetSettingsCommunicationTemplatesIdResponse,
        ReturnType<typeof getSettingsCommunicationTemplatesIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSettingsCommunicationTemplatesId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getSettingsCommunicationTemplatesIdQueryKey(options),
    })

export const putSettingsCommunicationTemplatesIdMutation = (
    options?: Partial<Options<PutSettingsCommunicationTemplatesIdData>>
): UseMutationOptions<
    PutSettingsCommunicationTemplatesIdResponse,
    AxiosError<PutSettingsCommunicationTemplatesIdError>,
    Options<PutSettingsCommunicationTemplatesIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PutSettingsCommunicationTemplatesIdResponse,
        AxiosError<PutSettingsCommunicationTemplatesIdError>,
        Options<PutSettingsCommunicationTemplatesIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putSettingsCommunicationTemplatesId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postSettingsCommunicationTemplatesActivateDefaultMutation = (
    options?: Partial<Options<PostSettingsCommunicationTemplatesActivateDefaultData>>
): UseMutationOptions<
    PostSettingsCommunicationTemplatesActivateDefaultResponse,
    AxiosError<PostSettingsCommunicationTemplatesActivateDefaultError>,
    Options<PostSettingsCommunicationTemplatesActivateDefaultData>
> => {
    const mutationOptions: UseMutationOptions<
        PostSettingsCommunicationTemplatesActivateDefaultResponse,
        AxiosError<PostSettingsCommunicationTemplatesActivateDefaultError>,
        Options<PostSettingsCommunicationTemplatesActivateDefaultData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSettingsCommunicationTemplatesActivateDefault({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const postSettingsCommunicationTemplatesPreviewMutation = (
    options?: Partial<Options<PostSettingsCommunicationTemplatesPreviewData>>
): UseMutationOptions<
    PostSettingsCommunicationTemplatesPreviewResponse,
    AxiosError<PostSettingsCommunicationTemplatesPreviewError>,
    Options<PostSettingsCommunicationTemplatesPreviewData>
> => {
    const mutationOptions: UseMutationOptions<
        PostSettingsCommunicationTemplatesPreviewResponse,
        AxiosError<PostSettingsCommunicationTemplatesPreviewError>,
        Options<PostSettingsCommunicationTemplatesPreviewData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSettingsCommunicationTemplatesPreview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobsIdSourcedCandidatesQueryKey = (options: Options<GetJobsIdSourcedCandidatesData>) =>
    createQueryKey('getJobsIdSourcedCandidates', options, false, ['SourcedCandidate'])

/**
 * GET /api/jobs/[id]/sourced-candidates — a job's Sourced list (the Sourced table).
 *
 * People added from the sourcing extension, newest first. Same access as the job's Applications tab;
 */
export const getJobsIdSourcedCandidatesOptions = (options: Options<GetJobsIdSourcedCandidatesData>) =>
    queryOptions<
        GetJobsIdSourcedCandidatesResponse,
        AxiosError<GetJobsIdSourcedCandidatesError>,
        GetJobsIdSourcedCandidatesResponse,
        ReturnType<typeof getJobsIdSourcedCandidatesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsIdSourcedCandidates({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdSourcedCandidatesQueryKey(options),
    })

export const getJobsIdSourcedCandidatesInfiniteQueryKey = (
    options: Options<GetJobsIdSourcedCandidatesData>
): QueryKey<Options<GetJobsIdSourcedCandidatesData>> => createQueryKey('getJobsIdSourcedCandidates', options, true)

/**
 * GET /api/jobs/[id]/sourced-candidates — a job's Sourced list (the Sourced table).
 *
 * People added from the sourcing extension, newest first. Same access as the job's Applications tab;
 */
export const getJobsIdSourcedCandidatesInfiniteOptions = (options: Options<GetJobsIdSourcedCandidatesData>) => {
    const opts = infiniteQueryOptions<
        GetJobsIdSourcedCandidatesResponse,
        AxiosError<GetJobsIdSourcedCandidatesError>,
        InfiniteData<GetJobsIdSourcedCandidatesResponse>,
        QueryKey<Options<GetJobsIdSourcedCandidatesData>>,
        number | Pick<QueryKey<Options<GetJobsIdSourcedCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'>
    >(
        // @ts-ignore
        {
            queryFn: async ({ pageParam, queryKey, signal }) => {
                // @ts-ignore
                const page: Pick<QueryKey<Options<GetJobsIdSourcedCandidatesData>>[0], 'body' | 'headers' | 'path' | 'query'> =
                    typeof pageParam === 'object'
                        ? pageParam
                        : {
                              query: {
                                  page: pageParam,
                              },
                          }
                const params = createInfiniteParams(queryKey, page)
                const { data } = await getJobsIdSourcedCandidates({
                    ...options,
                    ...params,
                    signal,
                    throwOnError: true,
                })
                return data
            },
            queryKey: getJobsIdSourcedCandidatesInfiniteQueryKey(options),
        }
    )
    return opts as Omit<typeof opts, 'initialData'>
}

/**
 * DELETE /api/jobs/[id]/sourced-candidates/[sourcedCandidateId] — remove the person from the job's Sourced list.
 *
 * Permanent, with the comments that were only on their Sourced row. An application they already have
 */
export const deleteJobsIdSourcedCandidatesSourcedCandidateIdMutation = (
    options?: Partial<Options<DeleteJobsIdSourcedCandidatesSourcedCandidateIdData>>
): UseMutationOptions<
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdResponse,
    AxiosError<DeleteJobsIdSourcedCandidatesSourcedCandidateIdError>,
    Options<DeleteJobsIdSourcedCandidatesSourcedCandidateIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteJobsIdSourcedCandidatesSourcedCandidateIdResponse,
        AxiosError<DeleteJobsIdSourcedCandidatesSourcedCandidateIdError>,
        Options<DeleteJobsIdSourcedCandidatesSourcedCandidateIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteJobsIdSourcedCandidatesSourcedCandidateId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/jobs/[id]/sourced-candidates/[sourcedCandidateId] — mark contacted, or archive / restore.
 *
 * A later status (invited, applied, moved) is kept when marking contacted.
 */
export const patchJobsIdSourcedCandidatesSourcedCandidateIdMutation = (
    options?: Partial<Options<PatchJobsIdSourcedCandidatesSourcedCandidateIdData>>
): UseMutationOptions<
    PatchJobsIdSourcedCandidatesSourcedCandidateIdResponse,
    AxiosError<PatchJobsIdSourcedCandidatesSourcedCandidateIdError>,
    Options<PatchJobsIdSourcedCandidatesSourcedCandidateIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchJobsIdSourcedCandidatesSourcedCandidateIdResponse,
        AxiosError<PatchJobsIdSourcedCandidatesSourcedCandidateIdError>,
        Options<PatchJobsIdSourcedCandidatesSourcedCandidateIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJobsIdSourcedCandidatesSourcedCandidateId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/invite-drafts — AI draft inviting this person to apply.
 *
 * One message (email, LinkedIn connection note or InMail) from the stored profile and the job. Nothing is
 */
export const postJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsMutation = (
    options?: Partial<Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsData>>
): UseMutationOptions<
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsResponse,
    AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsError>,
    Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsResponse,
        AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsError>,
        Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteDraftsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobsIdSourcedCandidatesSourcedCandidateIdInviteDrafts({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/invite-emails — email this person an invite to apply.
 *
 * intalent.ai sends the recruiter-approved message with the job ID and an apply button to the job's
 */
export const postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsMutation = (
    options?: Partial<Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsData>>
): UseMutationOptions<
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsResponse,
    AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsError>,
    Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsResponse,
        AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsError>,
        Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmails({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/move — move this person to the job's Applications.
 *
 * intalent.ai builds a resume PDF from the stored profile and creates the application, queued for the
 */
export const postJobsIdSourcedCandidatesSourcedCandidateIdMoveMutation = (
    options?: Partial<Options<PostJobsIdSourcedCandidatesSourcedCandidateIdMoveData>>
): UseMutationOptions<
    PostJobsIdSourcedCandidatesSourcedCandidateIdMoveResponse,
    AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdMoveError>,
    Options<PostJobsIdSourcedCandidatesSourcedCandidateIdMoveData>
> => {
    const mutationOptions: UseMutationOptions<
        PostJobsIdSourcedCandidatesSourcedCandidateIdMoveResponse,
        AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdMoveError>,
        Options<PostJobsIdSourcedCandidatesSourcedCandidateIdMoveData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobsIdSourcedCandidatesSourcedCandidateIdMove({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getJobsIdSourcedCandidatesSourcedCandidateIdNotesQueryKey = (options: Options<GetJobsIdSourcedCandidatesSourcedCandidateIdNotesData>) =>
    createQueryKey('getJobsIdSourcedCandidatesSourcedCandidateIdNotes', options, false, ['SourcedCandidate'])

/**
 * GET /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/notes — comments on a sourced person, newest first.
 *
 * Same access as the job's Applications tab.
 */
export const getJobsIdSourcedCandidatesSourcedCandidateIdNotesOptions = (options: Options<GetJobsIdSourcedCandidatesSourcedCandidateIdNotesData>) =>
    queryOptions<
        GetJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
        AxiosError<GetJobsIdSourcedCandidatesSourcedCandidateIdNotesError>,
        GetJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
        ReturnType<typeof getJobsIdSourcedCandidatesSourcedCandidateIdNotesQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getJobsIdSourcedCandidatesSourcedCandidateIdNotes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getJobsIdSourcedCandidatesSourcedCandidateIdNotesQueryKey(options),
    })

/**
 * POST /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/notes — add a comment on a sourced person.
 *
 * Signed with the session user. Once they are in Applications it shows on their application too.
 */
export const postJobsIdSourcedCandidatesSourcedCandidateIdNotesMutation = (
    options?: Partial<Options<PostJobsIdSourcedCandidatesSourcedCandidateIdNotesData>>
): UseMutationOptions<
    PostJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
    AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdNotesError>,
    Options<PostJobsIdSourcedCandidatesSourcedCandidateIdNotesData>
> => {
    const mutationOptions: UseMutationOptions<
        PostJobsIdSourcedCandidatesSourcedCandidateIdNotesResponse,
        AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdNotesError>,
        Options<PostJobsIdSourcedCandidatesSourcedCandidateIdNotesData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobsIdSourcedCandidatesSourcedCandidateIdNotes({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/invite-emails/preview — the invite email exactly as it would be sent.
 *
 * Nothing is sent.
 */
export const postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewMutation = (
    options?: Partial<Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewData>>
): UseMutationOptions<
    PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewResponse,
    AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewError>,
    Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewData>
> => {
    const mutationOptions: UseMutationOptions<
        PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewResponse,
        AxiosError<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewError>,
        Options<PostJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreviewData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postJobsIdSourcedCandidatesSourcedCandidateIdInviteEmailsPreview({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * DELETE /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/notes/[noteId] — delete a comment.
 *
 * Only comments on this person in this job; 404 otherwise.
 */
export const deleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdMutation = (
    options?: Partial<Options<DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData>>
): UseMutationOptions<
    DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
    AxiosError<DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError>,
    Options<DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData>
> => {
    const mutationOptions: UseMutationOptions<
        DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
        AxiosError<DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError>,
        Options<DeleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * PATCH /api/jobs/[id]/sourced-candidates/[sourcedCandidateId]/notes/[noteId] — edit a comment's text.
 *
 * Only comments on this person in this job; 404 otherwise.
 */
export const patchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdMutation = (
    options?: Partial<Options<PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData>>
): UseMutationOptions<
    PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
    AxiosError<PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError>,
    Options<PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData>
> => {
    const mutationOptions: UseMutationOptions<
        PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdResponse,
        AxiosError<PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdError>,
        Options<PatchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchJobsIdSourcedCandidatesSourcedCandidateIdNotesNoteId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/sourcing/extract — candidate fields from a captured profile page.
 *
 * Used by the inTalent Chrome extension. Runs one LLM extraction on the page text and returns the
 */
export const postSourcingExtractMutation = (
    options?: Partial<Options<PostSourcingExtractData>>
): UseMutationOptions<PostSourcingExtractResponse, AxiosError<PostSourcingExtractError>, Options<PostSourcingExtractData>> => {
    const mutationOptions: UseMutationOptions<PostSourcingExtractResponse, AxiosError<PostSourcingExtractError>, Options<PostSourcingExtractData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSourcingExtract({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getSourcingJobsQueryKey = (options?: Options<GetSourcingJobsData>) => createQueryKey('getSourcingJobs', options, false, ['Sourcing'])

/**
 * GET /api/sourcing/jobs — open jobs the sourcing extension can add a candidate to.
 *
 * Newest approved, visible, processed jobs in the signed-in recruiter's company, plus the company slug the
 */
export const getSourcingJobsOptions = (options?: Options<GetSourcingJobsData>) =>
    queryOptions<GetSourcingJobsResponse, AxiosError<GetSourcingJobsError>, GetSourcingJobsResponse, ReturnType<typeof getSourcingJobsQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSourcingJobs({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getSourcingJobsQueryKey(options),
    })

/**
 * POST /api/sourcing/sourced-candidates — add a person from the sourcing extension to a job's Sourced list.
 *
 * Nothing is processed: no resume, no workflow, no credits. The recruiter invites them or moves them to
 */
export const postSourcingSourcedCandidatesMutation = (
    options?: Partial<Options<PostSourcingSourcedCandidatesData>>
): UseMutationOptions<PostSourcingSourcedCandidatesResponse, AxiosError<PostSourcingSourcedCandidatesError>, Options<PostSourcingSourcedCandidatesData>> => {
    const mutationOptions: UseMutationOptions<
        PostSourcingSourcedCandidatesResponse,
        AxiosError<PostSourcingSourcedCandidatesError>,
        Options<PostSourcingSourcedCandidatesData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postSourcingSourcedCandidates({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getSseTestQueryKey = (options?: Options<GetSseTestData>) => createQueryKey('getSseTest', options, false, ['Sse-test'])

/**
 * Test API endpoint to send SSE_TEST_EVENT to all connected users
 */
export const getSseTestOptions = (options?: Options<GetSseTestData>) =>
    queryOptions<GetSseTestResponse, AxiosError<GetSseTestError>, GetSseTestResponse, ReturnType<typeof getSseTestQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSseTest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getSseTestQueryKey(options),
    })

export const getSseV2QueryKey = (options?: Options<GetSseV2Data>) => createQueryKey('getSseV2', options, false, ['Sse-v2'])

/**
 * SSE route handler for real-time notifications
 */
export const getSseV2Options = (options?: Options<GetSseV2Data>) =>
    queryOptions<unknown, AxiosError<GetSseV2Error>, unknown, ReturnType<typeof getSseV2QueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSseV2({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getSseV2QueryKey(options),
    })

export const getStorageAccessQueryKey = (options: Options<GetStorageAccessData>) => createQueryKey('getStorageAccess', options, false, ['Storage'])

/**
 * GET /api/storage/access — signed read URL for a file the signed-in user may see.
 *
 * Signed-in only. The file must be in one of our storage buckets and, when its path names a company (`{companySlug}/…`), the user must be a member of that company (SuperAdmins may read any). Public pages receive signed URLs from their own slug/token-scoped endpoints instead.
 */
export const getStorageAccessOptions = (options: Options<GetStorageAccessData>) =>
    queryOptions<GetStorageAccessResponse, AxiosError<GetStorageAccessError>, GetStorageAccessResponse, ReturnType<typeof getStorageAccessQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStorageAccess({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getStorageAccessQueryKey(options),
    })

export const getStorageUploadQueryKey = (options: Options<GetStorageUploadData>) => createQueryKey('getStorageUpload', options, false, ['Storage'])

/**
 * GET /api/storage/upload — signed upload URL for a signed-in member of the company.
 *
 * The server chooses the object (`demodocs/{companySlug}/…`); callers only pass the company, kind and file extension. Anonymous uploads (public apply page) use `/api/{companySlug}/public/career/jobs/{id}/upload-url`.
 */
export const getStorageUploadOptions = (options: Options<GetStorageUploadData>) =>
    queryOptions<GetStorageUploadResponse, AxiosError<GetStorageUploadError>, GetStorageUploadResponse, ReturnType<typeof getStorageUploadQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getStorageUpload({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getStorageUploadQueryKey(options),
    })

export const postTemporalCandidateMutation = (
    options?: Partial<Options<PostTemporalCandidateData>>
): UseMutationOptions<unknown, AxiosError<PostTemporalCandidateError>, Options<PostTemporalCandidateData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTemporalCandidateError>, Options<PostTemporalCandidateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTemporalCandidate({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalCheatDetectionConfigQueryKey = (options?: Options<GetTemporalCheatDetectionConfigData>) =>
    createQueryKey('getTemporalCheatDetectionConfig', options, false, ['Temporal'])

export const getTemporalCheatDetectionConfigOptions = (options?: Options<GetTemporalCheatDetectionConfigData>) =>
    queryOptions<unknown, AxiosError<GetTemporalCheatDetectionConfigError>, unknown, ReturnType<typeof getTemporalCheatDetectionConfigQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalCheatDetectionConfig({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalCheatDetectionConfigQueryKey(options),
    })

export const postTemporalCommunicationStatusMutation = (
    options?: Partial<Options<PostTemporalCommunicationStatusData>>
): UseMutationOptions<unknown, AxiosError<PostTemporalCommunicationStatusError>, Options<PostTemporalCommunicationStatusData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostTemporalCommunicationStatusError>, Options<PostTemporalCommunicationStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTemporalCommunicationStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalHiQuestionsQueryKey = (options?: Options<GetTemporalHiQuestionsData>) =>
    createQueryKey('getTemporalHiQuestions', options, false, ['Temporal'])

/**
 * GET /api/temporal/hi_questions?job_application_id={id}
 */
export const getTemporalHiQuestionsOptions = (options?: Options<GetTemporalHiQuestionsData>) =>
    queryOptions<
        GetTemporalHiQuestionsResponse,
        AxiosError<GetTemporalHiQuestionsError>,
        GetTemporalHiQuestionsResponse,
        ReturnType<typeof getTemporalHiQuestionsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalHiQuestions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalHiQuestionsQueryKey(options),
    })

export const getTemporalIntegrationsQueryKey = (options?: Options<GetTemporalIntegrationsData>) =>
    createQueryKey('getTemporalIntegrations', options, false, ['Temporal'])

/**
 * GET /api/temporal/integrations?companyId=123&type=whatsapp[&integrationId=…]
 */
export const getTemporalIntegrationsOptions = (options?: Options<GetTemporalIntegrationsData>) =>
    queryOptions<
        GetTemporalIntegrationsResponse,
        AxiosError<GetTemporalIntegrationsError>,
        GetTemporalIntegrationsResponse,
        ReturnType<typeof getTemporalIntegrationsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalIntegrations({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalIntegrationsQueryKey(options),
    })

export const getTemporalScreeningCallQueryKey = (options?: Options<GetTemporalScreeningCallData>) =>
    createQueryKey('getTemporalScreeningCall', options, false, ['Temporal'])

/**
 * GET /api/temporal/screening-call?id={screening_call_id}
 */
export const getTemporalScreeningCallOptions = (options?: Options<GetTemporalScreeningCallData>) =>
    queryOptions<
        GetTemporalScreeningCallResponse,
        AxiosError<GetTemporalScreeningCallError>,
        GetTemporalScreeningCallResponse,
        ReturnType<typeof getTemporalScreeningCallQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalScreeningCall({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalScreeningCallQueryKey(options),
    })

/**
 * PUT /api/temporal/screening-call
 */
export const putTemporalScreeningCallMutation = (
    options?: Partial<Options<PutTemporalScreeningCallData>>
): UseMutationOptions<PutTemporalScreeningCallResponse, AxiosError<PutTemporalScreeningCallError>, Options<PutTemporalScreeningCallData>> => {
    const mutationOptions: UseMutationOptions<
        PutTemporalScreeningCallResponse,
        AxiosError<PutTemporalScreeningCallError>,
        Options<PutTemporalScreeningCallData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTemporalScreeningCall({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalScreeningInterviewQueryKey = (options?: Options<GetTemporalScreeningInterviewData>) =>
    createQueryKey('getTemporalScreeningInterview', options, false, ['Temporal'])

/**
 * GET /api/temporal/screening-interview?id={screening_interview_id}
 */
export const getTemporalScreeningInterviewOptions = (options?: Options<GetTemporalScreeningInterviewData>) =>
    queryOptions<
        GetTemporalScreeningInterviewResponse,
        AxiosError<GetTemporalScreeningInterviewError>,
        GetTemporalScreeningInterviewResponse,
        ReturnType<typeof getTemporalScreeningInterviewQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalScreeningInterview({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalScreeningInterviewQueryKey(options),
    })

/**
 * POST /api/temporal/workshorts
 */
export const postTemporalWorkshortsMutation = (
    options?: Partial<Options<PostTemporalWorkshortsData>>
): UseMutationOptions<PostTemporalWorkshortsResponse, AxiosError<PostTemporalWorkshortsError>, Options<PostTemporalWorkshortsData>> => {
    const mutationOptions: UseMutationOptions<PostTemporalWorkshortsResponse, AxiosError<PostTemporalWorkshortsError>, Options<PostTemporalWorkshortsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTemporalWorkshorts({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalInterviewQualityCheckQueryKey = (options: Options<GetTemporalInterviewQualityCheckData>) =>
    createQueryKey('getTemporalInterviewQualityCheck', options, false, ['Temporal'])

/**
 * GET /api/temporal/interview-quality/check — talent-ai asks whether to analyze a scored screening.
 *
 * M2M (Bearer). Resolves the web screening (`screeningInterviewId`) or phone call (`screeningCallId`) to its interview and company, and reads the company's `INTERVIEW_QUALITY_ANALYSIS_ENABLED` flag (defaults ← plan ← company override). An unknown screening returns `enabled: false` with null ids.
 */
export const getTemporalInterviewQualityCheckOptions = (options: Options<GetTemporalInterviewQualityCheckData>) =>
    queryOptions<
        GetTemporalInterviewQualityCheckResponse,
        AxiosError<GetTemporalInterviewQualityCheckError>,
        GetTemporalInterviewQualityCheckResponse,
        ReturnType<typeof getTemporalInterviewQualityCheckQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalInterviewQualityCheck({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalInterviewQualityCheckQueryKey(options),
    })

export const getTemporalInterviewQualityContextQueryKey = (options: Options<GetTemporalInterviewQualityContextData>) =>
    createQueryKey('getTemporalInterviewQualityContext', options, false, ['Temporal'])

/**
 * GET /api/temporal/interview-quality/context — talent-ai loads what it needs to analyze an interview.
 *
 * M2M (Bearer). Candidate / company / job, questions, screening config, artifact URLs and the channel's raw event logs. 404 when the interview has no AI screening (on the requested channel).
 */
export const getTemporalInterviewQualityContextOptions = (options: Options<GetTemporalInterviewQualityContextData>) =>
    queryOptions<
        GetTemporalInterviewQualityContextResponse,
        AxiosError<GetTemporalInterviewQualityContextError>,
        GetTemporalInterviewQualityContextResponse,
        ReturnType<typeof getTemporalInterviewQualityContextQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalInterviewQualityContext({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalInterviewQualityContextQueryKey(options),
    })

/**
 * POST /api/temporal/interview-quality/report — talent-ai stores the result of an interview quality analysis.
 *
 * M2M (Bearer). Idempotent on `workflowId`. A report (with its issues) is created only when `report.issues` is non-empty. With `runId`, the manual run is finished: COMPLETED_WITH_ISSUES / COMPLETED_NO_ISSUES / FAILED, plus reportId, error and completedAt.
 */
export const postTemporalInterviewQualityReportMutation = (
    options?: Partial<Options<PostTemporalInterviewQualityReportData>>
): UseMutationOptions<
    PostTemporalInterviewQualityReportResponse,
    AxiosError<PostTemporalInterviewQualityReportError>,
    Options<PostTemporalInterviewQualityReportData>
> => {
    const mutationOptions: UseMutationOptions<
        PostTemporalInterviewQualityReportResponse,
        AxiosError<PostTemporalInterviewQualityReportError>,
        Options<PostTemporalInterviewQualityReportData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTemporalInterviewQualityReport({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalJobApplicationsIdQueryKey = (options: Options<GetTemporalJobApplicationsIdData>) =>
    createQueryKey('getTemporalJobApplicationsId', options, false, ['Temporal'])

export const getTemporalJobApplicationsIdOptions = (options: Options<GetTemporalJobApplicationsIdData>) =>
    queryOptions<
        GetTemporalJobApplicationsIdResponse,
        AxiosError<GetTemporalJobApplicationsIdError>,
        GetTemporalJobApplicationsIdResponse,
        ReturnType<typeof getTemporalJobApplicationsIdQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalJobApplicationsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalJobApplicationsIdQueryKey(options),
    })

export const putTemporalJobApplicationsIdMutation = (
    options?: Partial<Options<PutTemporalJobApplicationsIdData>>
): UseMutationOptions<PutTemporalJobApplicationsIdResponse, AxiosError<PutTemporalJobApplicationsIdError>, Options<PutTemporalJobApplicationsIdData>> => {
    const mutationOptions: UseMutationOptions<
        PutTemporalJobApplicationsIdResponse,
        AxiosError<PutTemporalJobApplicationsIdError>,
        Options<PutTemporalJobApplicationsIdData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await putTemporalJobApplicationsId({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalJobApplicationsStatusQueryKey = (options?: Options<GetTemporalJobApplicationsStatusData>) =>
    createQueryKey('getTemporalJobApplicationsStatus', options, false, ['Temporal'])

export const getTemporalJobApplicationsStatusOptions = (options?: Options<GetTemporalJobApplicationsStatusData>) =>
    queryOptions<
        GetTemporalJobApplicationsStatusResponse,
        AxiosError<GetTemporalJobApplicationsStatusError>,
        GetTemporalJobApplicationsStatusResponse,
        ReturnType<typeof getTemporalJobApplicationsStatusQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalJobApplicationsStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalJobApplicationsStatusQueryKey(options),
    })

export const getTemporalJobsIdQueryKey = (options: Options<GetTemporalJobsIdData>) => createQueryKey('getTemporalJobsId', options, false, ['Temporal'])

export const getTemporalJobsIdOptions = (options: Options<GetTemporalJobsIdData>) =>
    queryOptions<GetTemporalJobsIdResponse, AxiosError<GetTemporalJobsIdError>, GetTemporalJobsIdResponse, ReturnType<typeof getTemporalJobsIdQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalJobsId({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalJobsIdQueryKey(options),
    })

/**
 * POST /api/temporal/screening-call/objective-evaluations — talent-ai stores its verdicts on a phone screening's objective questions.
 *
 * M2M (Bearer). Replaces `ScreeningCall.objectiveEvaluations` (idempotent, latest wins). A phone attempt id (`attempt-{callId}-{n}-…`) that is not the call's current attempt returns 200 with `ignored: true`; any other id (e.g. a scoring workflow id) is stored. 404 when the call doesn't exist.
 */
export const postTemporalScreeningCallObjectiveEvaluationsMutation = (
    options?: Partial<Options<PostTemporalScreeningCallObjectiveEvaluationsData>>
): UseMutationOptions<
    PostTemporalScreeningCallObjectiveEvaluationsResponse,
    AxiosError<PostTemporalScreeningCallObjectiveEvaluationsError>,
    Options<PostTemporalScreeningCallObjectiveEvaluationsData>
> => {
    const mutationOptions: UseMutationOptions<
        PostTemporalScreeningCallObjectiveEvaluationsResponse,
        AxiosError<PostTemporalScreeningCallObjectiveEvaluationsError>,
        Options<PostTemporalScreeningCallObjectiveEvaluationsData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTemporalScreeningCallObjectiveEvaluations({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getTemporalCompaniesIdAgentMemoryFlagsQueryKey = (options: Options<GetTemporalCompaniesIdAgentMemoryFlagsData>) =>
    createQueryKey('getTemporalCompaniesIdAgentMemoryFlags', options, false, ['Temporal'])

/**
 * GET /api/temporal/companies/[id]/agent-memory-flags — talent-ai reads a company's agent memory flags.
 *
 * M2M (Bearer). The company's effective flags (defaults ← plan ← company override). 404 for an unknown company; talent-ai treats any error as all off.
 */
export const getTemporalCompaniesIdAgentMemoryFlagsOptions = (options: Options<GetTemporalCompaniesIdAgentMemoryFlagsData>) =>
    queryOptions<
        GetTemporalCompaniesIdAgentMemoryFlagsResponse,
        AxiosError<GetTemporalCompaniesIdAgentMemoryFlagsError>,
        GetTemporalCompaniesIdAgentMemoryFlagsResponse,
        ReturnType<typeof getTemporalCompaniesIdAgentMemoryFlagsQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getTemporalCompaniesIdAgentMemoryFlags({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getTemporalCompaniesIdAgentMemoryFlagsQueryKey(options),
    })

/**
 * POST /api/temporal/interview-quality/runs/[runId]/status — talent-ai marks a manual run as running.
 *
 * M2M (Bearer). Called at workflow start for MANUAL triggers. Moves PENDING / RUNNING runs to RUNNING (and stores workflowId); a finished run is left as it is. 404 for an unknown run.
 */
export const postTemporalInterviewQualityRunsRunIdStatusMutation = (
    options?: Partial<Options<PostTemporalInterviewQualityRunsRunIdStatusData>>
): UseMutationOptions<
    PostTemporalInterviewQualityRunsRunIdStatusResponse,
    AxiosError<PostTemporalInterviewQualityRunsRunIdStatusError>,
    Options<PostTemporalInterviewQualityRunsRunIdStatusData>
> => {
    const mutationOptions: UseMutationOptions<
        PostTemporalInterviewQualityRunsRunIdStatusResponse,
        AxiosError<PostTemporalInterviewQualityRunsRunIdStatusError>,
        Options<PostTemporalInterviewQualityRunsRunIdStatusData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postTemporalInterviewQualityRunsRunIdStatus({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getUserDataQueryKey = (options?: Options<GetUserDataData>) => createQueryKey('getUserData', options, false, ['User-data'])

/**
 * GET API for fetching user data and initializing user-department relationships
 */
export const getUserDataOptions = (options?: Options<GetUserDataData>) =>
    queryOptions<unknown, AxiosError<GetUserDataError>, unknown, ReturnType<typeof getUserDataQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getUserData({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getUserDataQueryKey(options),
    })

export const getWebhooksAzureEmailQueryKey = (options?: Options<GetWebhooksAzureEmailData>) =>
    createQueryKey('getWebhooksAzureEmail', options, false, ['Webhooks'])

/**
 * Handles Azure Event Grid validation requests
 */
export const getWebhooksAzureEmailOptions = (options?: Options<GetWebhooksAzureEmailData>) =>
    queryOptions<unknown, AxiosError<GetWebhooksAzureEmailError>, unknown, ReturnType<typeof getWebhooksAzureEmailQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWebhooksAzureEmail({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWebhooksAzureEmailQueryKey(options),
    })

/**
 * Handles Azure Communication Services email delivery events
 */
export const postWebhooksAzureEmailMutation = (
    options?: Partial<Options<PostWebhooksAzureEmailData>>
): UseMutationOptions<unknown, AxiosError<PostWebhooksAzureEmailError>, Options<PostWebhooksAzureEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWebhooksAzureEmailError>, Options<PostWebhooksAzureEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksAzureEmail({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Handles webhook events from Daily.co
 */
export const postWebhooksDailyMutation = (
    options?: Partial<Options<PostWebhooksDailyData>>
): UseMutationOptions<unknown, AxiosError<PostWebhooksDailyError>, Options<PostWebhooksDailyData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWebhooksDailyError>, Options<PostWebhooksDailyData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksDaily({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWebhooksGraphQueryKey = (options?: Options<GetWebhooksGraphData>) => createQueryKey('getWebhooksGraph', options, false, ['Webhooks'])

/**
 * Microsoft Graph validation can come as GET with ?validationToken=...
 */
export const getWebhooksGraphOptions = (options?: Options<GetWebhooksGraphData>) =>
    queryOptions<GetWebhooksGraphResponse, AxiosError<GetWebhooksGraphError>, GetWebhooksGraphResponse, ReturnType<typeof getWebhooksGraphQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWebhooksGraph({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWebhooksGraphQueryKey(options),
    })

export const postWebhooksGraphMutation = (
    options?: Partial<Options<PostWebhooksGraphData>>
): UseMutationOptions<PostWebhooksGraphResponse, AxiosError<PostWebhooksGraphError>, Options<PostWebhooksGraphData>> => {
    const mutationOptions: UseMutationOptions<PostWebhooksGraphResponse, AxiosError<PostWebhooksGraphError>, Options<PostWebhooksGraphData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksGraph({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWebhooksPlivoWhatsappQueryKey = (options?: Options<GetWebhooksPlivoWhatsappData>) =>
    createQueryKey('getWebhooksPlivoWhatsapp', options, false, ['Webhooks'])

export const getWebhooksPlivoWhatsappOptions = (options?: Options<GetWebhooksPlivoWhatsappData>) =>
    queryOptions<unknown, AxiosError<GetWebhooksPlivoWhatsappError>, unknown, ReturnType<typeof getWebhooksPlivoWhatsappQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWebhooksPlivoWhatsapp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWebhooksPlivoWhatsappQueryKey(options),
    })

/**
 * POST /api/webhooks/plivo-whatsapp
 */
export const postWebhooksPlivoWhatsappMutation = (
    options?: Partial<Options<PostWebhooksPlivoWhatsappData>>
): UseMutationOptions<unknown, AxiosError<PostWebhooksPlivoWhatsappError>, Options<PostWebhooksPlivoWhatsappData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWebhooksPlivoWhatsappError>, Options<PostWebhooksPlivoWhatsappData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksPlivoWhatsapp({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * Handles Resend email delivery events
 */
export const postWebhooksResendEmailMutation = (
    options?: Partial<Options<PostWebhooksResendEmailData>>
): UseMutationOptions<unknown, AxiosError<PostWebhooksResendEmailError>, Options<PostWebhooksResendEmailData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWebhooksResendEmailError>, Options<PostWebhooksResendEmailData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksResendEmail({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/webhooks/stripe
 */
export const postWebhooksStripeMutation = (
    options?: Partial<Options<PostWebhooksStripeData>>
): UseMutationOptions<PostWebhooksStripeResponse, AxiosError<PostWebhooksStripeError>, Options<PostWebhooksStripeData>> => {
    const mutationOptions: UseMutationOptions<PostWebhooksStripeResponse, AxiosError<PostWebhooksStripeError>, Options<PostWebhooksStripeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksStripe({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWebhooksTwilioWhatsappQueryKey = (options?: Options<GetWebhooksTwilioWhatsappData>) =>
    createQueryKey('getWebhooksTwilioWhatsapp', options, false, ['Webhooks'])

export const getWebhooksTwilioWhatsappOptions = (options?: Options<GetWebhooksTwilioWhatsappData>) =>
    queryOptions<unknown, AxiosError<GetWebhooksTwilioWhatsappError>, unknown, ReturnType<typeof getWebhooksTwilioWhatsappQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWebhooksTwilioWhatsapp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWebhooksTwilioWhatsappQueryKey(options),
    })

export const postWebhooksTwilioWhatsappMutation = (
    options?: Partial<Options<PostWebhooksTwilioWhatsappData>>
): UseMutationOptions<unknown, AxiosError<PostWebhooksTwilioWhatsappError>, Options<PostWebhooksTwilioWhatsappData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWebhooksTwilioWhatsappError>, Options<PostWebhooksTwilioWhatsappData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksTwilioWhatsapp({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWebhooksGraphTranscriptQueryKey = (options?: Options<GetWebhooksGraphTranscriptData>) =>
    createQueryKey('getWebhooksGraphTranscript', options, false, ['Webhooks'])

/**
 * Microsoft Graph validation can come as GET with ?validationToken=...
 */
export const getWebhooksGraphTranscriptOptions = (options?: Options<GetWebhooksGraphTranscriptData>) =>
    queryOptions<
        GetWebhooksGraphTranscriptResponse,
        AxiosError<GetWebhooksGraphTranscriptError>,
        GetWebhooksGraphTranscriptResponse,
        ReturnType<typeof getWebhooksGraphTranscriptQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWebhooksGraphTranscript({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWebhooksGraphTranscriptQueryKey(options),
    })

export const postWebhooksGraphTranscriptMutation = (
    options?: Partial<Options<PostWebhooksGraphTranscriptData>>
): UseMutationOptions<PostWebhooksGraphTranscriptResponse, AxiosError<PostWebhooksGraphTranscriptError>, Options<PostWebhooksGraphTranscriptData>> => {
    const mutationOptions: UseMutationOptions<
        PostWebhooksGraphTranscriptResponse,
        AxiosError<PostWebhooksGraphTranscriptError>,
        Options<PostWebhooksGraphTranscriptData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksGraphTranscript({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/webhooks/plivo/recording
 */
export const postWebhooksPlivoRecordingMutation = (
    options?: Partial<Options<PostWebhooksPlivoRecordingData>>
): UseMutationOptions<PostWebhooksPlivoRecordingResponse, AxiosError<PostWebhooksPlivoRecordingError>, Options<PostWebhooksPlivoRecordingData>> => {
    const mutationOptions: UseMutationOptions<
        PostWebhooksPlivoRecordingResponse,
        AxiosError<PostWebhooksPlivoRecordingError>,
        Options<PostWebhooksPlivoRecordingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksPlivoRecording({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWebhooksPlivoVoiceQueryKey = (options?: Options<GetWebhooksPlivoVoiceData>) =>
    createQueryKey('getWebhooksPlivoVoice', options, false, ['Webhooks'])

/**
 * GET /api/webhooks/plivo/voice — liveness check for the Plivo voice webhook.
 */
export const getWebhooksPlivoVoiceOptions = (options?: Options<GetWebhooksPlivoVoiceData>) =>
    queryOptions<
        GetWebhooksPlivoVoiceResponse,
        AxiosError<GetWebhooksPlivoVoiceError>,
        GetWebhooksPlivoVoiceResponse,
        ReturnType<typeof getWebhooksPlivoVoiceQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWebhooksPlivoVoice({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWebhooksPlivoVoiceQueryKey(options),
    })

/**
 * POST /api/webhooks/plivo/voice
 */
export const postWebhooksPlivoVoiceMutation = (
    options?: Partial<Options<PostWebhooksPlivoVoiceData>>
): UseMutationOptions<PostWebhooksPlivoVoiceResponse, AxiosError<PostWebhooksPlivoVoiceError>, Options<PostWebhooksPlivoVoiceData>> => {
    const mutationOptions: UseMutationOptions<PostWebhooksPlivoVoiceResponse, AxiosError<PostWebhooksPlivoVoiceError>, Options<PostWebhooksPlivoVoiceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksPlivoVoice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/webhooks/twilio/recording
 */
export const postWebhooksTwilioRecordingMutation = (
    options?: Partial<Options<PostWebhooksTwilioRecordingData>>
): UseMutationOptions<PostWebhooksTwilioRecordingResponse, AxiosError<PostWebhooksTwilioRecordingError>, Options<PostWebhooksTwilioRecordingData>> => {
    const mutationOptions: UseMutationOptions<
        PostWebhooksTwilioRecordingResponse,
        AxiosError<PostWebhooksTwilioRecordingError>,
        Options<PostWebhooksTwilioRecordingData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksTwilioRecording({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

/**
 * POST /api/webhooks/twilio/voice
 */
export const postWebhooksTwilioVoiceMutation = (
    options?: Partial<Options<PostWebhooksTwilioVoiceData>>
): UseMutationOptions<PostWebhooksTwilioVoiceResponse, AxiosError<PostWebhooksTwilioVoiceError>, Options<PostWebhooksTwilioVoiceData>> => {
    const mutationOptions: UseMutationOptions<
        PostWebhooksTwilioVoiceResponse,
        AxiosError<PostWebhooksTwilioVoiceError>,
        Options<PostWebhooksTwilioVoiceData>
    > = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWebhooksTwilioVoice({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWellKnownScreeningJwksQueryKey = (options?: Options<GetWellKnownScreeningJwksData>) =>
    createQueryKey('getWellKnownScreeningJwks', options, false, ['Well-known'])

/**
 * Aggregated screening JWKS — public keys for Talent Web and Talent AI
 */
export const getWellKnownScreeningJwksOptions = (options?: Options<GetWellKnownScreeningJwksData>) =>
    queryOptions<
        GetWellKnownScreeningJwksResponse,
        AxiosError<GetWellKnownScreeningJwksError>,
        GetWellKnownScreeningJwksResponse,
        ReturnType<typeof getWellKnownScreeningJwksQueryKey>
    >({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWellKnownScreeningJwks({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWellKnownScreeningJwksQueryKey(options),
    })

export const getWhatsappQueryKey = (options?: Options<GetWhatsappData>) => createQueryKey('getWhatsapp', options, false, ['Whatsapp'])

/**
 * GET call which is initiated by a recruiter to send a job to an applicant. This creates the initial whatsapphistory record.
 */
export const getWhatsappOptions = (options?: Options<GetWhatsappData>) =>
    queryOptions<unknown, AxiosError<GetWhatsappError>, unknown, ReturnType<typeof getWhatsappQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWhatsapp({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWhatsappQueryKey(options),
    })

/**
 * POST call typically triggered by the user replying to the whatsapp message. This will go through a workflow and create an application if applicable.
 */
export const postWhatsappMutation = (
    options?: Partial<Options<PostWhatsappData>>
): UseMutationOptions<unknown, AxiosError<PostWhatsappError>, Options<PostWhatsappData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWhatsappError>, Options<PostWhatsappData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWhatsapp({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}

export const getWhatsappCompanySlugQueryKey = (options: Options<GetWhatsappCompanySlugData>) =>
    createQueryKey('getWhatsappCompanySlug', options, false, ['Whatsapp'])

/**
 * GET call which is initiated by a recruiter to send a job to an applicant. This creates the initial whatsapphistory record.
 */
export const getWhatsappCompanySlugOptions = (options: Options<GetWhatsappCompanySlugData>) =>
    queryOptions<unknown, AxiosError<GetWhatsappCompanySlugError>, unknown, ReturnType<typeof getWhatsappCompanySlugQueryKey>>({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getWhatsappCompanySlug({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            })
            return data
        },
        queryKey: getWhatsappCompanySlugQueryKey(options),
    })

/**
 * POST call typically triggered by the user replying to the whatsapp message. This will go through a workflow and create an application if applicable.
 */
export const postWhatsappCompanySlugMutation = (
    options?: Partial<Options<PostWhatsappCompanySlugData>>
): UseMutationOptions<unknown, AxiosError<PostWhatsappCompanySlugError>, Options<PostWhatsappCompanySlugData>> => {
    const mutationOptions: UseMutationOptions<unknown, AxiosError<PostWhatsappCompanySlugError>, Options<PostWhatsappCompanySlugData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postWhatsappCompanySlug({
                ...options,
                ...fnOptions,
                throwOnError: true,
            })
            return data
        },
    }
    return mutationOptions
}
